"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
        }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];return o(n || r);
        }, p, p.exports, r, e, n, t);
      }return n[i].exports;
    }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
      o(t[i]);
    }return o;
  }return r;
})()({ 1: [function (require, module, exports) {
    module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
  }, { "core-js/library/fn/json/stringify": 7 }], 2: [function (require, module, exports) {
    module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
  }, { "core-js/library/fn/promise": 8 }], 3: [function (require, module, exports) {
    /**
     * Created by Kingsley on 2017-05-20.
     */
    module.exports = function (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var value = obj[key];
          if (Object.prototype.toString.call(value) === '[object Object]') {
            var real_value = value.value;
            if (!value.clearable) {
              obj[key] = real_value;
              continue;
            }
            obj[key] = value = real_value;
          }
          if (value === undefined || value === '' || value === null || value instanceof Array && value.length === 0) {
            delete obj[key];
          }
        }
      }
    };
  }, {}], 4: [function (require, module, exports) {
    /**
     * Created by Kingsley on 2017-05-19.
     */
    /**
     * 时间戳转格式化的时间字符串
     * 使用方法等同smarty时间戳转换函数
     * @param {String|Date} ts 时间戳 timestamp
     * @param {String} fmt 转换的格式 关键字：{%Y: 年, %m: 月, %d: 日, %H: 时, %M: 分, %S: 秒} 例：'%Y-%m-%d %H:%M:%S' => '2017-05-19 11:11:11'
     * @param {Boolean} is_standard 是否格式化成标准格式的时间 is_standard ? '02' : '2'
     * @returns {String} 格式化后的时间字符串
     */
    module.exports = function (ts, fmt) {
      var is_standard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var datetime = new Date(ts);
      if (!ts) {
        throw new Error("The timestamp value '" + ts + "' is invalid.");
      }
      return fmt.replace(/%[YmdHMS]/g, function (match) {
        switch (match) {
          case '%Y':
            return datetime.getFullYear();
          case '%m':
            match = datetime.getMonth() + 1;
            break;
          case '%d':
            match = datetime.getDate();
            break;
          case '%H':
            match = datetime.getHours();
            break;
          case '%M':
            match = datetime.getMinutes();
            break;
          case '%S':
            match = datetime.getSeconds();
            break;
          default:
            return match;
        }
        return ("" + (is_standard ? '0' : '') + match).slice(-2);
      });
    };
  }, {}], 5: [function (require, module, exports) {
    var originJsonp = require('jsonp');

    var jsonp = function jsonp(url, data, option) {
      url += (url.indexOf('?') < 0 ? '?' : '&') + param(data);

      return new Promise(function (resolve, reject) {
        originJsonp(url, option, function (err, data) {
          if (!err) {
            resolve(data);
          } else {
            reject(err);
          }
        });
      });
    };

    function param(data) {
      var url = '';
      for (var k in data) {
        var value = data[k] !== undefined ? data[k] : '';
        url += '&' + k + '=' + encodeURIComponent(value);
      }
      return url ? url.substring(1) : '';
    }

    module.exports = jsonp;
  }, { "jsonp": 80 }], 6: [function (require, module, exports) {
    module.exports = function (name) {
      var SEARCH = window.location.search;
      var reg = new RegExp("(\\?|&)" + name + "(\\[\\])?=([^&]*)");
      var value = SEARCH.match(reg);

      return value ? value[3] : '';
    };
  }, {}], 7: [function (require, module, exports) {
    var core = require('../../modules/_core');
    var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
    module.exports = function stringify(it) {
      // eslint-disable-line no-unused-vars
      return $JSON.stringify.apply($JSON, arguments);
    };
  }, { "../../modules/_core": 16 }], 8: [function (require, module, exports) {
    require('../modules/es6.object.to-string');
    require('../modules/es6.string.iterator');
    require('../modules/web.dom.iterable');
    require('../modules/es6.promise');
    require('../modules/es7.promise.finally');
    require('../modules/es7.promise.try');
    module.exports = require('../modules/_core').Promise;
  }, { "../modules/_core": 16, "../modules/es6.object.to-string": 72, "../modules/es6.promise": 73, "../modules/es6.string.iterator": 74, "../modules/es7.promise.finally": 75, "../modules/es7.promise.try": 76, "../modules/web.dom.iterable": 77 }], 9: [function (require, module, exports) {
    module.exports = function (it) {
      if (typeof it != 'function') throw TypeError(it + ' is not a function!');
      return it;
    };
  }, {}], 10: [function (require, module, exports) {
    module.exports = function () {/* empty */};
  }, {}], 11: [function (require, module, exports) {
    module.exports = function (it, Constructor, name, forbiddenField) {
      if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
        throw TypeError(name + ': incorrect invocation!');
      }return it;
    };
  }, {}], 12: [function (require, module, exports) {
    var isObject = require('./_is-object');
    module.exports = function (it) {
      if (!isObject(it)) throw TypeError(it + ' is not an object!');
      return it;
    };
  }, { "./_is-object": 33 }], 13: [function (require, module, exports) {
    // false -> Array#indexOf
    // true  -> Array#includes
    var toIObject = require('./_to-iobject');
    var toLength = require('./_to-length');
    var toAbsoluteIndex = require('./_to-absolute-index');
    module.exports = function (IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while (length > index) {
          value = O[index++];
          // eslint-disable-next-line no-self-compare
          if (value != value) return true;
          // Array#indexOf ignores holes, Array#includes - not
        } else for (; length > index; index++) {
          if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
          }
        }return !IS_INCLUDES && -1;
      };
    };
  }, { "./_to-absolute-index": 61, "./_to-iobject": 63, "./_to-length": 64 }], 14: [function (require, module, exports) {
    // getting tag from 19.1.3.6 Object.prototype.toString()
    var cof = require('./_cof');
    var TAG = require('./_wks')('toStringTag');
    // ES3 wrong here
    var ARG = cof(function () {
      return arguments;
    }()) == 'Arguments';

    // fallback for IE11 Script Access Denied error
    var tryGet = function tryGet(it, key) {
      try {
        return it[key];
      } catch (e) {/* empty */}
    };

    module.exports = function (it) {
      var O, T, B;
      return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
      // builtinTag case
      : ARG ? cof(O)
      // ES3 arguments fallback
      : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
    };
  }, { "./_cof": 15, "./_wks": 69 }], 15: [function (require, module, exports) {
    var toString = {}.toString;

    module.exports = function (it) {
      return toString.call(it).slice(8, -1);
    };
  }, {}], 16: [function (require, module, exports) {
    var core = module.exports = { version: '2.5.7' };
    if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
  }, {}], 17: [function (require, module, exports) {
    // optional / simple context binding
    var aFunction = require('./_a-function');
    module.exports = function (fn, that, length) {
      aFunction(fn);
      if (that === undefined) return fn;
      switch (length) {
        case 1:
          return function (a) {
            return fn.call(that, a);
          };
        case 2:
          return function (a, b) {
            return fn.call(that, a, b);
          };
        case 3:
          return function (a, b, c) {
            return fn.call(that, a, b, c);
          };
      }
      return function () /* ...args */{
        return fn.apply(that, arguments);
      };
    };
  }, { "./_a-function": 9 }], 18: [function (require, module, exports) {
    // 7.2.1 RequireObjectCoercible(argument)
    module.exports = function (it) {
      if (it == undefined) throw TypeError("Can't call method on  " + it);
      return it;
    };
  }, {}], 19: [function (require, module, exports) {
    // Thank's IE8 for his funny defineProperty
    module.exports = !require('./_fails')(function () {
      return Object.defineProperty({}, 'a', { get: function get() {
          return 7;
        } }).a != 7;
    });
  }, { "./_fails": 23 }], 20: [function (require, module, exports) {
    var isObject = require('./_is-object');
    var document = require('./_global').document;
    // typeof document.createElement is 'object' in old IE
    var is = isObject(document) && isObject(document.createElement);
    module.exports = function (it) {
      return is ? document.createElement(it) : {};
    };
  }, { "./_global": 25, "./_is-object": 33 }], 21: [function (require, module, exports) {
    // IE 8- don't enum bug keys
    module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
  }, {}], 22: [function (require, module, exports) {
    var global = require('./_global');
    var core = require('./_core');
    var ctx = require('./_ctx');
    var hide = require('./_hide');
    var has = require('./_has');
    var PROTOTYPE = 'prototype';

    var $export = function $export(type, name, source) {
      var IS_FORCED = type & $export.F;
      var IS_GLOBAL = type & $export.G;
      var IS_STATIC = type & $export.S;
      var IS_PROTO = type & $export.P;
      var IS_BIND = type & $export.B;
      var IS_WRAP = type & $export.W;
      var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
      var expProto = exports[PROTOTYPE];
      var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
      var key, own, out;
      if (IS_GLOBAL) source = name;
      for (key in source) {
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && has(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
        // bind timers to global for call from export context
        : IS_BIND && own ? ctx(out, global)
        // wrap global constructors for prevent change them in library
        : IS_WRAP && target[key] == out ? function (C) {
          var F = function F(a, b, c) {
            if (this instanceof C) {
              switch (arguments.length) {
                case 0:
                  return new C();
                case 1:
                  return new C(a);
                case 2:
                  return new C(a, b);
              }return new C(a, b, c);
            }return C.apply(this, arguments);
          };
          F[PROTOTYPE] = C[PROTOTYPE];
          return F;
          // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
          (exports.virtual || (exports.virtual = {}))[key] = out;
          // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
          if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
        }
      }
    };
    // type bitmap
    $export.F = 1; // forced
    $export.G = 2; // global
    $export.S = 4; // static
    $export.P = 8; // proto
    $export.B = 16; // bind
    $export.W = 32; // wrap
    $export.U = 64; // safe
    $export.R = 128; // real proto method for `library`
    module.exports = $export;
  }, { "./_core": 16, "./_ctx": 17, "./_global": 25, "./_has": 26, "./_hide": 27 }], 23: [function (require, module, exports) {
    module.exports = function (exec) {
      try {
        return !!exec();
      } catch (e) {
        return true;
      }
    };
  }, {}], 24: [function (require, module, exports) {
    var ctx = require('./_ctx');
    var call = require('./_iter-call');
    var isArrayIter = require('./_is-array-iter');
    var anObject = require('./_an-object');
    var toLength = require('./_to-length');
    var getIterFn = require('./core.get-iterator-method');
    var BREAK = {};
    var RETURN = {};
    var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
      var iterFn = ITERATOR ? function () {
        return iterable;
      } : getIterFn(iterable);
      var f = ctx(fn, that, entries ? 2 : 1);
      var index = 0;
      var length, step, iterator, result;
      if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
      // fast case for arrays with default iterator
      if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
        result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === BREAK || result === RETURN) return result;
      } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
        result = call(iterator, f, step.value, entries);
        if (result === BREAK || result === RETURN) return result;
      }
    };
    exports.BREAK = BREAK;
    exports.RETURN = RETURN;
  }, { "./_an-object": 12, "./_ctx": 17, "./_is-array-iter": 32, "./_iter-call": 34, "./_to-length": 64, "./core.get-iterator-method": 70 }], 25: [function (require, module, exports) {
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
    if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
  }, {}], 26: [function (require, module, exports) {
    var hasOwnProperty = {}.hasOwnProperty;
    module.exports = function (it, key) {
      return hasOwnProperty.call(it, key);
    };
  }, {}], 27: [function (require, module, exports) {
    var dP = require('./_object-dp');
    var createDesc = require('./_property-desc');
    module.exports = require('./_descriptors') ? function (object, key, value) {
      return dP.f(object, key, createDesc(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };
  }, { "./_descriptors": 19, "./_object-dp": 44, "./_property-desc": 51 }], 28: [function (require, module, exports) {
    var document = require('./_global').document;
    module.exports = document && document.documentElement;
  }, { "./_global": 25 }], 29: [function (require, module, exports) {
    module.exports = !require('./_descriptors') && !require('./_fails')(function () {
      return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function get() {
          return 7;
        } }).a != 7;
    });
  }, { "./_descriptors": 19, "./_dom-create": 20, "./_fails": 23 }], 30: [function (require, module, exports) {
    // fast apply, http://jsperf.lnkit.com/fast-apply/5
    module.exports = function (fn, args, that) {
      var un = that === undefined;
      switch (args.length) {
        case 0:
          return un ? fn() : fn.call(that);
        case 1:
          return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
          return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
          return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
          return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
      }return fn.apply(that, args);
    };
  }, {}], 31: [function (require, module, exports) {
    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var cof = require('./_cof');
    // eslint-disable-next-line no-prototype-builtins
    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
      return cof(it) == 'String' ? it.split('') : Object(it);
    };
  }, { "./_cof": 15 }], 32: [function (require, module, exports) {
    // check on default Array iterator
    var Iterators = require('./_iterators');
    var ITERATOR = require('./_wks')('iterator');
    var ArrayProto = Array.prototype;

    module.exports = function (it) {
      return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
    };
  }, { "./_iterators": 39, "./_wks": 69 }], 33: [function (require, module, exports) {
    module.exports = function (it) {
      return (typeof it === "undefined" ? "undefined" : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
    };
  }, {}], 34: [function (require, module, exports) {
    // call something on iterator step with safe closing on error
    var anObject = require('./_an-object');
    module.exports = function (iterator, fn, value, entries) {
      try {
        return entries ? fn(anObject(value)[0], value[1]) : fn(value);
        // 7.4.6 IteratorClose(iterator, completion)
      } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) anObject(ret.call(iterator));
        throw e;
      }
    };
  }, { "./_an-object": 12 }], 35: [function (require, module, exports) {
    'use strict';

    var create = require('./_object-create');
    var descriptor = require('./_property-desc');
    var setToStringTag = require('./_set-to-string-tag');
    var IteratorPrototype = {};

    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
    require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () {
      return this;
    });

    module.exports = function (Constructor, NAME, next) {
      Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
      setToStringTag(Constructor, NAME + ' Iterator');
    };
  }, { "./_hide": 27, "./_object-create": 43, "./_property-desc": 51, "./_set-to-string-tag": 55, "./_wks": 69 }], 36: [function (require, module, exports) {
    'use strict';

    var LIBRARY = require('./_library');
    var $export = require('./_export');
    var redefine = require('./_redefine');
    var hide = require('./_hide');
    var Iterators = require('./_iterators');
    var $iterCreate = require('./_iter-create');
    var setToStringTag = require('./_set-to-string-tag');
    var getPrototypeOf = require('./_object-gpo');
    var ITERATOR = require('./_wks')('iterator');
    var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
    var FF_ITERATOR = '@@iterator';
    var KEYS = 'keys';
    var VALUES = 'values';

    var returnThis = function returnThis() {
      return this;
    };

    module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
      $iterCreate(Constructor, NAME, next);
      var getMethod = function getMethod(kind) {
        if (!BUGGY && kind in proto) return proto[kind];
        switch (kind) {
          case KEYS:
            return function keys() {
              return new Constructor(this, kind);
            };
          case VALUES:
            return function values() {
              return new Constructor(this, kind);
            };
        }return function entries() {
          return new Constructor(this, kind);
        };
      };
      var TAG = NAME + ' Iterator';
      var DEF_VALUES = DEFAULT == VALUES;
      var VALUES_BUG = false;
      var proto = Base.prototype;
      var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
      var $default = $native || getMethod(DEFAULT);
      var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
      var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
      var methods, key, IteratorPrototype;
      // Fix native
      if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
          // Set @@toStringTag to native iterators
          setToStringTag(IteratorPrototype, TAG, true);
          // fix for some old engines
          if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
        }
      }
      // fix Array#{values, @@iterator}.name in V8 / FF
      if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() {
          return $native.call(this);
        };
      }
      // Define iterator
      if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
        hide(proto, ITERATOR, $default);
      }
      // Plug for library
      Iterators[NAME] = $default;
      Iterators[TAG] = returnThis;
      if (DEFAULT) {
        methods = {
          values: DEF_VALUES ? $default : getMethod(VALUES),
          keys: IS_SET ? $default : getMethod(KEYS),
          entries: $entries
        };
        if (FORCED) for (key in methods) {
          if (!(key in proto)) redefine(proto, key, methods[key]);
        } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
      }
      return methods;
    };
  }, { "./_export": 22, "./_hide": 27, "./_iter-create": 35, "./_iterators": 39, "./_library": 40, "./_object-gpo": 46, "./_redefine": 53, "./_set-to-string-tag": 55, "./_wks": 69 }], 37: [function (require, module, exports) {
    var ITERATOR = require('./_wks')('iterator');
    var SAFE_CLOSING = false;

    try {
      var riter = [7][ITERATOR]();
      riter['return'] = function () {
        SAFE_CLOSING = true;
      };
      // eslint-disable-next-line no-throw-literal
      Array.from(riter, function () {
        throw 2;
      });
    } catch (e) {/* empty */}

    module.exports = function (exec, skipClosing) {
      if (!skipClosing && !SAFE_CLOSING) return false;
      var safe = false;
      try {
        var arr = [7];
        var iter = arr[ITERATOR]();
        iter.next = function () {
          return { done: safe = true };
        };
        arr[ITERATOR] = function () {
          return iter;
        };
        exec(arr);
      } catch (e) {/* empty */}
      return safe;
    };
  }, { "./_wks": 69 }], 38: [function (require, module, exports) {
    module.exports = function (done, value) {
      return { value: value, done: !!done };
    };
  }, {}], 39: [function (require, module, exports) {
    module.exports = {};
  }, {}], 40: [function (require, module, exports) {
    module.exports = true;
  }, {}], 41: [function (require, module, exports) {
    var global = require('./_global');
    var macrotask = require('./_task').set;
    var Observer = global.MutationObserver || global.WebKitMutationObserver;
    var process = global.process;
    var Promise = global.Promise;
    var isNode = require('./_cof')(process) == 'process';

    module.exports = function () {
      var head, last, notify;

      var flush = function flush() {
        var parent, fn;
        if (isNode && (parent = process.domain)) parent.exit();
        while (head) {
          fn = head.fn;
          head = head.next;
          try {
            fn();
          } catch (e) {
            if (head) notify();else last = undefined;
            throw e;
          }
        }last = undefined;
        if (parent) parent.enter();
      };

      // Node.js
      if (isNode) {
        notify = function notify() {
          process.nextTick(flush);
        };
        // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
      } else if (Observer && !(global.navigator && global.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
        notify = function notify() {
          node.data = toggle = !toggle;
        };
        // environments with maybe non-completely correct, but existent Promise
      } else if (Promise && Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = Promise.resolve(undefined);
        notify = function notify() {
          promise.then(flush);
        };
        // for other environments - macrotask based on:
        // - setImmediate
        // - MessageChannel
        // - window.postMessag
        // - onreadystatechange
        // - setTimeout
      } else {
        notify = function notify() {
          // strange IE + webpack dev server bug - use .call(global)
          macrotask.call(global, flush);
        };
      }

      return function (fn) {
        var task = { fn: fn, next: undefined };
        if (last) last.next = task;
        if (!head) {
          head = task;
          notify();
        }last = task;
      };
    };
  }, { "./_cof": 15, "./_global": 25, "./_task": 60 }], 42: [function (require, module, exports) {
    'use strict';
    // 25.4.1.5 NewPromiseCapability(C)

    var aFunction = require('./_a-function');

    function PromiseCapability(C) {
      var resolve, reject;
      this.promise = new C(function ($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
      });
      this.resolve = aFunction(resolve);
      this.reject = aFunction(reject);
    }

    module.exports.f = function (C) {
      return new PromiseCapability(C);
    };
  }, { "./_a-function": 9 }], 43: [function (require, module, exports) {
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    var anObject = require('./_an-object');
    var dPs = require('./_object-dps');
    var enumBugKeys = require('./_enum-bug-keys');
    var IE_PROTO = require('./_shared-key')('IE_PROTO');
    var Empty = function Empty() {/* empty */};
    var PROTOTYPE = 'prototype';

    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var _createDict = function createDict() {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = require('./_dom-create')('iframe');
      var i = enumBugKeys.length;
      var lt = '<';
      var gt = '>';
      var iframeDocument;
      iframe.style.display = 'none';
      require('./_html').appendChild(iframe);
      iframe.src = 'javascript:'; // eslint-disable-line no-script-url
      // createDict = iframe.contentWindow.Object;
      // html.removeChild(iframe);
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
      iframeDocument.close();
      _createDict = iframeDocument.F;
      while (i--) {
        delete _createDict[PROTOTYPE][enumBugKeys[i]];
      }return _createDict();
    };

    module.exports = Object.create || function create(O, Properties) {
      var result;
      if (O !== null) {
        Empty[PROTOTYPE] = anObject(O);
        result = new Empty();
        Empty[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
      } else result = _createDict();
      return Properties === undefined ? result : dPs(result, Properties);
    };
  }, { "./_an-object": 12, "./_dom-create": 20, "./_enum-bug-keys": 21, "./_html": 28, "./_object-dps": 45, "./_shared-key": 56 }], 44: [function (require, module, exports) {
    var anObject = require('./_an-object');
    var IE8_DOM_DEFINE = require('./_ie8-dom-define');
    var toPrimitive = require('./_to-primitive');
    var dP = Object.defineProperty;

    exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPrimitive(P, true);
      anObject(Attributes);
      if (IE8_DOM_DEFINE) try {
        return dP(O, P, Attributes);
      } catch (e) {/* empty */}
      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };
  }, { "./_an-object": 12, "./_descriptors": 19, "./_ie8-dom-define": 29, "./_to-primitive": 66 }], 45: [function (require, module, exports) {
    var dP = require('./_object-dp');
    var anObject = require('./_an-object');
    var getKeys = require('./_object-keys');

    module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject(O);
      var keys = getKeys(Properties);
      var length = keys.length;
      var i = 0;
      var P;
      while (length > i) {
        dP.f(O, P = keys[i++], Properties[P]);
      }return O;
    };
  }, { "./_an-object": 12, "./_descriptors": 19, "./_object-dp": 44, "./_object-keys": 48 }], 46: [function (require, module, exports) {
    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
    var has = require('./_has');
    var toObject = require('./_to-object');
    var IE_PROTO = require('./_shared-key')('IE_PROTO');
    var ObjectProto = Object.prototype;

    module.exports = Object.getPrototypeOf || function (O) {
      O = toObject(O);
      if (has(O, IE_PROTO)) return O[IE_PROTO];
      if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
      }return O instanceof Object ? ObjectProto : null;
    };
  }, { "./_has": 26, "./_shared-key": 56, "./_to-object": 65 }], 47: [function (require, module, exports) {
    var has = require('./_has');
    var toIObject = require('./_to-iobject');
    var arrayIndexOf = require('./_array-includes')(false);
    var IE_PROTO = require('./_shared-key')('IE_PROTO');

    module.exports = function (object, names) {
      var O = toIObject(object);
      var i = 0;
      var result = [];
      var key;
      for (key in O) {
        if (key != IE_PROTO) has(O, key) && result.push(key);
      } // Don't enum bug & hidden keys
      while (names.length > i) {
        if (has(O, key = names[i++])) {
          ~arrayIndexOf(result, key) || result.push(key);
        }
      }return result;
    };
  }, { "./_array-includes": 13, "./_has": 26, "./_shared-key": 56, "./_to-iobject": 63 }], 48: [function (require, module, exports) {
    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
    var $keys = require('./_object-keys-internal');
    var enumBugKeys = require('./_enum-bug-keys');

    module.exports = Object.keys || function keys(O) {
      return $keys(O, enumBugKeys);
    };
  }, { "./_enum-bug-keys": 21, "./_object-keys-internal": 47 }], 49: [function (require, module, exports) {
    module.exports = function (exec) {
      try {
        return { e: false, v: exec() };
      } catch (e) {
        return { e: true, v: e };
      }
    };
  }, {}], 50: [function (require, module, exports) {
    var anObject = require('./_an-object');
    var isObject = require('./_is-object');
    var newPromiseCapability = require('./_new-promise-capability');

    module.exports = function (C, x) {
      anObject(C);
      if (isObject(x) && x.constructor === C) return x;
      var promiseCapability = newPromiseCapability.f(C);
      var resolve = promiseCapability.resolve;
      resolve(x);
      return promiseCapability.promise;
    };
  }, { "./_an-object": 12, "./_is-object": 33, "./_new-promise-capability": 42 }], 51: [function (require, module, exports) {
    module.exports = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };
  }, {}], 52: [function (require, module, exports) {
    var hide = require('./_hide');
    module.exports = function (target, src, safe) {
      for (var key in src) {
        if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
      }return target;
    };
  }, { "./_hide": 27 }], 53: [function (require, module, exports) {
    module.exports = require('./_hide');
  }, { "./_hide": 27 }], 54: [function (require, module, exports) {
    'use strict';

    var global = require('./_global');
    var core = require('./_core');
    var dP = require('./_object-dp');
    var DESCRIPTORS = require('./_descriptors');
    var SPECIES = require('./_wks')('species');

    module.exports = function (KEY) {
      var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
      if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
        configurable: true,
        get: function get() {
          return this;
        }
      });
    };
  }, { "./_core": 16, "./_descriptors": 19, "./_global": 25, "./_object-dp": 44, "./_wks": 69 }], 55: [function (require, module, exports) {
    var def = require('./_object-dp').f;
    var has = require('./_has');
    var TAG = require('./_wks')('toStringTag');

    module.exports = function (it, tag, stat) {
      if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
    };
  }, { "./_has": 26, "./_object-dp": 44, "./_wks": 69 }], 56: [function (require, module, exports) {
    var shared = require('./_shared')('keys');
    var uid = require('./_uid');
    module.exports = function (key) {
      return shared[key] || (shared[key] = uid(key));
    };
  }, { "./_shared": 57, "./_uid": 67 }], 57: [function (require, module, exports) {
    var core = require('./_core');
    var global = require('./_global');
    var SHARED = '__core-js_shared__';
    var store = global[SHARED] || (global[SHARED] = {});

    (module.exports = function (key, value) {
      return store[key] || (store[key] = value !== undefined ? value : {});
    })('versions', []).push({
      version: core.version,
      mode: require('./_library') ? 'pure' : 'global',
      copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
    });
  }, { "./_core": 16, "./_global": 25, "./_library": 40 }], 58: [function (require, module, exports) {
    // 7.3.20 SpeciesConstructor(O, defaultConstructor)
    var anObject = require('./_an-object');
    var aFunction = require('./_a-function');
    var SPECIES = require('./_wks')('species');
    module.exports = function (O, D) {
      var C = anObject(O).constructor;
      var S;
      return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
    };
  }, { "./_a-function": 9, "./_an-object": 12, "./_wks": 69 }], 59: [function (require, module, exports) {
    var toInteger = require('./_to-integer');
    var defined = require('./_defined');
    // true  -> String#at
    // false -> String#codePointAt
    module.exports = function (TO_STRING) {
      return function (that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
      };
    };
  }, { "./_defined": 18, "./_to-integer": 62 }], 60: [function (require, module, exports) {
    var ctx = require('./_ctx');
    var invoke = require('./_invoke');
    var html = require('./_html');
    var cel = require('./_dom-create');
    var global = require('./_global');
    var process = global.process;
    var setTask = global.setImmediate;
    var clearTask = global.clearImmediate;
    var MessageChannel = global.MessageChannel;
    var Dispatch = global.Dispatch;
    var counter = 0;
    var queue = {};
    var ONREADYSTATECHANGE = 'onreadystatechange';
    var defer, channel, port;
    var run = function run() {
      var id = +this;
      // eslint-disable-next-line no-prototype-builtins
      if (queue.hasOwnProperty(id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
      }
    };
    var listener = function listener(event) {
      run.call(event.data);
    };
    // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
    if (!setTask || !clearTask) {
      setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while (arguments.length > i) {
          args.push(arguments[i++]);
        }queue[++counter] = function () {
          // eslint-disable-next-line no-new-func
          invoke(typeof fn == 'function' ? fn : Function(fn), args);
        };
        defer(counter);
        return counter;
      };
      clearTask = function clearImmediate(id) {
        delete queue[id];
      };
      // Node.js 0.8-
      if (require('./_cof')(process) == 'process') {
        defer = function defer(id) {
          process.nextTick(ctx(run, id, 1));
        };
        // Sphere (JS game engine) Dispatch API
      } else if (Dispatch && Dispatch.now) {
        defer = function defer(id) {
          Dispatch.now(ctx(run, id, 1));
        };
        // Browsers with MessageChannel, includes WebWorkers
      } else if (MessageChannel) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = listener;
        defer = ctx(port.postMessage, port, 1);
        // Browsers with postMessage, skip WebWorkers
        // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
      } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
        defer = function defer(id) {
          global.postMessage(id + '', '*');
        };
        global.addEventListener('message', listener, false);
        // IE8-
      } else if (ONREADYSTATECHANGE in cel('script')) {
        defer = function defer(id) {
          html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
            html.removeChild(this);
            run.call(id);
          };
        };
        // Rest old browsers
      } else {
        defer = function defer(id) {
          setTimeout(ctx(run, id, 1), 0);
        };
      }
    }
    module.exports = {
      set: setTask,
      clear: clearTask
    };
  }, { "./_cof": 15, "./_ctx": 17, "./_dom-create": 20, "./_global": 25, "./_html": 28, "./_invoke": 30 }], 61: [function (require, module, exports) {
    var toInteger = require('./_to-integer');
    var max = Math.max;
    var min = Math.min;
    module.exports = function (index, length) {
      index = toInteger(index);
      return index < 0 ? max(index + length, 0) : min(index, length);
    };
  }, { "./_to-integer": 62 }], 62: [function (require, module, exports) {
    // 7.1.4 ToInteger
    var ceil = Math.ceil;
    var floor = Math.floor;
    module.exports = function (it) {
      return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
    };
  }, {}], 63: [function (require, module, exports) {
    // to indexed object, toObject with fallback for non-array-like ES3 strings
    var IObject = require('./_iobject');
    var defined = require('./_defined');
    module.exports = function (it) {
      return IObject(defined(it));
    };
  }, { "./_defined": 18, "./_iobject": 31 }], 64: [function (require, module, exports) {
    // 7.1.15 ToLength
    var toInteger = require('./_to-integer');
    var min = Math.min;
    module.exports = function (it) {
      return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
    };
  }, { "./_to-integer": 62 }], 65: [function (require, module, exports) {
    // 7.1.13 ToObject(argument)
    var defined = require('./_defined');
    module.exports = function (it) {
      return Object(defined(it));
    };
  }, { "./_defined": 18 }], 66: [function (require, module, exports) {
    // 7.1.1 ToPrimitive(input [, PreferredType])
    var isObject = require('./_is-object');
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    module.exports = function (it, S) {
      if (!isObject(it)) return it;
      var fn, val;
      if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
      if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
      if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
      throw TypeError("Can't convert object to primitive value");
    };
  }, { "./_is-object": 33 }], 67: [function (require, module, exports) {
    var id = 0;
    var px = Math.random();
    module.exports = function (key) {
      return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
    };
  }, {}], 68: [function (require, module, exports) {
    var global = require('./_global');
    var navigator = global.navigator;

    module.exports = navigator && navigator.userAgent || '';
  }, { "./_global": 25 }], 69: [function (require, module, exports) {
    var store = require('./_shared')('wks');
    var uid = require('./_uid');
    var _Symbol = require('./_global').Symbol;
    var USE_SYMBOL = typeof _Symbol == 'function';

    var $exports = module.exports = function (name) {
      return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
    };

    $exports.store = store;
  }, { "./_global": 25, "./_shared": 57, "./_uid": 67 }], 70: [function (require, module, exports) {
    var classof = require('./_classof');
    var ITERATOR = require('./_wks')('iterator');
    var Iterators = require('./_iterators');
    module.exports = require('./_core').getIteratorMethod = function (it) {
      if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
    };
  }, { "./_classof": 14, "./_core": 16, "./_iterators": 39, "./_wks": 69 }], 71: [function (require, module, exports) {
    'use strict';

    var addToUnscopables = require('./_add-to-unscopables');
    var step = require('./_iter-step');
    var Iterators = require('./_iterators');
    var toIObject = require('./_to-iobject');

    // 22.1.3.4 Array.prototype.entries()
    // 22.1.3.13 Array.prototype.keys()
    // 22.1.3.29 Array.prototype.values()
    // 22.1.3.30 Array.prototype[@@iterator]()
    module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
      this._t = toIObject(iterated); // target
      this._i = 0; // next index
      this._k = kind; // kind
      // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
    }, function () {
      var O = this._t;
      var kind = this._k;
      var index = this._i++;
      if (!O || index >= O.length) {
        this._t = undefined;
        return step(1);
      }
      if (kind == 'keys') return step(0, index);
      if (kind == 'values') return step(0, O[index]);
      return step(0, [index, O[index]]);
    }, 'values');

    // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
    Iterators.Arguments = Iterators.Array;

    addToUnscopables('keys');
    addToUnscopables('values');
    addToUnscopables('entries');
  }, { "./_add-to-unscopables": 10, "./_iter-define": 36, "./_iter-step": 38, "./_iterators": 39, "./_to-iobject": 63 }], 72: [function (require, module, exports) {}, {}], 73: [function (require, module, exports) {
    'use strict';

    var LIBRARY = require('./_library');
    var global = require('./_global');
    var ctx = require('./_ctx');
    var classof = require('./_classof');
    var $export = require('./_export');
    var isObject = require('./_is-object');
    var aFunction = require('./_a-function');
    var anInstance = require('./_an-instance');
    var forOf = require('./_for-of');
    var speciesConstructor = require('./_species-constructor');
    var task = require('./_task').set;
    var microtask = require('./_microtask')();
    var newPromiseCapabilityModule = require('./_new-promise-capability');
    var perform = require('./_perform');
    var userAgent = require('./_user-agent');
    var promiseResolve = require('./_promise-resolve');
    var PROMISE = 'Promise';
    var TypeError = global.TypeError;
    var process = global.process;
    var versions = process && process.versions;
    var v8 = versions && versions.v8 || '';
    var $Promise = global[PROMISE];
    var isNode = classof(process) == 'process';
    var empty = function empty() {/* empty */};
    var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
    var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

    var USE_NATIVE = !!function () {
      try {
        // correct subclassing with @@species support
        var promise = $Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
          exec(empty, empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
        // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
        // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
        // we can't detect it synchronously, so just check versions
        && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
      } catch (e) {/* empty */}
    }();

    // helpers
    var isThenable = function isThenable(it) {
      var then;
      return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
    };
    var notify = function notify(promise, isReject) {
      if (promise._n) return;
      promise._n = true;
      var chain = promise._c;
      microtask(function () {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function run(reaction) {
          var handler = ok ? reaction.ok : reaction.fail;
          var resolve = reaction.resolve;
          var reject = reaction.reject;
          var domain = reaction.domain;
          var result, then, exited;
          try {
            if (handler) {
              if (!ok) {
                if (promise._h == 2) onHandleUnhandled(promise);
                promise._h = 1;
              }
              if (handler === true) result = value;else {
                if (domain) domain.enter();
                result = handler(value); // may throw
                if (domain) {
                  domain.exit();
                  exited = true;
                }
              }
              if (result === reaction.promise) {
                reject(TypeError('Promise-chain cycle'));
              } else if (then = isThenable(result)) {
                then.call(result, resolve, reject);
              } else resolve(result);
            } else reject(value);
          } catch (e) {
            if (domain && !exited) domain.exit();
            reject(e);
          }
        };
        while (chain.length > i) {
          run(chain[i++]);
        } // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) onUnhandled(promise);
      });
    };
    var onUnhandled = function onUnhandled(promise) {
      task.call(global, function () {
        var value = promise._v;
        var unhandled = isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
          result = perform(function () {
            if (isNode) {
              process.emit('unhandledRejection', value, promise);
            } else if (handler = global.onunhandledrejection) {
              handler({ promise: promise, reason: value });
            } else if ((console = global.console) && console.error) {
              console.error('Unhandled promise rejection', value);
            }
          });
          // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
          promise._h = isNode || isUnhandled(promise) ? 2 : 1;
        }promise._a = undefined;
        if (unhandled && result.e) throw result.v;
      });
    };
    var isUnhandled = function isUnhandled(promise) {
      return promise._h !== 1 && (promise._a || promise._c).length === 0;
    };
    var onHandleUnhandled = function onHandleUnhandled(promise) {
      task.call(global, function () {
        var handler;
        if (isNode) {
          process.emit('rejectionHandled', promise);
        } else if (handler = global.onrejectionhandled) {
          handler({ promise: promise, reason: promise._v });
        }
      });
    };
    var $reject = function $reject(value) {
      var promise = this;
      if (promise._d) return;
      promise._d = true;
      promise = promise._w || promise; // unwrap
      promise._v = value;
      promise._s = 2;
      if (!promise._a) promise._a = promise._c.slice();
      notify(promise, true);
    };
    var $resolve = function $resolve(value) {
      var promise = this;
      var then;
      if (promise._d) return;
      promise._d = true;
      promise = promise._w || promise; // unwrap
      try {
        if (promise === value) throw TypeError("Promise can't be resolved itself");
        if (then = isThenable(value)) {
          microtask(function () {
            var wrapper = { _w: promise, _d: false }; // wrap
            try {
              then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
            } catch (e) {
              $reject.call(wrapper, e);
            }
          });
        } else {
          promise._v = value;
          promise._s = 1;
          notify(promise, false);
        }
      } catch (e) {
        $reject.call({ _w: promise, _d: false }, e); // wrap
      }
    };

    // constructor polyfill
    if (!USE_NATIVE) {
      // 25.4.3.1 Promise(executor)
      $Promise = function Promise(executor) {
        anInstance(this, $Promise, PROMISE, '_h');
        aFunction(executor);
        Internal.call(this);
        try {
          executor(ctx($resolve, this, 1), ctx($reject, this, 1));
        } catch (err) {
          $reject.call(this, err);
        }
      };
      // eslint-disable-next-line no-unused-vars
      Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
      };
      Internal.prototype = require('./_redefine-all')($Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
          var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
          reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
          reaction.fail = typeof onRejected == 'function' && onRejected;
          reaction.domain = isNode ? process.domain : undefined;
          this._c.push(reaction);
          if (this._a) this._a.push(reaction);
          if (this._s) notify(this, false);
          return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function _catch(onRejected) {
          return this.then(undefined, onRejected);
        }
      });
      OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new Internal();
        this.promise = promise;
        this.resolve = ctx($resolve, promise, 1);
        this.reject = ctx($reject, promise, 1);
      };
      newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
        return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
      };
    }

    $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
    require('./_set-to-string-tag')($Promise, PROMISE);
    require('./_set-species')(PROMISE);
    Wrapper = require('./_core')[PROMISE];

    // statics
    $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
      // 25.4.4.5 Promise.reject(r)
      reject: function reject(r) {
        var capability = newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
      }
    });
    $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
      // 25.4.4.6 Promise.resolve(x)
      resolve: function resolve(x) {
        return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
      }
    });
    $export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
      $Promise.all(iter)['catch'](empty);
    })), PROMISE, {
      // 25.4.4.1 Promise.all(iterable)
      all: function all(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform(function () {
          var values = [];
          var index = 0;
          var remaining = 1;
          forOf(iterable, false, function (promise) {
            var $index = index++;
            var alreadyCalled = false;
            values.push(undefined);
            remaining++;
            C.resolve(promise).then(function (value) {
              if (alreadyCalled) return;
              alreadyCalled = true;
              values[$index] = value;
              --remaining || resolve(values);
            }, reject);
          });
          --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
      },
      // 25.4.4.4 Promise.race(iterable)
      race: function race(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var reject = capability.reject;
        var result = perform(function () {
          forOf(iterable, false, function (promise) {
            C.resolve(promise).then(capability.resolve, reject);
          });
        });
        if (result.e) reject(result.v);
        return capability.promise;
      }
    });
  }, { "./_a-function": 9, "./_an-instance": 11, "./_classof": 14, "./_core": 16, "./_ctx": 17, "./_export": 22, "./_for-of": 24, "./_global": 25, "./_is-object": 33, "./_iter-detect": 37, "./_library": 40, "./_microtask": 41, "./_new-promise-capability": 42, "./_perform": 49, "./_promise-resolve": 50, "./_redefine-all": 52, "./_set-species": 54, "./_set-to-string-tag": 55, "./_species-constructor": 58, "./_task": 60, "./_user-agent": 68, "./_wks": 69 }], 74: [function (require, module, exports) {
    'use strict';

    var $at = require('./_string-at')(true);

    // 21.1.3.27 String.prototype[@@iterator]()
    require('./_iter-define')(String, 'String', function (iterated) {
      this._t = String(iterated); // target
      this._i = 0; // next index
      // 21.1.5.2.1 %StringIteratorPrototype%.next()
    }, function () {
      var O = this._t;
      var index = this._i;
      var point;
      if (index >= O.length) return { value: undefined, done: true };
      point = $at(O, index);
      this._i += point.length;
      return { value: point, done: false };
    });
  }, { "./_iter-define": 36, "./_string-at": 59 }], 75: [function (require, module, exports) {
    // https://github.com/tc39/proposal-promise-finally
    'use strict';

    var $export = require('./_export');
    var core = require('./_core');
    var global = require('./_global');
    var speciesConstructor = require('./_species-constructor');
    var promiseResolve = require('./_promise-resolve');

    $export($export.P + $export.R, 'Promise', { 'finally': function _finally(onFinally) {
        var C = speciesConstructor(this, core.Promise || global.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function (x) {
          return promiseResolve(C, onFinally()).then(function () {
            return x;
          });
        } : onFinally, isFunction ? function (e) {
          return promiseResolve(C, onFinally()).then(function () {
            throw e;
          });
        } : onFinally);
      } });
  }, { "./_core": 16, "./_export": 22, "./_global": 25, "./_promise-resolve": 50, "./_species-constructor": 58 }], 76: [function (require, module, exports) {
    'use strict';
    // https://github.com/tc39/proposal-promise-try

    var $export = require('./_export');
    var newPromiseCapability = require('./_new-promise-capability');
    var perform = require('./_perform');

    $export($export.S, 'Promise', { 'try': function _try(callbackfn) {
        var promiseCapability = newPromiseCapability.f(this);
        var result = perform(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
      } });
  }, { "./_export": 22, "./_new-promise-capability": 42, "./_perform": 49 }], 77: [function (require, module, exports) {
    require('./es6.array.iterator');
    var global = require('./_global');
    var hide = require('./_hide');
    var Iterators = require('./_iterators');
    var TO_STRING_TAG = require('./_wks')('toStringTag');

    var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

    for (var i = 0; i < DOMIterables.length; i++) {
      var NAME = DOMIterables[i];
      var Collection = global[NAME];
      var proto = Collection && Collection.prototype;
      if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
      Iterators[NAME] = Iterators.Array;
    }
  }, { "./_global": 25, "./_hide": 27, "./_iterators": 39, "./_wks": 69, "./es6.array.iterator": 71 }], 78: [function (require, module, exports) {
    (function (root, factory) {
      if (typeof define === 'function' && define.amd) {
        define(function () {
          return factory(root);
        });
      } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
        module.exports = factory;
      } else {
        root.echo = factory(root);
      }
    })(this, function (root) {

      'use strict';

      var echo = {};

      var callback = function callback() {};

      var offset, poll, delay, useDebounce, unload;

      var isHidden = function isHidden(element) {
        return element.offsetParent === null;
      };

      var inView = function inView(element, view) {
        if (isHidden(element)) {
          return false;
        }

        var box = element.getBoundingClientRect();
        return box.right >= view.l && box.bottom >= view.t && box.left <= view.r && box.top <= view.b;
      };

      var debounceOrThrottle = function debounceOrThrottle() {
        if (!useDebounce && !!poll) {
          return;
        }
        clearTimeout(poll);
        poll = setTimeout(function () {
          echo.render();
          poll = null;
        }, delay);
      };

      echo.init = function (opts) {
        opts = opts || {};
        var offsetAll = opts.offset || 0;
        var offsetVertical = opts.offsetVertical || offsetAll;
        var offsetHorizontal = opts.offsetHorizontal || offsetAll;
        var optionToInt = function optionToInt(opt, fallback) {
          return parseInt(opt || fallback, 10);
        };
        offset = {
          t: optionToInt(opts.offsetTop, offsetVertical),
          b: optionToInt(opts.offsetBottom, offsetVertical),
          l: optionToInt(opts.offsetLeft, offsetHorizontal),
          r: optionToInt(opts.offsetRight, offsetHorizontal)
        };
        delay = optionToInt(opts.throttle, 250);
        useDebounce = opts.debounce !== false;
        unload = !!opts.unload;
        callback = opts.callback || callback;
        echo.render();
        if (document.addEventListener) {
          root.addEventListener('scroll', debounceOrThrottle, false);
          root.addEventListener('load', debounceOrThrottle, false);
        } else {
          root.attachEvent('onscroll', debounceOrThrottle);
          root.attachEvent('onload', debounceOrThrottle);
        }
      };

      echo.render = function () {
        var nodes = document.querySelectorAll('img[data-echo], [data-echo-background]');
        var length = nodes.length;
        var src, elem;
        var view = {
          l: 0 - offset.l,
          t: 0 - offset.t,
          b: (root.innerHeight || document.documentElement.clientHeight) + offset.b,
          r: (root.innerWidth || document.documentElement.clientWidth) + offset.r
        };
        for (var i = 0; i < length; i++) {
          elem = nodes[i];
          if (inView(elem, view)) {

            if (unload) {
              elem.setAttribute('data-echo-placeholder', elem.src);
            }

            if (elem.getAttribute('data-echo-background') !== null) {
              elem.style.backgroundImage = "url(" + elem.getAttribute('data-echo-background') + ")";
            } else {
              elem.src = elem.getAttribute('data-echo');
            }

            if (!unload) {
              elem.removeAttribute('data-echo');
              elem.removeAttribute('data-echo-background');
            }

            callback(elem, 'load');
          } else if (unload && !!(src = elem.getAttribute('data-echo-placeholder'))) {

            if (elem.getAttribute('data-echo-background') !== null) {
              elem.style.backgroundImage = "url(" + src + ")";
            } else {
              elem.src = src;
            }

            elem.removeAttribute('data-echo-placeholder');
            callback(elem, 'unload');
          }
        }
        if (!length) {
          echo.detach();
        }
      };

      echo.detach = function () {
        if (document.removeEventListener) {
          root.removeEventListener('scroll', debounceOrThrottle);
        } else {
          root.detachEvent('onscroll', debounceOrThrottle);
        }
        clearTimeout(poll);
      };

      return echo;
    });
  }, {}], 79: [function (require, module, exports) {
    /*!
     * JavaScript Cookie v2.2.0
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */
    ;(function (factory) {
      var registeredInModuleLoader = false;
      if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
      }
      if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
        module.exports = factory();
        registeredInModuleLoader = true;
      }
      if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function () {
          window.Cookies = OldCookies;
          return api;
        };
      }
    })(function () {
      function extend() {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
          var attributes = arguments[i];
          for (var key in attributes) {
            result[key] = attributes[key];
          }
        }
        return result;
      }

      function init(converter) {
        function api(key, value, attributes) {
          var result;
          if (typeof document === 'undefined') {
            return;
          }

          // Write

          if (arguments.length > 1) {
            attributes = extend({
              path: '/'
            }, api.defaults, attributes);

            if (typeof attributes.expires === 'number') {
              var expires = new Date();
              expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
              attributes.expires = expires;
            }

            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

            try {
              result = JSON.stringify(value);
              if (/^[\{\[]/.test(result)) {
                value = result;
              }
            } catch (e) {}

            if (!converter.write) {
              value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            } else {
              value = converter.write(value, key);
            }

            key = encodeURIComponent(String(key));
            key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
            key = key.replace(/[\(\)]/g, escape);

            var stringifiedAttributes = '';

            for (var attributeName in attributes) {
              if (!attributes[attributeName]) {
                continue;
              }
              stringifiedAttributes += '; ' + attributeName;
              if (attributes[attributeName] === true) {
                continue;
              }
              stringifiedAttributes += '=' + attributes[attributeName];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
          }

          // Read

          if (!key) {
            result = {};
          }

          // To prevent the for loop in the first place assign an empty array
          // in case there are no cookies at all. Also prevents odd result when
          // calling "get()"
          var cookies = document.cookie ? document.cookie.split('; ') : [];
          var rdecode = /(%[0-9A-Z]{2})+/g;
          var i = 0;

          for (; i < cookies.length; i++) {
            var parts = cookies[i].split('=');
            var cookie = parts.slice(1).join('=');

            if (!this.json && cookie.charAt(0) === '"') {
              cookie = cookie.slice(1, -1);
            }

            try {
              var name = parts[0].replace(rdecode, decodeURIComponent);
              cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

              if (this.json) {
                try {
                  cookie = JSON.parse(cookie);
                } catch (e) {}
              }

              if (key === name) {
                result = cookie;
                break;
              }

              if (!key) {
                result[name] = cookie;
              }
            } catch (e) {}
          }

          return result;
        }

        api.set = api;
        api.get = function (key) {
          return api.call(api, key);
        };
        api.getJSON = function () {
          return api.apply({
            json: true
          }, [].slice.call(arguments));
        };
        api.defaults = {};

        api.remove = function (key, attributes) {
          api(key, '', extend(attributes, {
            expires: -1
          }));
        };

        api.withConverter = init;

        return api;
      }

      return init(function () {});
    });
  }, {}], 80: [function (require, module, exports) {
    /**
     * Module dependencies
     */

    var debug = require('debug')('jsonp');

    /**
     * Module exports.
     */

    module.exports = jsonp;

    /**
     * Callback index.
     */

    var count = 0;

    /**
     * Noop function.
     */

    function noop() {}

    /**
     * JSONP handler
     *
     * Options:
     *  - param {String} qs parameter (`callback`)
     *  - prefix {String} qs parameter (`__jp`)
     *  - name {String} qs parameter (`prefix` + incr)
     *  - timeout {Number} how long after a timeout error is emitted (`60000`)
     *
     * @param {String} url
     * @param {Object|Function} optional options / callback
     * @param {Function} optional callback
     */

    function jsonp(url, opts, fn) {
      if ('function' == typeof opts) {
        fn = opts;
        opts = {};
      }
      if (!opts) opts = {};

      var prefix = opts.prefix || '__jp';

      // use the callback name that was passed if one was provided.
      // otherwise generate a unique name by incrementing our counter.
      var id = opts.name || prefix + count++;

      var param = opts.param || 'callback';
      var timeout = null != opts.timeout ? opts.timeout : 60000;
      var enc = encodeURIComponent;
      var target = document.getElementsByTagName('script')[0] || document.head;
      var script;
      var timer;

      if (timeout) {
        timer = setTimeout(function () {
          cleanup();
          if (fn) fn(new Error('Timeout'));
        }, timeout);
      }

      function cleanup() {
        if (script.parentNode) script.parentNode.removeChild(script);
        window[id] = noop;
        if (timer) clearTimeout(timer);
      }

      function cancel() {
        if (window[id]) {
          cleanup();
        }
      }

      window[id] = function (data) {
        debug('jsonp got', data);
        cleanup();
        if (fn) fn(null, data);
      };

      // add qs component
      url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
      url = url.replace('?&', '?');

      debug('jsonp req "%s"', url);

      // create script
      script = document.createElement('script');
      script.src = url;
      target.parentNode.insertBefore(script, target);

      return cancel;
    }
  }, { "debug": 81 }], 81: [function (require, module, exports) {
    (function (process) {
      /**
       * This is the web browser implementation of `debug()`.
       *
       * Expose `debug()` as the module.
       */

      exports = module.exports = require('./debug');
      exports.log = log;
      exports.formatArgs = formatArgs;
      exports.save = save;
      exports.load = load;
      exports.useColors = useColors;
      exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

      /**
       * Colors.
       */

      exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];

      /**
       * Currently only WebKit-based Web Inspectors, Firefox >= v31,
       * and the Firebug extension (any Firefox version) are known
       * to support "%c" CSS customizations.
       *
       * TODO: add a `localStorage` variable to explicitly enable/disable colors
       */

      function useColors() {
        // NB: In an Electron preload script, document will be defined but not fully
        // initialized. Since we know we're in Chrome, we'll just detect this case
        // explicitly
        if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
          return true;
        }

        // is webkit? http://stackoverflow.com/a/16459606/376773
        // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
        return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
        // is firebug? http://stackoverflow.com/a/398120/376773
        typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
        // is firefox >= v31?
        // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
        typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
        // double check webkit in userAgent just in case we are in a worker
        typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }

      /**
       * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
       */

      exports.formatters.j = function (v) {
        try {
          return JSON.stringify(v);
        } catch (err) {
          return '[UnexpectedJSONParseError]: ' + err.message;
        }
      };

      /**
       * Colorize log arguments if enabled.
       *
       * @api public
       */

      function formatArgs(args) {
        var useColors = this.useColors;

        args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

        if (!useColors) return;

        var c = 'color: ' + this.color;
        args.splice(1, 0, c, 'color: inherit');

        // the final "%c" is somewhat tricky, because there could be other
        // arguments passed either before or after the %c, so we need to
        // figure out the correct index to insert the CSS into
        var index = 0;
        var lastC = 0;
        args[0].replace(/%[a-zA-Z%]/g, function (match) {
          if ('%%' === match) return;
          index++;
          if ('%c' === match) {
            // we only are interested in the *last* %c
            // (the user may have provided their own)
            lastC = index;
          }
        });

        args.splice(lastC, 0, c);
      }

      /**
       * Invokes `console.log()` when available.
       * No-op when `console.log` is not a "function".
       *
       * @api public
       */

      function log() {
        // this hackery is required for IE8/9, where
        // the `console.log` function doesn't have 'apply'
        return 'object' === (typeof console === "undefined" ? "undefined" : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
      }

      /**
       * Save `namespaces`.
       *
       * @param {String} namespaces
       * @api private
       */

      function save(namespaces) {
        try {
          if (null == namespaces) {
            exports.storage.removeItem('debug');
          } else {
            exports.storage.debug = namespaces;
          }
        } catch (e) {}
      }

      /**
       * Load `namespaces`.
       *
       * @return {String} returns the previously persisted debug modes
       * @api private
       */

      function load() {
        var r;
        try {
          r = exports.storage.debug;
        } catch (e) {}

        // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
        if (!r && typeof process !== 'undefined' && 'env' in process) {
          r = process.env.DEBUG;
        }

        return r;
      }

      /**
       * Enable namespaces listed in `localStorage.debug` initially.
       */

      exports.enable(load());

      /**
       * Localstorage attempts to return the localstorage.
       *
       * This is necessary because safari throws
       * when a user disables cookies/localstorage
       * and you attempt to access it.
       *
       * @return {LocalStorage}
       * @api private
       */

      function localstorage() {
        try {
          return window.localStorage;
        } catch (e) {}
      }
    }).call(this, require('_process'));
  }, { "./debug": 82, "_process": 123 }], 82: [function (require, module, exports) {

    /**
     * This is the common logic for both the Node.js and web browser
     * implementations of `debug()`.
     *
     * Expose `debug()` as the module.
     */

    exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
    exports.coerce = coerce;
    exports.disable = disable;
    exports.enable = enable;
    exports.enabled = enabled;
    exports.humanize = require('ms');

    /**
     * The currently active debug mode names, and names to skip.
     */

    exports.names = [];
    exports.skips = [];

    /**
     * Map of special "%n" handling functions, for the debug "format" argument.
     *
     * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
     */

    exports.formatters = {};

    /**
     * Previous log timestamp.
     */

    var prevTime;

    /**
     * Select a color.
     * @param {String} namespace
     * @return {Number}
     * @api private
     */

    function selectColor(namespace) {
      var hash = 0,
          i;

      for (i in namespace) {
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
      }

      return exports.colors[Math.abs(hash) % exports.colors.length];
    }

    /**
     * Create a debugger with the given `namespace`.
     *
     * @param {String} namespace
     * @return {Function}
     * @api public
     */

    function createDebug(namespace) {

      function debug() {
        // disabled?
        if (!debug.enabled) return;

        var self = debug;

        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;

        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }

        args[0] = exports.coerce(args[0]);

        if ('string' !== typeof args[0]) {
          // anything else let's inspect with %O
          args.unshift('%O');
        }

        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
          // if we encounter an escaped % then don't increase the array index
          if (match === '%%') return match;
          index++;
          var formatter = exports.formatters[format];
          if ('function' === typeof formatter) {
            var val = args[index];
            match = formatter.call(self, val);

            // now we need to remove `args[index]` since it's inlined in the `format`
            args.splice(index, 1);
            index--;
          }
          return match;
        });

        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);

        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
      }

      debug.namespace = namespace;
      debug.enabled = exports.enabled(namespace);
      debug.useColors = exports.useColors();
      debug.color = selectColor(namespace);

      // env-specific initialization logic for debug instances
      if ('function' === typeof exports.init) {
        exports.init(debug);
      }

      return debug;
    }

    /**
     * Enables a debug mode by namespaces. This can include modes
     * separated by a colon and wildcards.
     *
     * @param {String} namespaces
     * @api public
     */

    function enable(namespaces) {
      exports.save(namespaces);

      exports.names = [];
      exports.skips = [];

      var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
      var len = split.length;

      for (var i = 0; i < len; i++) {
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') {
          exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        } else {
          exports.names.push(new RegExp('^' + namespaces + '$'));
        }
      }
    }

    /**
     * Disable debug output.
     *
     * @api public
     */

    function disable() {
      exports.enable('');
    }

    /**
     * Returns true if the given mode name is enabled, false otherwise.
     *
     * @param {String} name
     * @return {Boolean}
     * @api public
     */

    function enabled(name) {
      var i, len;
      for (i = 0, len = exports.skips.length; i < len; i++) {
        if (exports.skips[i].test(name)) {
          return false;
        }
      }
      for (i = 0, len = exports.names.length; i < len; i++) {
        if (exports.names[i].test(name)) {
          return true;
        }
      }
      return false;
    }

    /**
     * Coerce `val`.
     *
     * @param {Mixed} val
     * @return {Mixed}
     * @api private
     */

    function coerce(val) {
      if (val instanceof Error) return val.stack || val.message;
      return val;
    }
  }, { "ms": 121 }], 83: [function (require, module, exports) {
    var root = require('./_root');

    /** Built-in value references. */
    var _Symbol2 = root.Symbol;

    module.exports = _Symbol2;
  }, { "./_root": 106 }], 84: [function (require, module, exports) {
    /**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    module.exports = arrayEach;
  }, {}], 85: [function (require, module, exports) {
    var baseTimes = require('./_baseTimes'),
        isArguments = require('./isArguments'),
        isArray = require('./isArray'),
        isBuffer = require('./isBuffer'),
        isIndex = require('./_isIndex'),
        isTypedArray = require('./isTypedArray');

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
        // Safari 9 has enumerable `arguments.length` in strict mode.
        key == 'length' ||
        // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == 'offset' || key == 'parent') ||
        // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
        // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }

    module.exports = arrayLikeKeys;
  }, { "./_baseTimes": 93, "./_isIndex": 100, "./isArguments": 110, "./isArray": 111, "./isBuffer": 113, "./isTypedArray": 118 }], 86: [function (require, module, exports) {
    var baseForOwn = require('./_baseForOwn'),
        createBaseEach = require('./_createBaseEach');

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    module.exports = baseEach;
  }, { "./_baseForOwn": 88, "./_createBaseEach": 96 }], 87: [function (require, module, exports) {
    var createBaseFor = require('./_createBaseFor');

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    module.exports = baseFor;
  }, { "./_createBaseFor": 97 }], 88: [function (require, module, exports) {
    var baseFor = require('./_baseFor'),
        keys = require('./keys');

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    module.exports = baseForOwn;
  }, { "./_baseFor": 87, "./keys": 119 }], 89: [function (require, module, exports) {
    var _Symbol3 = require('./_Symbol'),
        getRawTag = require('./_getRawTag'),
        objectToString = require('./_objectToString');

    /** `Object#toString` result references. */
    var nullTag = '[object Null]',
        undefinedTag = '[object Undefined]';

    /** Built-in value references. */
    var symToStringTag = _Symbol3 ? _Symbol3.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }

    module.exports = baseGetTag;
  }, { "./_Symbol": 83, "./_getRawTag": 99, "./_objectToString": 104 }], 90: [function (require, module, exports) {
    var baseGetTag = require('./_baseGetTag'),
        isObjectLike = require('./isObjectLike');

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]';

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    module.exports = baseIsArguments;
  }, { "./_baseGetTag": 89, "./isObjectLike": 117 }], 91: [function (require, module, exports) {
    var baseGetTag = require('./_baseGetTag'),
        isLength = require('./isLength'),
        isObjectLike = require('./isObjectLike');

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        objectTag = '[object Object]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        weakMapTag = '[object WeakMap]';

    var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    module.exports = baseIsTypedArray;
  }, { "./_baseGetTag": 89, "./isLength": 115, "./isObjectLike": 117 }], 92: [function (require, module, exports) {
    var isPrototype = require('./_isPrototype'),
        nativeKeys = require('./_nativeKeys');

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    module.exports = baseKeys;
  }, { "./_isPrototype": 101, "./_nativeKeys": 102 }], 93: [function (require, module, exports) {
    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
      var index = -1,
          result = Array(n);

      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }

    module.exports = baseTimes;
  }, {}], 94: [function (require, module, exports) {
    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }

    module.exports = baseUnary;
  }, {}], 95: [function (require, module, exports) {
    var identity = require('./identity');

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    module.exports = castFunction;
  }, { "./identity": 109 }], 96: [function (require, module, exports) {
    var isArrayLike = require('./isArrayLike');

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function (collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while (fromRight ? index-- : ++index < length) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    module.exports = createBaseEach;
  }, { "./isArrayLike": 112 }], 97: [function (require, module, exports) {
    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function (object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    module.exports = createBaseFor;
  }, {}], 98: [function (require, module, exports) {
    (function (global) {
      /** Detect free variable `global` from Node.js. */
      var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global && global.Object === Object && global;

      module.exports = freeGlobal;
    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  }, {}], 99: [function (require, module, exports) {
    var _Symbol4 = require('./_Symbol');

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Built-in value references. */
    var symToStringTag = _Symbol4 ? _Symbol4.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    module.exports = getRawTag;
  }, { "./_Symbol": 83 }], 100: [function (require, module, exports) {
    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value === "undefined" ? "undefined" : _typeof(value);
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }

    module.exports = isIndex;
  }, {}], 101: [function (require, module, exports) {
    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

      return value === proto;
    }

    module.exports = isPrototype;
  }, {}], 102: [function (require, module, exports) {
    var overArg = require('./_overArg');

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeKeys = overArg(Object.keys, Object);

    module.exports = nativeKeys;
  }, { "./_overArg": 105 }], 103: [function (require, module, exports) {
    var freeGlobal = require('./_freeGlobal');

    /** Detect free variable `exports`. */
    var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && (typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = function () {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;

        if (types) {
          return types;
        }

        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();

    module.exports = nodeUtil;
  }, { "./_freeGlobal": 98 }], 104: [function (require, module, exports) {
    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    module.exports = objectToString;
  }, {}], 105: [function (require, module, exports) {
    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }

    module.exports = overArg;
  }, {}], 106: [function (require, module, exports) {
    var freeGlobal = require('./_freeGlobal');

    /** Detect free variable `self`. */
    var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();

    module.exports = root;
  }, { "./_freeGlobal": 98 }], 107: [function (require, module, exports) {
    module.exports = require('./forEach');
  }, { "./forEach": 108 }], 108: [function (require, module, exports) {
    var arrayEach = require('./_arrayEach'),
        baseEach = require('./_baseEach'),
        castFunction = require('./_castFunction'),
        isArray = require('./isArray');

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, castFunction(iteratee));
    }

    module.exports = forEach;
  }, { "./_arrayEach": 84, "./_baseEach": 86, "./_castFunction": 95, "./isArray": 111 }], 109: [function (require, module, exports) {
    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    module.exports = identity;
  }, {}], 110: [function (require, module, exports) {
    var baseIsArguments = require('./_baseIsArguments'),
        isObjectLike = require('./isObjectLike');

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Built-in value references. */
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    };

    module.exports = isArguments;
  }, { "./_baseIsArguments": 90, "./isObjectLike": 117 }], 111: [function (require, module, exports) {
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    module.exports = isArray;
  }, {}], 112: [function (require, module, exports) {
    var isFunction = require('./isFunction'),
        isLength = require('./isLength');

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    module.exports = isArrayLike;
  }, { "./isFunction": 114, "./isLength": 115 }], 113: [function (require, module, exports) {
    var root = require('./_root'),
        stubFalse = require('./stubFalse');

    /** Detect free variable `exports`. */
    var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && (typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Built-in value references. */
    var Buffer = moduleExports ? root.Buffer : undefined;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    module.exports = isBuffer;
  }, { "./_root": 106, "./stubFalse": 120 }], 114: [function (require, module, exports) {
    var baseGetTag = require('./_baseGetTag'),
        isObject = require('./isObject');

    /** `Object#toString` result references. */
    var asyncTag = '[object AsyncFunction]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        proxyTag = '[object Proxy]';

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    module.exports = isFunction;
  }, { "./_baseGetTag": 89, "./isObject": 116 }], 115: [function (require, module, exports) {
    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    module.exports = isLength;
  }, {}], 116: [function (require, module, exports) {
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value === "undefined" ? "undefined" : _typeof(value);
      return value != null && (type == 'object' || type == 'function');
    }

    module.exports = isObject;
  }, {}], 117: [function (require, module, exports) {
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && (typeof value === "undefined" ? "undefined" : _typeof(value)) == 'object';
    }

    module.exports = isObjectLike;
  }, {}], 118: [function (require, module, exports) {
    var baseIsTypedArray = require('./_baseIsTypedArray'),
        baseUnary = require('./_baseUnary'),
        nodeUtil = require('./_nodeUtil');

    /* Node.js helper references. */
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    module.exports = isTypedArray;
  }, { "./_baseIsTypedArray": 91, "./_baseUnary": 94, "./_nodeUtil": 103 }], 119: [function (require, module, exports) {
    var arrayLikeKeys = require('./_arrayLikeKeys'),
        baseKeys = require('./_baseKeys'),
        isArrayLike = require('./isArrayLike');

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    module.exports = keys;
  }, { "./_arrayLikeKeys": 85, "./_baseKeys": 92, "./isArrayLike": 112 }], 120: [function (require, module, exports) {
    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    module.exports = stubFalse;
  }, {}], 121: [function (require, module, exports) {
    /**
     * Helpers.
     */

    var s = 1000;
    var m = s * 60;
    var h = m * 60;
    var d = h * 24;
    var y = d * 365.25;

    /**
     * Parse or format the given `val`.
     *
     * Options:
     *
     *  - `long` verbose formatting [false]
     *
     * @param {String|Number} val
     * @param {Object} [options]
     * @throws {Error} throw an error if val is not a non-empty string or a number
     * @return {String|Number}
     * @api public
     */

    module.exports = function (val, options) {
      options = options || {};
      var type = typeof val === "undefined" ? "undefined" : _typeof(val);
      if (type === 'string' && val.length > 0) {
        return parse(val);
      } else if (type === 'number' && isNaN(val) === false) {
        return options.long ? fmtLong(val) : fmtShort(val);
      }
      throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
    };

    /**
     * Parse the given `str` and return milliseconds.
     *
     * @param {String} str
     * @return {Number}
     * @api private
     */

    function parse(str) {
      str = String(str);
      if (str.length > 100) {
        return;
      }
      var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
      if (!match) {
        return;
      }
      var n = parseFloat(match[1]);
      var type = (match[2] || 'ms').toLowerCase();
      switch (type) {
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
          return n * y;
        case 'days':
        case 'day':
        case 'd':
          return n * d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
          return n * h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
          return n * m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
          return n * s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
          return n;
        default:
          return undefined;
      }
    }

    /**
     * Short format for `ms`.
     *
     * @param {Number} ms
     * @return {String}
     * @api private
     */

    function fmtShort(ms) {
      if (ms >= d) {
        return Math.round(ms / d) + 'd';
      }
      if (ms >= h) {
        return Math.round(ms / h) + 'h';
      }
      if (ms >= m) {
        return Math.round(ms / m) + 'm';
      }
      if (ms >= s) {
        return Math.round(ms / s) + 's';
      }
      return ms + 'ms';
    }

    /**
     * Long format for `ms`.
     *
     * @param {Number} ms
     * @return {String}
     * @api private
     */

    function fmtLong(ms) {
      return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
    }

    /**
     * Pluralization helper.
     */

    function plural(ms, n, name) {
      if (ms < n) {
        return;
      }
      if (ms < n * 1.5) {
        return Math.floor(ms / n) + ' ' + name;
      }
      return Math.ceil(ms / n) + ' ' + name + 's';
    }
  }, {}], 122: [function (require, module, exports) {
    /*! @preserve
     * numeral.js
     * version : 2.0.6
     * author : Adam Draper
     * license : MIT
     * http://adamwdraper.github.com/Numeral-js/
     */

    (function (global, factory) {
      if (typeof define === 'function' && define.amd) {
        define(factory);
      } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
        module.exports = factory();
      } else {
        global.numeral = factory();
      }
    })(this, function () {
      /************************************
          Variables
      ************************************/

      var _numeral,
          _,
          VERSION = '2.0.6',
          formats = {},
          locales = {},
          defaults = {
        currentLocale: 'en',
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: '0,0',
        scalePercentBy100: true
      },
          options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
      };

      /************************************
          Constructors
      ************************************/

      // Numeral prototype object
      function Numeral(input, number) {
        this._input = input;

        this._value = number;
      }

      _numeral = function numeral(input) {
        var value, kind, unformatFunction, regexp;

        if (_numeral.isNumeral(input)) {
          value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
          value = 0;
        } else if (input === null || _.isNaN(input)) {
          value = null;
        } else if (typeof input === 'string') {
          if (options.zeroFormat && input === options.zeroFormat) {
            value = 0;
          } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
            value = null;
          } else {
            for (kind in formats) {
              regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

              if (regexp && input.match(regexp)) {
                unformatFunction = formats[kind].unformat;

                break;
              }
            }

            unformatFunction = unformatFunction || _numeral._.stringToNumber;

            value = unformatFunction(input);
          }
        } else {
          value = Number(input) || null;
        }

        return new Numeral(input, value);
      };

      // version number
      _numeral.version = VERSION;

      // compare numeral object
      _numeral.isNumeral = function (obj) {
        return obj instanceof Numeral;
      };

      // helper functions
      _numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function numberToFormat(value, format, roundingFunction) {
          var locale = locales[_numeral.options.currentLocale],
              negP = false,
              optDec = false,
              leadingCount = 0,
              abbr = '',
              trillion = 1000000000000,
              billion = 1000000000,
              million = 1000000,
              thousand = 1000,
              decimal = '',
              neg = false,
              abbrForce,
              // force abbreviation
          abs,
              min,
              max,
              power,
              int,
              precision,
              signed,
              thousands,
              output;

          // make sure we never format a null value
          value = value || 0;

          abs = Math.abs(value);

          // see if we should use parentheses for negative number or if we should prefix with a sign
          // if both are present we default to parentheses
          if (_numeral._.includes(format, '(')) {
            negP = true;
            format = format.replace(/[\(|\)]/g, '');
          } else if (_numeral._.includes(format, '+') || _numeral._.includes(format, '-')) {
            signed = _numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
            format = format.replace(/[\+|\-]/g, '');
          }

          // see if abbreviation is wanted
          if (_numeral._.includes(format, 'a')) {
            abbrForce = format.match(/a(k|m|b|t)?/);

            abbrForce = abbrForce ? abbrForce[1] : false;

            // check for space before abbreviation
            if (_numeral._.includes(format, ' a')) {
              abbr = ' ';
            }

            format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

            if (abs >= trillion && !abbrForce || abbrForce === 't') {
              // trillion
              abbr += locale.abbreviations.trillion;
              value = value / trillion;
            } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
              // billion
              abbr += locale.abbreviations.billion;
              value = value / billion;
            } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
              // million
              abbr += locale.abbreviations.million;
              value = value / million;
            } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
              // thousand
              abbr += locale.abbreviations.thousand;
              value = value / thousand;
            }
          }

          // check for optional decimals
          if (_numeral._.includes(format, '[.]')) {
            optDec = true;
            format = format.replace('[.]', '.');
          }

          // break number and format
          int = value.toString().split('.')[0];
          precision = format.split('.')[1];
          thousands = format.indexOf(',');
          leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

          if (precision) {
            if (_numeral._.includes(precision, '[')) {
              precision = precision.replace(']', '');
              precision = precision.split('[');
              decimal = _numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
            } else {
              decimal = _numeral._.toFixed(value, precision.length, roundingFunction);
            }

            int = decimal.split('.')[0];

            if (_numeral._.includes(decimal, '.')) {
              decimal = locale.delimiters.decimal + decimal.split('.')[1];
            } else {
              decimal = '';
            }

            if (optDec && Number(decimal.slice(1)) === 0) {
              decimal = '';
            }
          } else {
            int = _numeral._.toFixed(value, 0, roundingFunction);
          }

          // check abbreviation again after rounding
          if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
            int = String(Number(int) / 1000);

            switch (abbr) {
              case locale.abbreviations.thousand:
                abbr = locale.abbreviations.million;
                break;
              case locale.abbreviations.million:
                abbr = locale.abbreviations.billion;
                break;
              case locale.abbreviations.billion:
                abbr = locale.abbreviations.trillion;
                break;
            }
          }

          // format number
          if (_numeral._.includes(int, '-')) {
            int = int.slice(1);
            neg = true;
          }

          if (int.length < leadingCount) {
            for (var i = leadingCount - int.length; i > 0; i--) {
              int = '0' + int;
            }
          }

          if (thousands > -1) {
            int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
          }

          if (format.indexOf('.') === 0) {
            int = '';
          }

          output = int + decimal + (abbr ? abbr : '');

          if (negP) {
            output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
          } else {
            if (signed >= 0) {
              output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
            } else if (neg) {
              output = '-' + output;
            }
          }

          return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function stringToNumber(string) {
          var locale = locales[options.currentLocale],
              stringOriginal = string,
              abbreviations = {
            thousand: 3,
            million: 6,
            billion: 9,
            trillion: 12
          },
              abbreviation,
              value,
              i,
              regexp;

          if (options.zeroFormat && string === options.zeroFormat) {
            value = 0;
          } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
            value = null;
          } else {
            value = 1;

            if (locale.delimiters.decimal !== '.') {
              string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
            }

            for (abbreviation in abbreviations) {
              regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

              if (stringOriginal.match(regexp)) {
                value *= Math.pow(10, abbreviations[abbreviation]);
                break;
              }
            }

            // check for negative number
            value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

            // remove non numbers
            string = string.replace(/[^0-9\.]+/g, '');

            value *= Number(string);
          }

          return value;
        },
        isNaN: function (_isNaN) {
          function isNaN(_x2) {
            return _isNaN.apply(this, arguments);
          }

          isNaN.toString = function () {
            return _isNaN.toString();
          };

          return isNaN;
        }(function (value) {
          return typeof value === 'number' && isNaN(value);
        }),
        includes: function includes(string, search) {
          return string.indexOf(search) !== -1;
        },
        insert: function insert(string, subString, start) {
          return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function reduce(array, callback /*, initialValue*/) {
          if (this === null) {
            throw new TypeError('Array.prototype.reduce called on null or undefined');
          }

          if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
          }

          var t = Object(array),
              len = t.length >>> 0,
              k = 0,
              value;

          if (arguments.length === 3) {
            value = arguments[2];
          } else {
            while (k < len && !(k in t)) {
              k++;
            }

            if (k >= len) {
              throw new TypeError('Reduce of empty array with no initial value');
            }

            value = t[k++];
          }
          for (; k < len; k++) {
            if (k in t) {
              value = callback(value, t[k], k, t);
            }
          }
          return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function multiplier(x) {
          var parts = x.toString().split('.');

          return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function correctionFactor() {
          var args = Array.prototype.slice.call(arguments);

          return args.reduce(function (accum, next) {
            var mn = _.multiplier(next);
            return accum > mn ? accum : mn;
          }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function toFixed(value, maxDecimals, roundingFunction, optionals) {
          var splitValue = value.toString().split('.'),
              minDecimals = maxDecimals - (optionals || 0),
              boundedPrecision,
              optionalsRegExp,
              power,
              output;

          // Use the smallest precision value possible to avoid errors from floating point representation
          if (splitValue.length === 2) {
            boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
          } else {
            boundedPrecision = minDecimals;
          }

          power = Math.pow(10, boundedPrecision);

          // Multiply up by precision, round accurately, then divide and use native toFixed():
          output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

          if (optionals > maxDecimals - boundedPrecision) {
            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
            output = output.replace(optionalsRegExp, '');
          }

          return output;
        }
      };

      // avaliable options
      _numeral.options = options;

      // avaliable formats
      _numeral.formats = formats;

      // avaliable formats
      _numeral.locales = locales;

      // This function sets the current locale.  If
      // no arguments are passed in, it will simply return the current global
      // locale key.
      _numeral.locale = function (key) {
        if (key) {
          options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
      };

      // This function provides access to the loaded locale data.  If
      // no arguments are passed in, it will simply return the current
      // global locale object.
      _numeral.localeData = function (key) {
        if (!key) {
          return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
          throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
      };

      _numeral.reset = function () {
        for (var property in defaults) {
          options[property] = defaults[property];
        }
      };

      _numeral.zeroFormat = function (format) {
        options.zeroFormat = typeof format === 'string' ? format : null;
      };

      _numeral.nullFormat = function (format) {
        options.nullFormat = typeof format === 'string' ? format : null;
      };

      _numeral.defaultFormat = function (format) {
        options.defaultFormat = typeof format === 'string' ? format : '0.0';
      };

      _numeral.register = function (type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
          throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
      };

      _numeral.validate = function (val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;

        //coerce val to string
        if (typeof val !== 'string') {
          val += '';

          if (console.warn) {
            console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
          }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
          return true;
        }

        //if val is empty return false
        if (val === '') {
          return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
          //check if the culture is understood by numeral. if not, default it to current locale
          localeData = _numeral.localeData(culture);
        } catch (e) {
          localeData = _numeral.localeData(_numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
          _thousandSep = '\\.';
        } else {
          _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
          val = val.substr(1);
          if (temp[0] !== _currSymbol) {
            return false;
          }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
          val = val.slice(0, -1);
          if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
            return false;
          }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
          _valArray = val.split(_decimalSep);
          if (_valArray.length > 2) {
            return false;
          } else {
            if (_valArray.length < 2) {
              return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
            } else {
              if (_valArray[0].length === 1) {
                return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
              } else {
                return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
              }
            }
          }
        }

        return false;
      };

      /************************************
          Numeral Prototype
      ************************************/

      _numeral.fn = Numeral.prototype = {
        clone: function clone() {
          return _numeral(this);
        },
        format: function format(inputString, roundingFunction) {
          var value = this._value,
              format = inputString || options.defaultFormat,
              kind,
              output,
              formatFunction;

          // make sure we have a roundingFunction
          roundingFunction = roundingFunction || Math.round;

          // format based on value
          if (value === 0 && options.zeroFormat !== null) {
            output = options.zeroFormat;
          } else if (value === null && options.nullFormat !== null) {
            output = options.nullFormat;
          } else {
            for (kind in formats) {
              if (format.match(formats[kind].regexps.format)) {
                formatFunction = formats[kind].format;

                break;
              }
            }

            formatFunction = formatFunction || _numeral._.numberToFormat;

            output = formatFunction(value, format, roundingFunction);
          }

          return output;
        },
        value: function value() {
          return this._value;
        },
        input: function input() {
          return this._input;
        },
        set: function set(value) {
          this._value = Number(value);

          return this;
        },
        add: function add(value) {
          var corrFactor = _.correctionFactor.call(null, this._value, value);

          function cback(accum, curr, currI, O) {
            return accum + Math.round(corrFactor * curr);
          }

          this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

          return this;
        },
        subtract: function subtract(value) {
          var corrFactor = _.correctionFactor.call(null, this._value, value);

          function cback(accum, curr, currI, O) {
            return accum - Math.round(corrFactor * curr);
          }

          this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

          return this;
        },
        multiply: function multiply(value) {
          function cback(accum, curr, currI, O) {
            var corrFactor = _.correctionFactor(accum, curr);
            return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
          }

          this._value = _.reduce([this._value, value], cback, 1);

          return this;
        },
        divide: function divide(value) {
          function cback(accum, curr, currI, O) {
            var corrFactor = _.correctionFactor(accum, curr);
            return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
          }

          this._value = _.reduce([this._value, value], cback);

          return this;
        },
        difference: function difference(value) {
          return Math.abs(_numeral(this._value).subtract(value).value());
        }
      };

      /************************************
          Default Locale && Format
      ************************************/

      _numeral.register('locale', 'en', {
        delimiters: {
          thousands: ',',
          decimal: '.'
        },
        abbreviations: {
          thousand: 'k',
          million: 'm',
          billion: 'b',
          trillion: 't'
        },
        ordinal: function ordinal(number) {
          var b = number % 10;
          return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        },
        currency: {
          symbol: '$'
        }
      });

      (function () {
        _numeral.register('format', 'bps', {
          regexps: {
            format: /(BPS)/,
            unformat: /(BPS)/
          },
          format: function format(value, _format, roundingFunction) {
            var space = _numeral._.includes(_format, ' BPS') ? ' ' : '',
                output;

            value = value * 10000;

            // check for space before BPS
            _format = _format.replace(/\s?BPS/, '');

            output = _numeral._.numberToFormat(value, _format, roundingFunction);

            if (_numeral._.includes(output, ')')) {
              output = output.split('');

              output.splice(-1, 0, space + 'BPS');

              output = output.join('');
            } else {
              output = output + space + 'BPS';
            }

            return output;
          },
          unformat: function unformat(string) {
            return +(_numeral._.stringToNumber(string) * 0.0001).toFixed(15);
          }
        });
      })();

      (function () {
        var decimal = {
          base: 1000,
          suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
            binary = {
          base: 1024,
          suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function (item) {
          return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

        _numeral.register('format', 'bytes', {
          regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
          },
          format: function format(value, _format2, roundingFunction) {
            var output,
                bytes = _numeral._.includes(_format2, 'ib') ? binary : decimal,
                suffix = _numeral._.includes(_format2, ' b') || _numeral._.includes(_format2, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            _format2 = _format2.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
              min = Math.pow(bytes.base, power);
              max = Math.pow(bytes.base, power + 1);

              if (value === null || value === 0 || value >= min && value < max) {
                suffix += bytes.suffixes[power];

                if (min > 0) {
                  value = value / min;
                }

                break;
              }
            }

            output = _numeral._.numberToFormat(value, _format2, roundingFunction);

            return output + suffix;
          },
          unformat: function unformat(string) {
            var value = _numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
              for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                if (_numeral._.includes(string, decimal.suffixes[power])) {
                  bytesMultiplier = Math.pow(decimal.base, power);

                  break;
                }

                if (_numeral._.includes(string, binary.suffixes[power])) {
                  bytesMultiplier = Math.pow(binary.base, power);

                  break;
                }
              }

              value *= bytesMultiplier || 1;
            }

            return value;
          }
        });
      })();

      (function () {
        _numeral.register('format', 'currency', {
          regexps: {
            format: /(\$)/
          },
          format: function format(value, _format3, roundingFunction) {
            var locale = _numeral.locales[_numeral.options.currentLocale],
                symbols = {
              before: _format3.match(/^([\+|\-|\(|\s|\$]*)/)[0],
              after: _format3.match(/([\+|\-|\)|\s|\$]*)$/)[0]
            },
                output,
                symbol,
                i;

            // strip format of spaces and $
            _format3 = _format3.replace(/\s?\$\s?/, '');

            // format the number
            output = _numeral._.numberToFormat(value, _format3, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
              symbols.before = symbols.before.replace(/[\-\(]/, '');
              symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && !_numeral._.includes(symbols.before, '-') && !_numeral._.includes(symbols.before, '(')) {
              symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
              symbol = symbols.before[i];

              switch (symbol) {
                case '$':
                  output = _numeral._.insert(output, locale.currency.symbol, i);
                  break;
                case ' ':
                  output = _numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                  break;
              }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
              symbol = symbols.after[i];

              switch (symbol) {
                case '$':
                  output = i === symbols.after.length - 1 ? output + locale.currency.symbol : _numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                  break;
                case ' ':
                  output = i === symbols.after.length - 1 ? output + ' ' : _numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                  break;
              }
            }

            return output;
          }
        });
      })();

      (function () {
        _numeral.register('format', 'exponential', {
          regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
          },
          format: function format(value, _format4, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !_numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            _format4 = _format4.replace(/e[\+|\-]{1}0/, '');

            output = _numeral._.numberToFormat(Number(parts[0]), _format4, roundingFunction);

            return output + 'e' + parts[1];
          },
          unformat: function unformat(string) {
            var parts = _numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = _numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
              var corrFactor = _numeral._.correctionFactor(accum, curr),
                  num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
              return num;
            }

            return _numeral._.reduce([value, Math.pow(10, power)], cback, 1);
          }
        });
      })();

      (function () {
        _numeral.register('format', 'ordinal', {
          regexps: {
            format: /(o)/
          },
          format: function format(value, _format5, roundingFunction) {
            var locale = _numeral.locales[_numeral.options.currentLocale],
                output,
                ordinal = _numeral._.includes(_format5, ' o') ? ' ' : '';

            // check for space before
            _format5 = _format5.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = _numeral._.numberToFormat(value, _format5, roundingFunction);

            return output + ordinal;
          }
        });
      })();

      (function () {
        _numeral.register('format', 'percentage', {
          regexps: {
            format: /(%)/,
            unformat: /(%)/
          },
          format: function format(value, _format6, roundingFunction) {
            var space = _numeral._.includes(_format6, ' %') ? ' ' : '',
                output;

            if (_numeral.options.scalePercentBy100) {
              value = value * 100;
            }

            // check for space before %
            _format6 = _format6.replace(/\s?\%/, '');

            output = _numeral._.numberToFormat(value, _format6, roundingFunction);

            if (_numeral._.includes(output, ')')) {
              output = output.split('');

              output.splice(-1, 0, space + '%');

              output = output.join('');
            } else {
              output = output + space + '%';
            }

            return output;
          },
          unformat: function unformat(string) {
            var number = _numeral._.stringToNumber(string);
            if (_numeral.options.scalePercentBy100) {
              return number * 0.01;
            }
            return number;
          }
        });
      })();

      (function () {
        _numeral.register('format', 'time', {
          regexps: {
            format: /(:)/,
            unformat: /(:)/
          },
          format: function format(value, _format7, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - hours * 60 * 60) / 60),
                seconds = Math.round(value - hours * 60 * 60 - minutes * 60);

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
          },
          unformat: function unformat(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
              // hours
              seconds = seconds + Number(timeArray[0]) * 60 * 60;
              // minutes
              seconds = seconds + Number(timeArray[1]) * 60;
              // seconds
              seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
              // minutes
              seconds = seconds + Number(timeArray[0]) * 60;
              // seconds
              seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
          }
        });
      })();

      return _numeral;
    });
  }, {}], 123: [function (require, module, exports) {
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;

    function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
      throw new Error('clearTimeout has not been defined');
    }
    (function () {
      try {
        if (typeof setTimeout === 'function') {
          cachedSetTimeout = setTimeout;
        } else {
          cachedSetTimeout = defaultSetTimout;
        }
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }
      try {
        if (typeof clearTimeout === 'function') {
          cachedClearTimeout = clearTimeout;
        } else {
          cachedClearTimeout = defaultClearTimeout;
        }
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    })();
    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }
    function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
          return cachedClearTimeout.call(null, marker);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
          // Some versions of I.E. have different rules for clearTimeout vs setTimeout
          return cachedClearTimeout.call(this, marker);
        }
      }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;

    function cleanUpNextTick() {
      if (!draining || !currentQueue) {
        return;
      }
      draining = false;
      if (currentQueue.length) {
        queue = currentQueue.concat(queue);
      } else {
        queueIndex = -1;
      }
      if (queue.length) {
        drainQueue();
      }
    }

    function drainQueue() {
      if (draining) {
        return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;

      var len = queue.length;
      while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
          if (currentQueue) {
            currentQueue[queueIndex].run();
          }
        }
        queueIndex = -1;
        len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
    }

    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
      }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
      this.fun = fun;
      this.array = array;
    }
    Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};

    function noop() {}

    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;

    process.listeners = function (name) {
      return [];
    };

    process.binding = function (name) {
      throw new Error('process.binding is not supported');
    };

    process.cwd = function () {
      return '/';
    };
    process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
    };
    process.umask = function () {
      return 0;
    };
  }, {}], 124: [function (require, module, exports) {
    (function (global) {
      /*! smooth-scroll v12.1.5 | (c) 2017 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */
      !function (e, t) {
        "function" == typeof define && define.amd ? define([], function () {
          return t(e);
        }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = t(e) : e.SmoothScroll = t(e);
      }("undefined" != typeof global ? global : "undefined" != typeof window ? window : this, function (e) {
        "use strict";
        var t = "querySelector" in document && "addEventListener" in e && "requestAnimationFrame" in e && "closest" in e.Element.prototype,
            n = { ignore: "[data-scroll-ignore]", header: null, speed: 500, offset: 0, easing: "easeInOutCubic", customEasing: null, before: function before() {}, after: function after() {} },
            o = function o() {
          for (var e = {}, t = 0, n = arguments.length; t < n; t++) {
            var o = arguments[t];!function (t) {
              for (var n in t) {
                t.hasOwnProperty(n) && (e[n] = t[n]);
              }
            }(o);
          }return e;
        },
            a = function a(t) {
          return parseInt(e.getComputedStyle(t).height, 10);
        },
            r = function r(e) {
          "#" === e.charAt(0) && (e = e.substr(1));for (var t, n = String(e), o = n.length, a = -1, r = "", i = n.charCodeAt(0); ++a < o;) {
            if (0 === (t = n.charCodeAt(a))) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");t >= 1 && t <= 31 || 127 == t || 0 === a && t >= 48 && t <= 57 || 1 === a && t >= 48 && t <= 57 && 45 === i ? r += "\\" + t.toString(16) + " " : r += t >= 128 || 45 === t || 95 === t || t >= 48 && t <= 57 || t >= 65 && t <= 90 || t >= 97 && t <= 122 ? n.charAt(a) : "\\" + n.charAt(a);
          }return "#" + r;
        },
            i = function i(e, t) {
          var n;return "easeInQuad" === e.easing && (n = t * t), "easeOutQuad" === e.easing && (n = t * (2 - t)), "easeInOutQuad" === e.easing && (n = t < .5 ? 2 * t * t : (4 - 2 * t) * t - 1), "easeInCubic" === e.easing && (n = t * t * t), "easeOutCubic" === e.easing && (n = --t * t * t + 1), "easeInOutCubic" === e.easing && (n = t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1), "easeInQuart" === e.easing && (n = t * t * t * t), "easeOutQuart" === e.easing && (n = 1 - --t * t * t * t), "easeInOutQuart" === e.easing && (n = t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t), "easeInQuint" === e.easing && (n = t * t * t * t * t), "easeOutQuint" === e.easing && (n = 1 + --t * t * t * t * t), "easeInOutQuint" === e.easing && (n = t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t), e.customEasing && (n = e.customEasing(t)), n || t;
        },
            u = function u() {
          return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
        },
            c = function c(e, t, n) {
          var o = 0;if (e.offsetParent) do {
            o += e.offsetTop, e = e.offsetParent;
          } while (e);return o = Math.max(o - t - n, 0);
        },
            s = function s(e) {
          return e ? a(e) + e.offsetTop : 0;
        },
            l = function l(t, n, o) {
          o || (t.focus(), document.activeElement.id !== t.id && (t.setAttribute("tabindex", "-1"), t.focus(), t.style.outline = "none"), e.scrollTo(0, n));
        },
            f = function f(t) {
          return !!("matchMedia" in e && e.matchMedia("(prefers-reduced-motion)").matches);
        };return function (a, d) {
          var m,
              h,
              g,
              p,
              v,
              b,
              y,
              S = {};S.cancelScroll = function () {
            cancelAnimationFrame(y);
          }, S.animateScroll = function (t, a, r) {
            var f = o(m || n, r || {}),
                d = "[object Number]" === Object.prototype.toString.call(t),
                h = d || !t.tagName ? null : t;if (d || h) {
              var g = e.pageYOffset;f.header && !p && (p = document.querySelector(f.header)), v || (v = s(p));var b,
                  y,
                  E,
                  I = d ? t : c(h, v, parseInt("function" == typeof f.offset ? f.offset() : f.offset, 10)),
                  O = I - g,
                  A = u(),
                  C = 0,
                  w = function w(n, o) {
                var r = e.pageYOffset;if (n == o || r == o || (g < o && e.innerHeight + r) >= A) return S.cancelScroll(), l(t, o, d), f.after(t, a), b = null, !0;
              },
                  Q = function Q(t) {
                b || (b = t), C += t - b, y = C / parseInt(f.speed, 10), y = y > 1 ? 1 : y, E = g + O * i(f, y), e.scrollTo(0, Math.floor(E)), w(E, I) || (e.requestAnimationFrame(Q), b = t);
              };0 === e.pageYOffset && e.scrollTo(0, 0), f.before(t, a), S.cancelScroll(), e.requestAnimationFrame(Q);
            }
          };var E = function E(e) {
            h && (h.id = h.getAttribute("data-scroll-id"), S.animateScroll(h, g), h = null, g = null);
          },
              I = function I(t) {
            if (!f() && 0 === t.button && !t.metaKey && !t.ctrlKey && (g = t.target.closest(a)) && "a" === g.tagName.toLowerCase() && !t.target.closest(m.ignore) && g.hostname === e.location.hostname && g.pathname === e.location.pathname && /#/.test(g.href)) {
              var n;try {
                n = r(decodeURIComponent(g.hash));
              } catch (e) {
                n = r(g.hash);
              }if ("#" === n) {
                t.preventDefault(), h = document.body;var o = h.id ? h.id : "smooth-scroll-top";return h.setAttribute("data-scroll-id", o), h.id = "", void (e.location.hash.substring(1) === o ? E() : e.location.hash = o);
              }h = document.querySelector(n), h && (h.setAttribute("data-scroll-id", h.id), h.id = "", g.hash === e.location.hash && (t.preventDefault(), E()));
            }
          },
              O = function O(e) {
            b || (b = setTimeout(function () {
              b = null, v = s(p);
            }, 66));
          };return S.destroy = function () {
            m && (document.removeEventListener("click", I, !1), e.removeEventListener("resize", O, !1), S.cancelScroll(), m = null, h = null, g = null, p = null, v = null, b = null, y = null);
          }, S.init = function (a) {
            t && (S.destroy(), m = o(n, a || {}), p = m.header ? document.querySelector(m.header) : null, v = s(p), document.addEventListener("click", I, !1), e.addEventListener("hashchange", E, !1), p && e.addEventListener("resize", O, !1));
          }, S.init(d), S;
        };
      });
    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  }, {}], 125: [function (require, module, exports) {
    (function (setImmediate, clearImmediate) {
      var nextTick = require('process/browser.js').nextTick;
      var apply = Function.prototype.apply;
      var slice = Array.prototype.slice;
      var immediateIds = {};
      var nextImmediateId = 0;

      // DOM APIs, for completeness

      exports.setTimeout = function () {
        return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
      };
      exports.setInterval = function () {
        return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
      };
      exports.clearTimeout = exports.clearInterval = function (timeout) {
        timeout.close();
      };

      function Timeout(id, clearFn) {
        this._id = id;
        this._clearFn = clearFn;
      }
      Timeout.prototype.unref = Timeout.prototype.ref = function () {};
      Timeout.prototype.close = function () {
        this._clearFn.call(window, this._id);
      };

      // Does not start the time, just sets up the members needed.
      exports.enroll = function (item, msecs) {
        clearTimeout(item._idleTimeoutId);
        item._idleTimeout = msecs;
      };

      exports.unenroll = function (item) {
        clearTimeout(item._idleTimeoutId);
        item._idleTimeout = -1;
      };

      exports._unrefActive = exports.active = function (item) {
        clearTimeout(item._idleTimeoutId);

        var msecs = item._idleTimeout;
        if (msecs >= 0) {
          item._idleTimeoutId = setTimeout(function onTimeout() {
            if (item._onTimeout) item._onTimeout();
          }, msecs);
        }
      };

      // That's not how node.js implements it but the exposed api is the same.
      exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function (fn) {
        var id = nextImmediateId++;
        var args = arguments.length < 2 ? false : slice.call(arguments, 1);

        immediateIds[id] = true;

        nextTick(function onNextTick() {
          if (immediateIds[id]) {
            // fn.call() is faster so we optimize for the common use-case
            // @see http://jsperf.com/call-apply-segu
            if (args) {
              fn.apply(null, args);
            } else {
              fn.call(null);
            }
            // Prevent ids from leaking
            exports.clearImmediate(id);
          }
        });

        return id;
      };

      exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function (id) {
        delete immediateIds[id];
      };
    }).call(this, require("timers").setImmediate, require("timers").clearImmediate);
  }, { "process/browser.js": 123, "timers": 125 }], 126: [function (require, module, exports) {
    var Vue; // late bind
    var version;
    var map = window.__VUE_HOT_MAP__ = Object.create(null);
    var installed = false;
    var isBrowserify = false;
    var initHookName = 'beforeCreate';

    exports.install = function (vue, browserify) {
      if (installed) {
        return;
      }
      installed = true;

      Vue = vue.__esModule ? vue.default : vue;
      version = Vue.version.split('.').map(Number);
      isBrowserify = browserify;

      // compat with < 2.0.0-alpha.7
      if (Vue.config._lifecycleHooks.indexOf('init') > -1) {
        initHookName = 'init';
      }

      exports.compatible = version[0] >= 2;
      if (!exports.compatible) {
        console.warn('[HMR] You are using a version of vue-hot-reload-api that is ' + 'only compatible with Vue.js core ^2.0.0.');
        return;
      }
    };

    /**
     * Create a record for a hot module, which keeps track of its constructor
     * and instances
     *
     * @param {String} id
     * @param {Object} options
     */

    exports.createRecord = function (id, options) {
      if (map[id]) {
        return;
      }

      var Ctor = null;
      if (typeof options === 'function') {
        Ctor = options;
        options = Ctor.options;
      }
      makeOptionsHot(id, options);
      map[id] = {
        Ctor: Ctor,
        options: options,
        instances: []
      };
    };

    /**
     * Check if module is recorded
     *
     * @param {String} id
     */

    exports.isRecorded = function (id) {
      return typeof map[id] !== 'undefined';
    };

    /**
     * Make a Component options object hot.
     *
     * @param {String} id
     * @param {Object} options
     */

    function makeOptionsHot(id, options) {
      if (options.functional) {
        var render = options.render;
        options.render = function (h, ctx) {
          var instances = map[id].instances;
          if (ctx && instances.indexOf(ctx.parent) < 0) {
            instances.push(ctx.parent);
          }
          return render(h, ctx);
        };
      } else {
        injectHook(options, initHookName, function () {
          var record = map[id];
          if (!record.Ctor) {
            record.Ctor = this.constructor;
          }
          record.instances.push(this);
        });
        injectHook(options, 'beforeDestroy', function () {
          var instances = map[id].instances;
          instances.splice(instances.indexOf(this), 1);
        });
      }
    }

    /**
     * Inject a hook to a hot reloadable component so that
     * we can keep track of it.
     *
     * @param {Object} options
     * @param {String} name
     * @param {Function} hook
     */

    function injectHook(options, name, hook) {
      var existing = options[name];
      options[name] = existing ? Array.isArray(existing) ? existing.concat(hook) : [existing, hook] : [hook];
    }

    function tryWrap(fn) {
      return function (id, arg) {
        try {
          fn(id, arg);
        } catch (e) {
          console.error(e);
          console.warn('Something went wrong during Vue component hot-reload. Full reload required.');
        }
      };
    }

    function updateOptions(oldOptions, newOptions) {
      for (var key in oldOptions) {
        if (!(key in newOptions)) {
          delete oldOptions[key];
        }
      }
      for (var key$1 in newOptions) {
        oldOptions[key$1] = newOptions[key$1];
      }
    }

    exports.rerender = tryWrap(function (id, options) {
      var record = map[id];
      if (!options) {
        record.instances.slice().forEach(function (instance) {
          instance.$forceUpdate();
        });
        return;
      }
      if (typeof options === 'function') {
        options = options.options;
      }
      if (record.Ctor) {
        record.Ctor.options.render = options.render;
        record.Ctor.options.staticRenderFns = options.staticRenderFns;
        record.instances.slice().forEach(function (instance) {
          instance.$options.render = options.render;
          instance.$options.staticRenderFns = options.staticRenderFns;
          // reset static trees
          // pre 2.5, all static trees are cahced together on the instance
          if (instance._staticTrees) {
            instance._staticTrees = [];
          }
          // 2.5.0
          if (Array.isArray(record.Ctor.options.cached)) {
            record.Ctor.options.cached = [];
          }
          // 2.5.3
          if (Array.isArray(instance.$options.cached)) {
            instance.$options.cached = [];
          }
          // post 2.5.4: v-once trees are cached on instance._staticTrees.
          // Pure static trees are cached on the staticRenderFns array
          // (both already reset above)
          instance.$forceUpdate();
        });
      } else {
        // functional or no instance created yet
        record.options.render = options.render;
        record.options.staticRenderFns = options.staticRenderFns;

        // handle functional component re-render
        if (record.options.functional) {
          // rerender with full options
          if (Object.keys(options).length > 2) {
            updateOptions(record.options, options);
          } else {
            // template-only rerender.
            // need to inject the style injection code for CSS modules
            // to work properly.
            var injectStyles = record.options._injectStyles;
            if (injectStyles) {
              var render = options.render;
              record.options.render = function (h, ctx) {
                injectStyles.call(ctx);
                return render(h, ctx);
              };
            }
          }
          record.options._Ctor = null;
          // 2.5.3
          if (Array.isArray(record.options.cached)) {
            record.options.cached = [];
          }
          record.instances.slice().forEach(function (instance) {
            instance.$forceUpdate();
          });
        }
      }
    });

    exports.reload = tryWrap(function (id, options) {
      var record = map[id];
      if (options) {
        if (typeof options === 'function') {
          options = options.options;
        }
        makeOptionsHot(id, options);
        if (record.Ctor) {
          if (version[1] < 2) {
            // preserve pre 2.2 behavior for global mixin handling
            record.Ctor.extendOptions = options;
          }
          var newCtor = record.Ctor.super.extend(options);
          record.Ctor.options = newCtor.options;
          record.Ctor.cid = newCtor.cid;
          record.Ctor.prototype = newCtor.prototype;
          if (newCtor.release) {
            // temporary global mixin strategy used in < 2.0.0-alpha.6
            newCtor.release();
          }
        } else {
          updateOptions(record.options, options);
        }
      }
      record.instances.slice().forEach(function (instance) {
        if (instance.$vnode && instance.$vnode.context) {
          instance.$vnode.context.$forceUpdate();
        } else {
          console.warn('Root or manually mounted instance modified. Full reload required.');
        }
      });
    });
  }, {}], 127: [function (require, module, exports) {
    (function (process, global, setImmediate) {
      /*!
       * Vue.js v2.5.16
       * (c) 2014-2018 Evan You
       * Released under the MIT License.
       */
      'use strict';

      /*  */

      var emptyObject = Object.freeze({});

      // these helpers produces better vm code in JS engines due to their
      // explicitness and function inlining
      function isUndef(v) {
        return v === undefined || v === null;
      }

      function isDef(v) {
        return v !== undefined && v !== null;
      }

      function isTrue(v) {
        return v === true;
      }

      function isFalse(v) {
        return v === false;
      }

      /**
       * Check if value is primitive
       */
      function isPrimitive(value) {
        return typeof value === 'string' || typeof value === 'number' ||
        // $flow-disable-line
        (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'symbol' || typeof value === 'boolean';
      }

      /**
       * Quick object check - this is primarily used to tell
       * Objects from primitive values when we know the value
       * is a JSON-compliant type.
       */
      function isObject(obj) {
        return obj !== null && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object';
      }

      /**
       * Get the raw type string of a value e.g. [object Object]
       */
      var _toString = Object.prototype.toString;

      function toRawType(value) {
        return _toString.call(value).slice(8, -1);
      }

      /**
       * Strict object type check. Only returns true
       * for plain JavaScript objects.
       */
      function isPlainObject(obj) {
        return _toString.call(obj) === '[object Object]';
      }

      function isRegExp(v) {
        return _toString.call(v) === '[object RegExp]';
      }

      /**
       * Check if val is a valid array index.
       */
      function isValidArrayIndex(val) {
        var n = parseFloat(String(val));
        return n >= 0 && Math.floor(n) === n && isFinite(val);
      }

      /**
       * Convert a value to a string that is actually rendered.
       */
      function toString(val) {
        return val == null ? '' : (typeof val === "undefined" ? "undefined" : _typeof(val)) === 'object' ? JSON.stringify(val, null, 2) : String(val);
      }

      /**
       * Convert a input value to a number for persistence.
       * If the conversion fails, return original string.
       */
      function toNumber(val) {
        var n = parseFloat(val);
        return isNaN(n) ? val : n;
      }

      /**
       * Make a map and return a function for checking if a key
       * is in that map.
       */
      function makeMap(str, expectsLowerCase) {
        var map = Object.create(null);
        var list = str.split(',');
        for (var i = 0; i < list.length; i++) {
          map[list[i]] = true;
        }
        return expectsLowerCase ? function (val) {
          return map[val.toLowerCase()];
        } : function (val) {
          return map[val];
        };
      }

      /**
       * Check if a tag is a built-in tag.
       */
      var isBuiltInTag = makeMap('slot,component', true);

      /**
       * Check if a attribute is a reserved attribute.
       */
      var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

      /**
       * Remove an item from an array
       */
      function remove(arr, item) {
        if (arr.length) {
          var index = arr.indexOf(item);
          if (index > -1) {
            return arr.splice(index, 1);
          }
        }
      }

      /**
       * Check whether the object has the property.
       */
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      function hasOwn(obj, key) {
        return hasOwnProperty.call(obj, key);
      }

      /**
       * Create a cached version of a pure function.
       */
      function cached(fn) {
        var cache = Object.create(null);
        return function cachedFn(str) {
          var hit = cache[str];
          return hit || (cache[str] = fn(str));
        };
      }

      /**
       * Camelize a hyphen-delimited string.
       */
      var camelizeRE = /-(\w)/g;
      var camelize = cached(function (str) {
        return str.replace(camelizeRE, function (_, c) {
          return c ? c.toUpperCase() : '';
        });
      });

      /**
       * Capitalize a string.
       */
      var capitalize = cached(function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      });

      /**
       * Hyphenate a camelCase string.
       */
      var hyphenateRE = /\B([A-Z])/g;
      var hyphenate = cached(function (str) {
        return str.replace(hyphenateRE, '-$1').toLowerCase();
      });

      /**
       * Simple bind polyfill for environments that do not support it... e.g.
       * PhantomJS 1.x. Technically we don't need this anymore since native bind is
       * now more performant in most browsers, but removing it would be breaking for
       * code that was able to run in PhantomJS 1.x, so this must be kept for
       * backwards compatibility.
       */

      /* istanbul ignore next */
      function polyfillBind(fn, ctx) {
        function boundFn(a) {
          var l = arguments.length;
          return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
        }

        boundFn._length = fn.length;
        return boundFn;
      }

      function nativeBind(fn, ctx) {
        return fn.bind(ctx);
      }

      var bind = Function.prototype.bind ? nativeBind : polyfillBind;

      /**
       * Convert an Array-like object to a real Array.
       */
      function toArray(list, start) {
        start = start || 0;
        var i = list.length - start;
        var ret = new Array(i);
        while (i--) {
          ret[i] = list[i + start];
        }
        return ret;
      }

      /**
       * Mix properties into target object.
       */
      function extend(to, _from) {
        for (var key in _from) {
          to[key] = _from[key];
        }
        return to;
      }

      /**
       * Merge an Array of Objects into a single Object.
       */
      function toObject(arr) {
        var res = {};
        for (var i = 0; i < arr.length; i++) {
          if (arr[i]) {
            extend(res, arr[i]);
          }
        }
        return res;
      }

      /**
       * Perform no operation.
       * Stubbing args to make Flow happy without leaving useless transpiled code
       * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
       */
      function noop(a, b, c) {}

      /**
       * Always return false.
       */
      var no = function no(a, b, c) {
        return false;
      };

      /**
       * Return same value
       */
      var identity = function identity(_) {
        return _;
      };

      /**
       * Generate a static keys string from compiler modules.
       */

      /**
       * Check if two values are loosely equal - that is,
       * if they are plain objects, do they have the same shape?
       */
      function looseEqual(a, b) {
        if (a === b) {
          return true;
        }
        var isObjectA = isObject(a);
        var isObjectB = isObject(b);
        if (isObjectA && isObjectB) {
          try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
              return a.length === b.length && a.every(function (e, i) {
                return looseEqual(e, b[i]);
              });
            } else if (!isArrayA && !isArrayB) {
              var keysA = Object.keys(a);
              var keysB = Object.keys(b);
              return keysA.length === keysB.length && keysA.every(function (key) {
                return looseEqual(a[key], b[key]);
              });
            } else {
              /* istanbul ignore next */
              return false;
            }
          } catch (e) {
            /* istanbul ignore next */
            return false;
          }
        } else if (!isObjectA && !isObjectB) {
          return String(a) === String(b);
        } else {
          return false;
        }
      }

      function looseIndexOf(arr, val) {
        for (var i = 0; i < arr.length; i++) {
          if (looseEqual(arr[i], val)) {
            return i;
          }
        }
        return -1;
      }

      /**
       * Ensure a function is called only once.
       */
      function once(fn) {
        var called = false;
        return function () {
          if (!called) {
            called = true;
            fn.apply(this, arguments);
          }
        };
      }

      var SSR_ATTR = 'data-server-rendered';

      var ASSET_TYPES = ['component', 'directive', 'filter'];

      var LIFECYCLE_HOOKS = ['beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed', 'activated', 'deactivated', 'errorCaptured'];

      /*  */

      var config = {
        /**
         * Option merge strategies (used in core/util/options)
         */
        // $flow-disable-line
        optionMergeStrategies: Object.create(null),

        /**
         * Whether to suppress warnings.
         */
        silent: false,

        /**
         * Show production mode tip message on boot?
         */
        productionTip: process.env.NODE_ENV !== 'production',

        /**
         * Whether to enable devtools
         */
        devtools: process.env.NODE_ENV !== 'production',

        /**
         * Whether to record perf
         */
        performance: false,

        /**
         * Error handler for watcher errors
         */
        errorHandler: null,

        /**
         * Warn handler for watcher warns
         */
        warnHandler: null,

        /**
         * Ignore certain custom elements
         */
        ignoredElements: [],

        /**
         * Custom user key aliases for v-on
         */
        // $flow-disable-line
        keyCodes: Object.create(null),

        /**
         * Check if a tag is reserved so that it cannot be registered as a
         * component. This is platform-dependent and may be overwritten.
         */
        isReservedTag: no,

        /**
         * Check if an attribute is reserved so that it cannot be used as a component
         * prop. This is platform-dependent and may be overwritten.
         */
        isReservedAttr: no,

        /**
         * Check if a tag is an unknown element.
         * Platform-dependent.
         */
        isUnknownElement: no,

        /**
         * Get the namespace of an element
         */
        getTagNamespace: noop,

        /**
         * Parse the real tag name for the specific platform.
         */
        parsePlatformTagName: identity,

        /**
         * Check if an attribute must be bound using property, e.g. value
         * Platform-dependent.
         */
        mustUseProp: no,

        /**
         * Exposed for legacy reasons
         */
        _lifecycleHooks: LIFECYCLE_HOOKS
      };

      /*  */

      /**
       * Check if a string starts with $ or _
       */
      function isReserved(str) {
        var c = (str + '').charCodeAt(0);
        return c === 0x24 || c === 0x5F;
      }

      /**
       * Define a property.
       */
      function def(obj, key, val, enumerable) {
        Object.defineProperty(obj, key, {
          value: val,
          enumerable: !!enumerable,
          writable: true,
          configurable: true
        });
      }

      /**
       * Parse simple path.
       */
      var bailRE = /[^\w.$]/;
      function parsePath(path) {
        if (bailRE.test(path)) {
          return;
        }
        var segments = path.split('.');
        return function (obj) {
          for (var i = 0; i < segments.length; i++) {
            if (!obj) {
              return;
            }
            obj = obj[segments[i]];
          }
          return obj;
        };
      }

      /*  */

      // can we use __proto__?
      var hasProto = '__proto__' in {};

      // Browser environment sniffing
      var inBrowser = typeof window !== 'undefined';
      var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
      var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
      var UA = inBrowser && window.navigator.userAgent.toLowerCase();
      var isIE = UA && /msie|trident/.test(UA);
      var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
      var isEdge = UA && UA.indexOf('edge/') > 0;
      var isAndroid = UA && UA.indexOf('android') > 0 || weexPlatform === 'android';
      var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA) || weexPlatform === 'ios';
      var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

      // Firefox has a "watch" function on Object.prototype...
      var nativeWatch = {}.watch;

      var supportsPassive = false;
      if (inBrowser) {
        try {
          var opts = {};
          Object.defineProperty(opts, 'passive', {
            get: function get() {
              /* istanbul ignore next */
              supportsPassive = true;
            }
          }); // https://github.com/facebook/flow/issues/285
          window.addEventListener('test-passive', null, opts);
        } catch (e) {}
      }

      // this needs to be lazy-evaled because vue may be required before
      // vue-server-renderer can set VUE_ENV
      var _isServer;
      var isServerRendering = function isServerRendering() {
        if (_isServer === undefined) {
          /* istanbul ignore if */
          if (!inBrowser && !inWeex && typeof global !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer = global['process'].env.VUE_ENV === 'server';
          } else {
            _isServer = false;
          }
        }
        return _isServer;
      };

      // detect devtools
      var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

      /* istanbul ignore next */
      function isNative(Ctor) {
        return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
      }

      var hasSymbol = typeof Symbol !== 'undefined' && isNative(Symbol) && typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

      var _Set;
      /* istanbul ignore if */ // $flow-disable-line
      if (typeof Set !== 'undefined' && isNative(Set)) {
        // use native Set when available.
        _Set = Set;
      } else {
        // a non-standard Set polyfill that only works with primitive keys.
        _Set = function () {
          function Set() {
            this.set = Object.create(null);
          }
          Set.prototype.has = function has(key) {
            return this.set[key] === true;
          };
          Set.prototype.add = function add(key) {
            this.set[key] = true;
          };
          Set.prototype.clear = function clear() {
            this.set = Object.create(null);
          };

          return Set;
        }();
      }

      /*  */

      var warn = noop;
      var tip = noop;
      var generateComponentTrace = noop; // work around flow check
      var formatComponentName = noop;

      if (process.env.NODE_ENV !== 'production') {
        var hasConsole = typeof console !== 'undefined';
        var classifyRE = /(?:^|[-_])(\w)/g;
        var classify = function classify(str) {
          return str.replace(classifyRE, function (c) {
            return c.toUpperCase();
          }).replace(/[-_]/g, '');
        };

        warn = function warn(msg, vm) {
          var trace = vm ? generateComponentTrace(vm) : '';

          if (config.warnHandler) {
            config.warnHandler.call(null, msg, vm, trace);
          } else if (hasConsole && !config.silent) {
            console.error("[Vue warn]: " + msg + trace);
          }
        };

        tip = function tip(msg, vm) {
          if (hasConsole && !config.silent) {
            console.warn("[Vue tip]: " + msg + (vm ? generateComponentTrace(vm) : ''));
          }
        };

        formatComponentName = function formatComponentName(vm, includeFile) {
          if (vm.$root === vm) {
            return '<Root>';
          }
          var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
          var name = options.name || options._componentTag;
          var file = options.__file;
          if (!name && file) {
            var match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
          }

          return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : '');
        };

        var repeat = function repeat(str, n) {
          var res = '';
          while (n) {
            if (n % 2 === 1) {
              res += str;
            }
            if (n > 1) {
              str += str;
            }
            n >>= 1;
          }
          return res;
        };

        generateComponentTrace = function generateComponentTrace(vm) {
          if (vm._isVue && vm.$parent) {
            var tree = [];
            var currentRecursiveSequence = 0;
            while (vm) {
              if (tree.length > 0) {
                var last = tree[tree.length - 1];
                if (last.constructor === vm.constructor) {
                  currentRecursiveSequence++;
                  vm = vm.$parent;
                  continue;
                } else if (currentRecursiveSequence > 0) {
                  tree[tree.length - 1] = [last, currentRecursiveSequence];
                  currentRecursiveSequence = 0;
                }
              }
              tree.push(vm);
              vm = vm.$parent;
            }
            return '\n\nfound in\n\n' + tree.map(function (vm, i) {
              return "" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm) ? formatComponentName(vm[0]) + "... (" + vm[1] + " recursive calls)" : formatComponentName(vm));
            }).join('\n');
          } else {
            return "\n\n(found in " + formatComponentName(vm) + ")";
          }
        };
      }

      /*  */

      var uid = 0;

      /**
       * A dep is an observable that can have multiple
       * directives subscribing to it.
       */
      var Dep = function Dep() {
        this.id = uid++;
        this.subs = [];
      };

      Dep.prototype.addSub = function addSub(sub) {
        this.subs.push(sub);
      };

      Dep.prototype.removeSub = function removeSub(sub) {
        remove(this.subs, sub);
      };

      Dep.prototype.depend = function depend() {
        if (Dep.target) {
          Dep.target.addDep(this);
        }
      };

      Dep.prototype.notify = function notify() {
        // stabilize the subscriber list first
        var subs = this.subs.slice();
        for (var i = 0, l = subs.length; i < l; i++) {
          subs[i].update();
        }
      };

      // the current target watcher being evaluated.
      // this is globally unique because there could be only one
      // watcher being evaluated at any time.
      Dep.target = null;
      var targetStack = [];

      function pushTarget(_target) {
        if (Dep.target) {
          targetStack.push(Dep.target);
        }
        Dep.target = _target;
      }

      function popTarget() {
        Dep.target = targetStack.pop();
      }

      /*  */

      var VNode = function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
      };

      var prototypeAccessors = { child: { configurable: true } };

      // DEPRECATED: alias for componentInstance for backwards compat.
      /* istanbul ignore next */
      prototypeAccessors.child.get = function () {
        return this.componentInstance;
      };

      Object.defineProperties(VNode.prototype, prototypeAccessors);

      var createEmptyVNode = function createEmptyVNode(text) {
        if (text === void 0) text = '';

        var node = new VNode();
        node.text = text;
        node.isComment = true;
        return node;
      };

      function createTextVNode(val) {
        return new VNode(undefined, undefined, undefined, String(val));
      }

      // optimized shallow clone
      // used for static nodes and slot nodes because they may be reused across
      // multiple renders, cloning them avoids errors when DOM manipulations rely
      // on their elm reference.
      function cloneVNode(vnode) {
        var cloned = new VNode(vnode.tag, vnode.data, vnode.children, vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
        cloned.ns = vnode.ns;
        cloned.isStatic = vnode.isStatic;
        cloned.key = vnode.key;
        cloned.isComment = vnode.isComment;
        cloned.fnContext = vnode.fnContext;
        cloned.fnOptions = vnode.fnOptions;
        cloned.fnScopeId = vnode.fnScopeId;
        cloned.isCloned = true;
        return cloned;
      }

      /*
       * not type checking this file because flow doesn't play well with
       * dynamically accessing methods on Array prototype
       */

      var arrayProto = Array.prototype;
      var arrayMethods = Object.create(arrayProto);

      var methodsToPatch = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'];

      /**
       * Intercept mutating methods and emit events
       */
      methodsToPatch.forEach(function (method) {
        // cache original method
        var original = arrayProto[method];
        def(arrayMethods, method, function mutator() {
          var args = [],
              len = arguments.length;
          while (len--) {
            args[len] = arguments[len];
          }var result = original.apply(this, args);
          var ob = this.__ob__;
          var inserted;
          switch (method) {
            case 'push':
            case 'unshift':
              inserted = args;
              break;
            case 'splice':
              inserted = args.slice(2);
              break;
          }
          if (inserted) {
            ob.observeArray(inserted);
          }
          // notify change
          ob.dep.notify();
          return result;
        });
      });

      /*  */

      var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

      /**
       * In some cases we may want to disable observation inside a component's
       * update computation.
       */
      var shouldObserve = true;

      function toggleObserving(value) {
        shouldObserve = value;
      }

      /**
       * Observer class that is attached to each observed
       * object. Once attached, the observer converts the target
       * object's property keys into getter/setters that
       * collect dependencies and dispatch updates.
       */
      var Observer = function Observer(value) {
        this.value = value;
        this.dep = new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (Array.isArray(value)) {
          var augment = hasProto ? protoAugment : copyAugment;
          augment(value, arrayMethods, arrayKeys);
          this.observeArray(value);
        } else {
          this.walk(value);
        }
      };

      /**
       * Walk through each property and convert them into
       * getter/setters. This method should only be called when
       * value type is Object.
       */
      Observer.prototype.walk = function walk(obj) {
        var keys = Object.keys(obj);
        for (var i = 0; i < keys.length; i++) {
          defineReactive(obj, keys[i]);
        }
      };

      /**
       * Observe a list of Array items.
       */
      Observer.prototype.observeArray = function observeArray(items) {
        for (var i = 0, l = items.length; i < l; i++) {
          observe(items[i]);
        }
      };

      // helpers

      /**
       * Augment an target Object or Array by intercepting
       * the prototype chain using __proto__
       */
      function protoAugment(target, src, keys) {
        /* eslint-disable no-proto */
        target.__proto__ = src;
        /* eslint-enable no-proto */
      }

      /**
       * Augment an target Object or Array by defining
       * hidden properties.
       */
      /* istanbul ignore next */
      function copyAugment(target, src, keys) {
        for (var i = 0, l = keys.length; i < l; i++) {
          var key = keys[i];
          def(target, key, src[key]);
        }
      }

      /**
       * Attempt to create an observer instance for a value,
       * returns the new observer if successfully observed,
       * or the existing observer if the value already has one.
       */
      function observe(value, asRootData) {
        if (!isObject(value) || value instanceof VNode) {
          return;
        }
        var ob;
        if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
          ob = value.__ob__;
        } else if (shouldObserve && !isServerRendering() && (Array.isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
          ob = new Observer(value);
        }
        if (asRootData && ob) {
          ob.vmCount++;
        }
        return ob;
      }

      /**
       * Define a reactive property on an Object.
       */
      function defineReactive(obj, key, val, customSetter, shallow) {
        var dep = new Dep();

        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property && property.configurable === false) {
          return;
        }

        // cater for pre-defined getter/setters
        var getter = property && property.get;
        if (!getter && arguments.length === 2) {
          val = obj[key];
        }
        var setter = property && property.set;

        var childOb = !shallow && observe(val);
        Object.defineProperty(obj, key, {
          enumerable: true,
          configurable: true,
          get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
              dep.depend();
              if (childOb) {
                childOb.dep.depend();
                if (Array.isArray(value)) {
                  dependArray(value);
                }
              }
            }
            return value;
          },
          set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            /* eslint-disable no-self-compare */
            if (newVal === value || newVal !== newVal && value !== value) {
              return;
            }
            /* eslint-enable no-self-compare */
            if (process.env.NODE_ENV !== 'production' && customSetter) {
              customSetter();
            }
            if (setter) {
              setter.call(obj, newVal);
            } else {
              val = newVal;
            }
            childOb = !shallow && observe(newVal);
            dep.notify();
          }
        });
      }

      /**
       * Set a property on an object. Adds the new property and
       * triggers change notification if the property doesn't
       * already exist.
       */
      function set(target, key, val) {
        if (process.env.NODE_ENV !== 'production' && (isUndef(target) || isPrimitive(target))) {
          warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
        }
        if (Array.isArray(target) && isValidArrayIndex(key)) {
          target.length = Math.max(target.length, key);
          target.splice(key, 1, val);
          return val;
        }
        if (key in target && !(key in Object.prototype)) {
          target[key] = val;
          return val;
        }
        var ob = target.__ob__;
        if (target._isVue || ob && ob.vmCount) {
          process.env.NODE_ENV !== 'production' && warn('Avoid adding reactive properties to a Vue instance or its root $data ' + 'at runtime - declare it upfront in the data option.');
          return val;
        }
        if (!ob) {
          target[key] = val;
          return val;
        }
        defineReactive(ob.value, key, val);
        ob.dep.notify();
        return val;
      }

      /**
       * Delete a property and trigger change if necessary.
       */
      function del(target, key) {
        if (process.env.NODE_ENV !== 'production' && (isUndef(target) || isPrimitive(target))) {
          warn("Cannot delete reactive property on undefined, null, or primitive value: " + target);
        }
        if (Array.isArray(target) && isValidArrayIndex(key)) {
          target.splice(key, 1);
          return;
        }
        var ob = target.__ob__;
        if (target._isVue || ob && ob.vmCount) {
          process.env.NODE_ENV !== 'production' && warn('Avoid deleting properties on a Vue instance or its root $data ' + '- just set it to null.');
          return;
        }
        if (!hasOwn(target, key)) {
          return;
        }
        delete target[key];
        if (!ob) {
          return;
        }
        ob.dep.notify();
      }

      /**
       * Collect dependencies on array elements when the array is touched, since
       * we cannot intercept array element access like property getters.
       */
      function dependArray(value) {
        for (var e = void 0, i = 0, l = value.length; i < l; i++) {
          e = value[i];
          e && e.__ob__ && e.__ob__.dep.depend();
          if (Array.isArray(e)) {
            dependArray(e);
          }
        }
      }

      /*  */

      /**
       * Option overwriting strategies are functions that handle
       * how to merge a parent option value and a child option
       * value into the final value.
       */
      var strats = config.optionMergeStrategies;

      /**
       * Options with restrictions
       */
      if (process.env.NODE_ENV !== 'production') {
        strats.el = strats.propsData = function (parent, child, vm, key) {
          if (!vm) {
            warn("option \"" + key + "\" can only be used during instance " + 'creation with the `new` keyword.');
          }
          return defaultStrat(parent, child);
        };
      }

      /**
       * Helper that recursively merges two data objects together.
       */
      function mergeData(to, from) {
        if (!from) {
          return to;
        }
        var key, toVal, fromVal;
        var keys = Object.keys(from);
        for (var i = 0; i < keys.length; i++) {
          key = keys[i];
          toVal = to[key];
          fromVal = from[key];
          if (!hasOwn(to, key)) {
            set(to, key, fromVal);
          } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
          }
        }
        return to;
      }

      /**
       * Data
       */
      function mergeDataOrFn(parentVal, childVal, vm) {
        if (!vm) {
          // in a Vue.extend merge, both should be functions
          if (!childVal) {
            return parentVal;
          }
          if (!parentVal) {
            return childVal;
          }
          // when parentVal & childVal are both present,
          // we need to return a function that returns the
          // merged result of both functions... no need to
          // check if parentVal is a function here because
          // it has to be a function to pass previous merges.
          return function mergedDataFn() {
            return mergeData(typeof childVal === 'function' ? childVal.call(this, this) : childVal, typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal);
          };
        } else {
          return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = typeof childVal === 'function' ? childVal.call(vm, vm) : childVal;
            var defaultData = typeof parentVal === 'function' ? parentVal.call(vm, vm) : parentVal;
            if (instanceData) {
              return mergeData(instanceData, defaultData);
            } else {
              return defaultData;
            }
          };
        }
      }

      strats.data = function (parentVal, childVal, vm) {
        if (!vm) {
          if (childVal && typeof childVal !== 'function') {
            process.env.NODE_ENV !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);

            return parentVal;
          }
          return mergeDataOrFn(parentVal, childVal);
        }

        return mergeDataOrFn(parentVal, childVal, vm);
      };

      /**
       * Hooks and props are merged as arrays.
       */
      function mergeHook(parentVal, childVal) {
        return childVal ? parentVal ? parentVal.concat(childVal) : Array.isArray(childVal) ? childVal : [childVal] : parentVal;
      }

      LIFECYCLE_HOOKS.forEach(function (hook) {
        strats[hook] = mergeHook;
      });

      /**
       * Assets
       *
       * When a vm is present (instance creation), we need to do
       * a three-way merge between constructor options, instance
       * options and parent options.
       */
      function mergeAssets(parentVal, childVal, vm, key) {
        var res = Object.create(parentVal || null);
        if (childVal) {
          process.env.NODE_ENV !== 'production' && assertObjectType(key, childVal, vm);
          return extend(res, childVal);
        } else {
          return res;
        }
      }

      ASSET_TYPES.forEach(function (type) {
        strats[type + 's'] = mergeAssets;
      });

      /**
       * Watchers.
       *
       * Watchers hashes should not overwrite one
       * another, so we merge them as arrays.
       */
      strats.watch = function (parentVal, childVal, vm, key) {
        // work around Firefox's Object.prototype.watch...
        if (parentVal === nativeWatch) {
          parentVal = undefined;
        }
        if (childVal === nativeWatch) {
          childVal = undefined;
        }
        /* istanbul ignore if */
        if (!childVal) {
          return Object.create(parentVal || null);
        }
        if (process.env.NODE_ENV !== 'production') {
          assertObjectType(key, childVal, vm);
        }
        if (!parentVal) {
          return childVal;
        }
        var ret = {};
        extend(ret, parentVal);
        for (var key$1 in childVal) {
          var parent = ret[key$1];
          var child = childVal[key$1];
          if (parent && !Array.isArray(parent)) {
            parent = [parent];
          }
          ret[key$1] = parent ? parent.concat(child) : Array.isArray(child) ? child : [child];
        }
        return ret;
      };

      /**
       * Other object hashes.
       */
      strats.props = strats.methods = strats.inject = strats.computed = function (parentVal, childVal, vm, key) {
        if (childVal && process.env.NODE_ENV !== 'production') {
          assertObjectType(key, childVal, vm);
        }
        if (!parentVal) {
          return childVal;
        }
        var ret = Object.create(null);
        extend(ret, parentVal);
        if (childVal) {
          extend(ret, childVal);
        }
        return ret;
      };
      strats.provide = mergeDataOrFn;

      /**
       * Default strategy.
       */
      var defaultStrat = function defaultStrat(parentVal, childVal) {
        return childVal === undefined ? parentVal : childVal;
      };

      /**
       * Validate component names
       */
      function checkComponents(options) {
        for (var key in options.components) {
          validateComponentName(key);
        }
      }

      function validateComponentName(name) {
        if (!/^[a-zA-Z][\w-]*$/.test(name)) {
          warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characters and the hyphen, ' + 'and must start with a letter.');
        }
        if (isBuiltInTag(name) || config.isReservedTag(name)) {
          warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + name);
        }
      }

      /**
       * Ensure all props option syntax are normalized into the
       * Object-based format.
       */
      function normalizeProps(options, vm) {
        var props = options.props;
        if (!props) {
          return;
        }
        var res = {};
        var i, val, name;
        if (Array.isArray(props)) {
          i = props.length;
          while (i--) {
            val = props[i];
            if (typeof val === 'string') {
              name = camelize(val);
              res[name] = { type: null };
            } else if (process.env.NODE_ENV !== 'production') {
              warn('props must be strings when using array syntax.');
            }
          }
        } else if (isPlainObject(props)) {
          for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
          }
        } else if (process.env.NODE_ENV !== 'production') {
          warn("Invalid value for option \"props\": expected an Array or an Object, " + "but got " + toRawType(props) + ".", vm);
        }
        options.props = res;
      }

      /**
       * Normalize all injections into Object-based format
       */
      function normalizeInject(options, vm) {
        var inject = options.inject;
        if (!inject) {
          return;
        }
        var normalized = options.inject = {};
        if (Array.isArray(inject)) {
          for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
          }
        } else if (isPlainObject(inject)) {
          for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val) ? extend({ from: key }, val) : { from: val };
          }
        } else if (process.env.NODE_ENV !== 'production') {
          warn("Invalid value for option \"inject\": expected an Array or an Object, " + "but got " + toRawType(inject) + ".", vm);
        }
      }

      /**
       * Normalize raw function directives into object format.
       */
      function normalizeDirectives(options) {
        var dirs = options.directives;
        if (dirs) {
          for (var key in dirs) {
            var def = dirs[key];
            if (typeof def === 'function') {
              dirs[key] = { bind: def, update: def };
            }
          }
        }
      }

      function assertObjectType(name, value, vm) {
        if (!isPlainObject(value)) {
          warn("Invalid value for option \"" + name + "\": expected an Object, " + "but got " + toRawType(value) + ".", vm);
        }
      }

      /**
       * Merge two option objects into a new one.
       * Core utility used in both instantiation and inheritance.
       */
      function mergeOptions(parent, child, vm) {
        if (process.env.NODE_ENV !== 'production') {
          checkComponents(child);
        }

        if (typeof child === 'function') {
          child = child.options;
        }

        normalizeProps(child, vm);
        normalizeInject(child, vm);
        normalizeDirectives(child);
        var extendsFrom = child.extends;
        if (extendsFrom) {
          parent = mergeOptions(parent, extendsFrom, vm);
        }
        if (child.mixins) {
          for (var i = 0, l = child.mixins.length; i < l; i++) {
            parent = mergeOptions(parent, child.mixins[i], vm);
          }
        }
        var options = {};
        var key;
        for (key in parent) {
          mergeField(key);
        }
        for (key in child) {
          if (!hasOwn(parent, key)) {
            mergeField(key);
          }
        }
        function mergeField(key) {
          var strat = strats[key] || defaultStrat;
          options[key] = strat(parent[key], child[key], vm, key);
        }
        return options;
      }

      /**
       * Resolve an asset.
       * This function is used because child instances need access
       * to assets defined in its ancestor chain.
       */
      function resolveAsset(options, type, id, warnMissing) {
        /* istanbul ignore if */
        if (typeof id !== 'string') {
          return;
        }
        var assets = options[type];
        // check local registration variations first
        if (hasOwn(assets, id)) {
          return assets[id];
        }
        var camelizedId = camelize(id);
        if (hasOwn(assets, camelizedId)) {
          return assets[camelizedId];
        }
        var PascalCaseId = capitalize(camelizedId);
        if (hasOwn(assets, PascalCaseId)) {
          return assets[PascalCaseId];
        }
        // fallback to prototype chain
        var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
        if (process.env.NODE_ENV !== 'production' && warnMissing && !res) {
          warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
        }
        return res;
      }

      /*  */

      function validateProp(key, propOptions, propsData, vm) {
        var prop = propOptions[key];
        var absent = !hasOwn(propsData, key);
        var value = propsData[key];
        // boolean casting
        var booleanIndex = getTypeIndex(Boolean, prop.type);
        if (booleanIndex > -1) {
          if (absent && !hasOwn(prop, 'default')) {
            value = false;
          } else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
              value = true;
            }
          }
        }
        // check default value
        if (value === undefined) {
          value = getPropDefaultValue(vm, prop, key);
          // since the default value is a fresh copy,
          // make sure to observe it.
          var prevShouldObserve = shouldObserve;
          toggleObserving(true);
          observe(value);
          toggleObserving(prevShouldObserve);
        }
        if (process.env.NODE_ENV !== 'production' &&
        // skip validation for weex recycle-list child component props
        !(false && isObject(value) && '@binding' in value)) {
          assertProp(prop, key, value, vm, absent);
        }
        return value;
      }

      /**
       * Get the default value of a prop.
       */
      function getPropDefaultValue(vm, prop, key) {
        // no default, return undefined
        if (!hasOwn(prop, 'default')) {
          return undefined;
        }
        var def = prop.default;
        // warn against non-factory defaults for Object & Array
        if (process.env.NODE_ENV !== 'production' && isObject(def)) {
          warn('Invalid default value for prop "' + key + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
        }
        // the raw prop value was also undefined from previous render,
        // return previous default value to avoid unnecessary watcher trigger
        if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) {
          return vm._props[key];
        }
        // call factory function for non-Function types
        // a value is Function if its prototype is function even across different execution context
        return typeof def === 'function' && getType(prop.type) !== 'Function' ? def.call(vm) : def;
      }

      /**
       * Assert whether a prop is valid.
       */
      function assertProp(prop, name, value, vm, absent) {
        if (prop.required && absent) {
          warn('Missing required prop: "' + name + '"', vm);
          return;
        }
        if (value == null && !prop.required) {
          return;
        }
        var type = prop.type;
        var valid = !type || type === true;
        var expectedTypes = [];
        if (type) {
          if (!Array.isArray(type)) {
            type = [type];
          }
          for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i]);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
          }
        }
        if (!valid) {
          warn("Invalid prop: type check failed for prop \"" + name + "\"." + " Expected " + expectedTypes.map(capitalize).join(', ') + ", got " + toRawType(value) + ".", vm);
          return;
        }
        var validator = prop.validator;
        if (validator) {
          if (!validator(value)) {
            warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
          }
        }
      }

      var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

      function assertType(value, type) {
        var valid;
        var expectedType = getType(type);
        if (simpleCheckRE.test(expectedType)) {
          var t = typeof value === "undefined" ? "undefined" : _typeof(value);
          valid = t === expectedType.toLowerCase();
          // for primitive wrapper objects
          if (!valid && t === 'object') {
            valid = value instanceof type;
          }
        } else if (expectedType === 'Object') {
          valid = isPlainObject(value);
        } else if (expectedType === 'Array') {
          valid = Array.isArray(value);
        } else {
          valid = value instanceof type;
        }
        return {
          valid: valid,
          expectedType: expectedType
        };
      }

      /**
       * Use function string name to check built-in types,
       * because a simple equality check will fail when running
       * across different vms / iframes.
       */
      function getType(fn) {
        var match = fn && fn.toString().match(/^\s*function (\w+)/);
        return match ? match[1] : '';
      }

      function isSameType(a, b) {
        return getType(a) === getType(b);
      }

      function getTypeIndex(type, expectedTypes) {
        if (!Array.isArray(expectedTypes)) {
          return isSameType(expectedTypes, type) ? 0 : -1;
        }
        for (var i = 0, len = expectedTypes.length; i < len; i++) {
          if (isSameType(expectedTypes[i], type)) {
            return i;
          }
        }
        return -1;
      }

      /*  */

      function handleError(err, vm, info) {
        if (vm) {
          var cur = vm;
          while (cur = cur.$parent) {
            var hooks = cur.$options.errorCaptured;
            if (hooks) {
              for (var i = 0; i < hooks.length; i++) {
                try {
                  var capture = hooks[i].call(cur, err, vm, info) === false;
                  if (capture) {
                    return;
                  }
                } catch (e) {
                  globalHandleError(e, cur, 'errorCaptured hook');
                }
              }
            }
          }
        }
        globalHandleError(err, vm, info);
      }

      function globalHandleError(err, vm, info) {
        if (config.errorHandler) {
          try {
            return config.errorHandler.call(null, err, vm, info);
          } catch (e) {
            logError(e, null, 'config.errorHandler');
          }
        }
        logError(err, vm, info);
      }

      function logError(err, vm, info) {
        if (process.env.NODE_ENV !== 'production') {
          warn("Error in " + info + ": \"" + err.toString() + "\"", vm);
        }
        /* istanbul ignore else */
        if ((inBrowser || inWeex) && typeof console !== 'undefined') {
          console.error(err);
        } else {
          throw err;
        }
      }

      /*  */
      /* globals MessageChannel */

      var callbacks = [];
      var pending = false;

      function flushCallbacks() {
        pending = false;
        var copies = callbacks.slice(0);
        callbacks.length = 0;
        for (var i = 0; i < copies.length; i++) {
          copies[i]();
        }
      }

      // Here we have async deferring wrappers using both microtasks and (macro) tasks.
      // In < 2.4 we used microtasks everywhere, but there are some scenarios where
      // microtasks have too high a priority and fire in between supposedly
      // sequential events (e.g. #4521, #6690) or even between bubbling of the same
      // event (#6566). However, using (macro) tasks everywhere also has subtle problems
      // when state is changed right before repaint (e.g. #6813, out-in transitions).
      // Here we use microtask by default, but expose a way to force (macro) task when
      // needed (e.g. in event handlers attached by v-on).
      var microTimerFunc;
      var macroTimerFunc;
      var useMacroTask = false;

      // Determine (macro) task defer implementation.
      // Technically setImmediate should be the ideal choice, but it's only available
      // in IE. The only polyfill that consistently queues the callback after all DOM
      // events triggered in the same loop is by using MessageChannel.
      /* istanbul ignore if */
      if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
        macroTimerFunc = function macroTimerFunc() {
          setImmediate(flushCallbacks);
        };
      } else if (typeof MessageChannel !== 'undefined' && (isNative(MessageChannel) ||
      // PhantomJS
      MessageChannel.toString() === '[object MessageChannelConstructor]')) {
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = flushCallbacks;
        macroTimerFunc = function macroTimerFunc() {
          port.postMessage(1);
        };
      } else {
        /* istanbul ignore next */
        macroTimerFunc = function macroTimerFunc() {
          setTimeout(flushCallbacks, 0);
        };
      }

      // Determine microtask defer implementation.
      /* istanbul ignore next, $flow-disable-line */
      if (typeof Promise !== 'undefined' && isNative(Promise)) {
        var p = Promise.resolve();
        microTimerFunc = function microTimerFunc() {
          p.then(flushCallbacks);
          // in problematic UIWebViews, Promise.then doesn't completely break, but
          // it can get stuck in a weird state where callbacks are pushed into the
          // microtask queue but the queue isn't being flushed, until the browser
          // needs to do some other work, e.g. handle a timer. Therefore we can
          // "force" the microtask queue to be flushed by adding an empty timer.
          if (isIOS) {
            setTimeout(noop);
          }
        };
      } else {
        // fallback to macro
        microTimerFunc = macroTimerFunc;
      }

      /**
       * Wrap a function so that if any code inside triggers state change,
       * the changes are queued using a (macro) task instead of a microtask.
       */
      function withMacroTask(fn) {
        return fn._withTask || (fn._withTask = function () {
          useMacroTask = true;
          var res = fn.apply(null, arguments);
          useMacroTask = false;
          return res;
        });
      }

      function nextTick(cb, ctx) {
        var _resolve;
        callbacks.push(function () {
          if (cb) {
            try {
              cb.call(ctx);
            } catch (e) {
              handleError(e, ctx, 'nextTick');
            }
          } else if (_resolve) {
            _resolve(ctx);
          }
        });
        if (!pending) {
          pending = true;
          if (useMacroTask) {
            macroTimerFunc();
          } else {
            microTimerFunc();
          }
        }
        // $flow-disable-line
        if (!cb && typeof Promise !== 'undefined') {
          return new Promise(function (resolve) {
            _resolve = resolve;
          });
        }
      }

      /*  */

      /* not type checking this file because flow doesn't play well with Proxy */

      var initProxy;

      if (process.env.NODE_ENV !== 'production') {
        var allowedGlobals = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' + 'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' + 'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' + 'require' // for Webpack/Browserify
        );

        var warnNonPresent = function warnNonPresent(target, key) {
          warn("Property or method \"" + key + "\" is not defined on the instance but " + 'referenced during render. Make sure that this property is reactive, ' + 'either in the data option, or for class-based components, by ' + 'initializing the property. ' + 'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
        };

        var hasProxy = typeof Proxy !== 'undefined' && isNative(Proxy);

        if (hasProxy) {
          var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
          config.keyCodes = new Proxy(config.keyCodes, {
            set: function set(target, key, value) {
              if (isBuiltInModifier(key)) {
                warn("Avoid overwriting built-in modifier in config.keyCodes: ." + key);
                return false;
              } else {
                target[key] = value;
                return true;
              }
            }
          });
        }

        var hasHandler = {
          has: function has(target, key) {
            var has = key in target;
            var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
            if (!has && !isAllowed) {
              warnNonPresent(target, key);
            }
            return has || !isAllowed;
          }
        };

        var getHandler = {
          get: function get(target, key) {
            if (typeof key === 'string' && !(key in target)) {
              warnNonPresent(target, key);
            }
            return target[key];
          }
        };

        initProxy = function initProxy(vm) {
          if (hasProxy) {
            // determine which proxy handler to use
            var options = vm.$options;
            var handlers = options.render && options.render._withStripped ? getHandler : hasHandler;
            vm._renderProxy = new Proxy(vm, handlers);
          } else {
            vm._renderProxy = vm;
          }
        };
      }

      /*  */

      var seenObjects = new _Set();

      /**
       * Recursively traverse an object to evoke all converted
       * getters, so that every nested property inside the object
       * is collected as a "deep" dependency.
       */
      function traverse(val) {
        _traverse(val, seenObjects);
        seenObjects.clear();
      }

      function _traverse(val, seen) {
        var i, keys;
        var isA = Array.isArray(val);
        if (!isA && !isObject(val) || Object.isFrozen(val) || val instanceof VNode) {
          return;
        }
        if (val.__ob__) {
          var depId = val.__ob__.dep.id;
          if (seen.has(depId)) {
            return;
          }
          seen.add(depId);
        }
        if (isA) {
          i = val.length;
          while (i--) {
            _traverse(val[i], seen);
          }
        } else {
          keys = Object.keys(val);
          i = keys.length;
          while (i--) {
            _traverse(val[keys[i]], seen);
          }
        }
      }

      var mark;
      var measure;

      if (process.env.NODE_ENV !== 'production') {
        var perf = inBrowser && window.performance;
        /* istanbul ignore if */
        if (perf && perf.mark && perf.measure && perf.clearMarks && perf.clearMeasures) {
          mark = function mark(tag) {
            return perf.mark(tag);
          };
          measure = function measure(name, startTag, endTag) {
            perf.measure(name, startTag, endTag);
            perf.clearMarks(startTag);
            perf.clearMarks(endTag);
            perf.clearMeasures(name);
          };
        }
      }

      /*  */

      var normalizeEvent = cached(function (name) {
        var passive = name.charAt(0) === '&';
        name = passive ? name.slice(1) : name;
        var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
        name = once$$1 ? name.slice(1) : name;
        var capture = name.charAt(0) === '!';
        name = capture ? name.slice(1) : name;
        return {
          name: name,
          once: once$$1,
          capture: capture,
          passive: passive
        };
      });

      function createFnInvoker(fns) {
        function invoker() {
          var arguments$1 = arguments;

          var fns = invoker.fns;
          if (Array.isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
              cloned[i].apply(null, arguments$1);
            }
          } else {
            // return handler return value for single handlers
            return fns.apply(null, arguments);
          }
        }
        invoker.fns = fns;
        return invoker;
      }

      function updateListeners(on, oldOn, add, remove$$1, vm) {
        var name, def, cur, old, event;
        for (name in on) {
          def = cur = on[name];
          old = oldOn[name];
          event = normalizeEvent(name);
          /* istanbul ignore if */
          if (isUndef(cur)) {
            process.env.NODE_ENV !== 'production' && warn("Invalid handler for event \"" + event.name + "\": got " + String(cur), vm);
          } else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
              cur = on[name] = createFnInvoker(cur);
            }
            add(event.name, cur, event.once, event.capture, event.passive, event.params);
          } else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
          }
        }
        for (name in oldOn) {
          if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove$$1(event.name, oldOn[name], event.capture);
          }
        }
      }

      /*  */

      function mergeVNodeHook(def, hookKey, hook) {
        if (def instanceof VNode) {
          def = def.data.hook || (def.data.hook = {});
        }
        var invoker;
        var oldHook = def[hookKey];

        function wrappedHook() {
          hook.apply(this, arguments);
          // important: remove merged hook to ensure it's called only once
          // and prevent memory leak
          remove(invoker.fns, wrappedHook);
        }

        if (isUndef(oldHook)) {
          // no existing hook
          invoker = createFnInvoker([wrappedHook]);
        } else {
          /* istanbul ignore if */
          if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
          } else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
          }
        }

        invoker.merged = true;
        def[hookKey] = invoker;
      }

      /*  */

      function extractPropsFromVNodeData(data, Ctor, tag) {
        // we are only extracting raw values here.
        // validation and default values are handled in the child
        // component itself.
        var propOptions = Ctor.options.props;
        if (isUndef(propOptions)) {
          return;
        }
        var res = {};
        var attrs = data.attrs;
        var props = data.props;
        if (isDef(attrs) || isDef(props)) {
          for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (process.env.NODE_ENV !== 'production') {
              var keyInLowerCase = key.toLowerCase();
              if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                tip("Prop \"" + keyInLowerCase + "\" is passed to component " + formatComponentName(tag || Ctor) + ", but the declared prop name is" + " \"" + key + "\". " + "Note that HTML attributes are case-insensitive and camelCased " + "props need to use their kebab-case equivalents when using in-DOM " + "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\".");
              }
            }
            checkProp(res, props, key, altKey, true) || checkProp(res, attrs, key, altKey, false);
          }
        }
        return res;
      }

      function checkProp(res, hash, key, altKey, preserve) {
        if (isDef(hash)) {
          if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
              delete hash[key];
            }
            return true;
          } else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
              delete hash[altKey];
            }
            return true;
          }
        }
        return false;
      }

      /*  */

      // The template compiler attempts to minimize the need for normalization by
      // statically analyzing the template at compile time.
      //
      // For plain HTML markup, normalization can be completely skipped because the
      // generated render function is guaranteed to return Array<VNode>. There are
      // two cases where extra normalization is needed:

      // 1. When the children contains components - because a functional component
      // may return an Array instead of a single root. In this case, just a simple
      // normalization is needed - if any child is an Array, we flatten the whole
      // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
      // because functional components already normalize their own children.
      function simpleNormalizeChildren(children) {
        for (var i = 0; i < children.length; i++) {
          if (Array.isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
          }
        }
        return children;
      }

      // 2. When the children contains constructs that always generated nested Arrays,
      // e.g. <template>, <slot>, v-for, or when the children is provided by user
      // with hand-written render functions / JSX. In such cases a full normalization
      // is needed to cater to all possible types of children values.
      function normalizeChildren(children) {
        return isPrimitive(children) ? [createTextVNode(children)] : Array.isArray(children) ? normalizeArrayChildren(children) : undefined;
      }

      function isTextNode(node) {
        return isDef(node) && isDef(node.text) && isFalse(node.isComment);
      }

      function normalizeArrayChildren(children, nestedIndex) {
        var res = [];
        var i, c, lastIndex, last;
        for (i = 0; i < children.length; i++) {
          c = children[i];
          if (isUndef(c) || typeof c === 'boolean') {
            continue;
          }
          lastIndex = res.length - 1;
          last = res[lastIndex];
          //  nested
          if (Array.isArray(c)) {
            if (c.length > 0) {
              c = normalizeArrayChildren(c, (nestedIndex || '') + "_" + i);
              // merge adjacent text nodes
              if (isTextNode(c[0]) && isTextNode(last)) {
                res[lastIndex] = createTextVNode(last.text + c[0].text);
                c.shift();
              }
              res.push.apply(res, c);
            }
          } else if (isPrimitive(c)) {
            if (isTextNode(last)) {
              // merge adjacent text nodes
              // this is necessary for SSR hydration because text nodes are
              // essentially merged when rendered to HTML strings
              res[lastIndex] = createTextVNode(last.text + c);
            } else if (c !== '') {
              // convert primitive to vnode
              res.push(createTextVNode(c));
            }
          } else {
            if (isTextNode(c) && isTextNode(last)) {
              // merge adjacent text nodes
              res[lastIndex] = createTextVNode(last.text + c.text);
            } else {
              // default key for nested array children (likely generated by v-for)
              if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
                c.key = "__vlist" + nestedIndex + "_" + i + "__";
              }
              res.push(c);
            }
          }
        }
        return res;
      }

      /*  */

      function ensureCtor(comp, base) {
        if (comp.__esModule || hasSymbol && comp[Symbol.toStringTag] === 'Module') {
          comp = comp.default;
        }
        return isObject(comp) ? base.extend(comp) : comp;
      }

      function createAsyncPlaceholder(factory, data, context, children, tag) {
        var node = createEmptyVNode();
        node.asyncFactory = factory;
        node.asyncMeta = { data: data, context: context, children: children, tag: tag };
        return node;
      }

      function resolveAsyncComponent(factory, baseCtor, context) {
        if (isTrue(factory.error) && isDef(factory.errorComp)) {
          return factory.errorComp;
        }

        if (isDef(factory.resolved)) {
          return factory.resolved;
        }

        if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
          return factory.loadingComp;
        }

        if (isDef(factory.contexts)) {
          // already pending
          factory.contexts.push(context);
        } else {
          var contexts = factory.contexts = [context];
          var sync = true;

          var forceRender = function forceRender() {
            for (var i = 0, l = contexts.length; i < l; i++) {
              contexts[i].$forceUpdate();
            }
          };

          var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync) {
              forceRender();
            }
          });

          var reject = once(function (reason) {
            process.env.NODE_ENV !== 'production' && warn("Failed to resolve async component: " + String(factory) + (reason ? "\nReason: " + reason : ''));
            if (isDef(factory.errorComp)) {
              factory.error = true;
              forceRender();
            }
          });

          var res = factory(resolve, reject);

          if (isObject(res)) {
            if (typeof res.then === 'function') {
              // () => Promise
              if (isUndef(factory.resolved)) {
                res.then(resolve, reject);
              }
            } else if (isDef(res.component) && typeof res.component.then === 'function') {
              res.component.then(resolve, reject);

              if (isDef(res.error)) {
                factory.errorComp = ensureCtor(res.error, baseCtor);
              }

              if (isDef(res.loading)) {
                factory.loadingComp = ensureCtor(res.loading, baseCtor);
                if (res.delay === 0) {
                  factory.loading = true;
                } else {
                  setTimeout(function () {
                    if (isUndef(factory.resolved) && isUndef(factory.error)) {
                      factory.loading = true;
                      forceRender();
                    }
                  }, res.delay || 200);
                }
              }

              if (isDef(res.timeout)) {
                setTimeout(function () {
                  if (isUndef(factory.resolved)) {
                    reject(process.env.NODE_ENV !== 'production' ? "timeout (" + res.timeout + "ms)" : null);
                  }
                }, res.timeout);
              }
            }
          }

          sync = false;
          // return in case resolved synchronously
          return factory.loading ? factory.loadingComp : factory.resolved;
        }
      }

      /*  */

      function isAsyncPlaceholder(node) {
        return node.isComment && node.asyncFactory;
      }

      /*  */

      function getFirstComponentChild(children) {
        if (Array.isArray(children)) {
          for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
              return c;
            }
          }
        }
      }

      /*  */

      /*  */

      function initEvents(vm) {
        vm._events = Object.create(null);
        vm._hasHookEvent = false;
        // init parent attached events
        var listeners = vm.$options._parentListeners;
        if (listeners) {
          updateComponentListeners(vm, listeners);
        }
      }

      var target;

      function add(event, fn, once) {
        if (once) {
          target.$once(event, fn);
        } else {
          target.$on(event, fn);
        }
      }

      function remove$1(event, fn) {
        target.$off(event, fn);
      }

      function updateComponentListeners(vm, listeners, oldListeners) {
        target = vm;
        updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
        target = undefined;
      }

      function eventsMixin(Vue) {
        var hookRE = /^hook:/;
        Vue.prototype.$on = function (event, fn) {
          var this$1 = this;

          var vm = this;
          if (Array.isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
              this$1.$on(event[i], fn);
            }
          } else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
              vm._hasHookEvent = true;
            }
          }
          return vm;
        };

        Vue.prototype.$once = function (event, fn) {
          var vm = this;
          function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
          }
          on.fn = fn;
          vm.$on(event, on);
          return vm;
        };

        Vue.prototype.$off = function (event, fn) {
          var this$1 = this;

          var vm = this;
          // all
          if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
          }
          // array of events
          if (Array.isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
              this$1.$off(event[i], fn);
            }
            return vm;
          }
          // specific event
          var cbs = vm._events[event];
          if (!cbs) {
            return vm;
          }
          if (!fn) {
            vm._events[event] = null;
            return vm;
          }
          if (fn) {
            // specific handler
            var cb;
            var i$1 = cbs.length;
            while (i$1--) {
              cb = cbs[i$1];
              if (cb === fn || cb.fn === fn) {
                cbs.splice(i$1, 1);
                break;
              }
            }
          }
          return vm;
        };

        Vue.prototype.$emit = function (event) {
          var vm = this;
          if (process.env.NODE_ENV !== 'production') {
            var lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
              tip("Event \"" + lowerCaseEvent + "\" is emitted in component " + formatComponentName(vm) + " but the handler is registered for \"" + event + "\". " + "Note that HTML attributes are case-insensitive and you cannot use " + "v-on to listen to camelCase events when using in-DOM templates. " + "You should probably use \"" + hyphenate(event) + "\" instead of \"" + event + "\".");
            }
          }
          var cbs = vm._events[event];
          if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            for (var i = 0, l = cbs.length; i < l; i++) {
              try {
                cbs[i].apply(vm, args);
              } catch (e) {
                handleError(e, vm, "event handler for \"" + event + "\"");
              }
            }
          }
          return vm;
        };
      }

      /*  */

      /**
       * Runtime helper for resolving raw children VNodes into a slot object.
       */
      function resolveSlots(children, context) {
        var slots = {};
        if (!children) {
          return slots;
        }
        for (var i = 0, l = children.length; i < l; i++) {
          var child = children[i];
          var data = child.data;
          // remove slot attribute if the node is resolved as a Vue slot node
          if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
          }
          // named slots should only be respected if the vnode was rendered in the
          // same context.
          if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
            var name = data.slot;
            var slot = slots[name] || (slots[name] = []);
            if (child.tag === 'template') {
              slot.push.apply(slot, child.children || []);
            } else {
              slot.push(child);
            }
          } else {
            (slots.default || (slots.default = [])).push(child);
          }
        }
        // ignore slots that contains only whitespace
        for (var name$1 in slots) {
          if (slots[name$1].every(isWhitespace)) {
            delete slots[name$1];
          }
        }
        return slots;
      }

      function isWhitespace(node) {
        return node.isComment && !node.asyncFactory || node.text === ' ';
      }

      function resolveScopedSlots(fns, // see flow/vnode
      res) {
        res = res || {};
        for (var i = 0; i < fns.length; i++) {
          if (Array.isArray(fns[i])) {
            resolveScopedSlots(fns[i], res);
          } else {
            res[fns[i].key] = fns[i].fn;
          }
        }
        return res;
      }

      /*  */

      var activeInstance = null;
      var isUpdatingChildComponent = false;

      function initLifecycle(vm) {
        var options = vm.$options;

        // locate first non-abstract parent
        var parent = options.parent;
        if (parent && !options.abstract) {
          while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
          }
          parent.$children.push(vm);
        }

        vm.$parent = parent;
        vm.$root = parent ? parent.$root : vm;

        vm.$children = [];
        vm.$refs = {};

        vm._watcher = null;
        vm._inactive = null;
        vm._directInactive = false;
        vm._isMounted = false;
        vm._isDestroyed = false;
        vm._isBeingDestroyed = false;
      }

      function lifecycleMixin(Vue) {
        Vue.prototype._update = function (vnode, hydrating) {
          var vm = this;
          if (vm._isMounted) {
            callHook(vm, 'beforeUpdate');
          }
          var prevEl = vm.$el;
          var prevVnode = vm._vnode;
          var prevActiveInstance = activeInstance;
          activeInstance = vm;
          vm._vnode = vnode;
          // Vue.prototype.__patch__ is injected in entry points
          // based on the rendering backend used.
          if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */
            , vm.$options._parentElm, vm.$options._refElm);
            // no need for the ref nodes after initial patch
            // this prevents keeping a detached DOM tree in memory (#5851)
            vm.$options._parentElm = vm.$options._refElm = null;
          } else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
          }
          activeInstance = prevActiveInstance;
          // update __vue__ reference
          if (prevEl) {
            prevEl.__vue__ = null;
          }
          if (vm.$el) {
            vm.$el.__vue__ = vm;
          }
          // if parent is an HOC, update its $el as well
          if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
            vm.$parent.$el = vm.$el;
          }
          // updated hook is called by the scheduler to ensure that children are
          // updated in a parent's updated hook.
        };

        Vue.prototype.$forceUpdate = function () {
          var vm = this;
          if (vm._watcher) {
            vm._watcher.update();
          }
        };

        Vue.prototype.$destroy = function () {
          var vm = this;
          if (vm._isBeingDestroyed) {
            return;
          }
          callHook(vm, 'beforeDestroy');
          vm._isBeingDestroyed = true;
          // remove self from parent
          var parent = vm.$parent;
          if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove(parent.$children, vm);
          }
          // teardown watchers
          if (vm._watcher) {
            vm._watcher.teardown();
          }
          var i = vm._watchers.length;
          while (i--) {
            vm._watchers[i].teardown();
          }
          // remove reference from data ob
          // frozen object may not have observer.
          if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
          }
          // call the last hook...
          vm._isDestroyed = true;
          // invoke destroy hooks on current rendered tree
          vm.__patch__(vm._vnode, null);
          // fire destroyed hook
          callHook(vm, 'destroyed');
          // turn off all instance listeners.
          vm.$off();
          // remove __vue__ reference
          if (vm.$el) {
            vm.$el.__vue__ = null;
          }
          // release circular reference (#6759)
          if (vm.$vnode) {
            vm.$vnode.parent = null;
          }
        };
      }

      function mountComponent(vm, el, hydrating) {
        vm.$el = el;
        if (!vm.$options.render) {
          vm.$options.render = createEmptyVNode;
          if (process.env.NODE_ENV !== 'production') {
            /* istanbul ignore if */
            if (vm.$options.template && vm.$options.template.charAt(0) !== '#' || vm.$options.el || el) {
              warn('You are using the runtime-only build of Vue where the template ' + 'compiler is not available. Either pre-compile the templates into ' + 'render functions, or use the compiler-included build.', vm);
            } else {
              warn('Failed to mount component: template or render function not defined.', vm);
            }
          }
        }
        callHook(vm, 'beforeMount');

        var updateComponent;
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production' && config.performance && mark) {
          updateComponent = function updateComponent() {
            var name = vm._name;
            var id = vm._uid;
            var startTag = "vue-perf-start:" + id;
            var endTag = "vue-perf-end:" + id;

            mark(startTag);
            var vnode = vm._render();
            mark(endTag);
            measure("vue " + name + " render", startTag, endTag);

            mark(startTag);
            vm._update(vnode, hydrating);
            mark(endTag);
            measure("vue " + name + " patch", startTag, endTag);
          };
        } else {
          updateComponent = function updateComponent() {
            vm._update(vm._render(), hydrating);
          };
        }

        // we set this to vm._watcher inside the watcher's constructor
        // since the watcher's initial patch may call $forceUpdate (e.g. inside child
        // component's mounted hook), which relies on vm._watcher being already defined
        new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
        hydrating = false;

        // manually mounted instance, call mounted on self
        // mounted is called for render-created child components in its inserted hook
        if (vm.$vnode == null) {
          vm._isMounted = true;
          callHook(vm, 'mounted');
        }
        return vm;
      }

      function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
        if (process.env.NODE_ENV !== 'production') {
          isUpdatingChildComponent = true;
        }

        // determine whether component has slot children
        // we need to do this before overwriting $options._renderChildren
        var hasChildren = !!(renderChildren || // has new static slots
        vm.$options._renderChildren || // has old static slots
        parentVnode.data.scopedSlots || // has new scoped slots
        vm.$scopedSlots !== emptyObject // has old scoped slots
        );

        vm.$options._parentVnode = parentVnode;
        vm.$vnode = parentVnode; // update vm's placeholder node without re-render

        if (vm._vnode) {
          // update child tree's parent
          vm._vnode.parent = parentVnode;
        }
        vm.$options._renderChildren = renderChildren;

        // update $attrs and $listeners hash
        // these are also reactive so they may trigger child update if the child
        // used them during render
        vm.$attrs = parentVnode.data.attrs || emptyObject;
        vm.$listeners = listeners || emptyObject;

        // update props
        if (propsData && vm.$options.props) {
          toggleObserving(false);
          var props = vm._props;
          var propKeys = vm.$options._propKeys || [];
          for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
          }
          toggleObserving(true);
          // keep a copy of raw propsData
          vm.$options.propsData = propsData;
        }

        // update listeners
        listeners = listeners || emptyObject;
        var oldListeners = vm.$options._parentListeners;
        vm.$options._parentListeners = listeners;
        updateComponentListeners(vm, listeners, oldListeners);

        // resolve slots + force update if has children
        if (hasChildren) {
          vm.$slots = resolveSlots(renderChildren, parentVnode.context);
          vm.$forceUpdate();
        }

        if (process.env.NODE_ENV !== 'production') {
          isUpdatingChildComponent = false;
        }
      }

      function isInInactiveTree(vm) {
        while (vm && (vm = vm.$parent)) {
          if (vm._inactive) {
            return true;
          }
        }
        return false;
      }

      function activateChildComponent(vm, direct) {
        if (direct) {
          vm._directInactive = false;
          if (isInInactiveTree(vm)) {
            return;
          }
        } else if (vm._directInactive) {
          return;
        }
        if (vm._inactive || vm._inactive === null) {
          vm._inactive = false;
          for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
          }
          callHook(vm, 'activated');
        }
      }

      function deactivateChildComponent(vm, direct) {
        if (direct) {
          vm._directInactive = true;
          if (isInInactiveTree(vm)) {
            return;
          }
        }
        if (!vm._inactive) {
          vm._inactive = true;
          for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
          }
          callHook(vm, 'deactivated');
        }
      }

      function callHook(vm, hook) {
        // #7573 disable dep collection when invoking lifecycle hooks
        pushTarget();
        var handlers = vm.$options[hook];
        if (handlers) {
          for (var i = 0, j = handlers.length; i < j; i++) {
            try {
              handlers[i].call(vm);
            } catch (e) {
              handleError(e, vm, hook + " hook");
            }
          }
        }
        if (vm._hasHookEvent) {
          vm.$emit('hook:' + hook);
        }
        popTarget();
      }

      /*  */

      var MAX_UPDATE_COUNT = 100;

      var queue = [];
      var activatedChildren = [];
      var has = {};
      var circular = {};
      var waiting = false;
      var flushing = false;
      var index = 0;

      /**
       * Reset the scheduler's state.
       */
      function resetSchedulerState() {
        index = queue.length = activatedChildren.length = 0;
        has = {};
        if (process.env.NODE_ENV !== 'production') {
          circular = {};
        }
        waiting = flushing = false;
      }

      /**
       * Flush both queues and run the watchers.
       */
      function flushSchedulerQueue() {
        flushing = true;
        var watcher, id;

        // Sort queue before flush.
        // This ensures that:
        // 1. Components are updated from parent to child. (because parent is always
        //    created before the child)
        // 2. A component's user watchers are run before its render watcher (because
        //    user watchers are created before the render watcher)
        // 3. If a component is destroyed during a parent component's watcher run,
        //    its watchers can be skipped.
        queue.sort(function (a, b) {
          return a.id - b.id;
        });

        // do not cache length because more watchers might be pushed
        // as we run existing watchers
        for (index = 0; index < queue.length; index++) {
          watcher = queue[index];
          id = watcher.id;
          has[id] = null;
          watcher.run();
          // in dev build, check and stop circular updates.
          if (process.env.NODE_ENV !== 'production' && has[id] != null) {
            circular[id] = (circular[id] || 0) + 1;
            if (circular[id] > MAX_UPDATE_COUNT) {
              warn('You may have an infinite update loop ' + (watcher.user ? "in watcher with expression \"" + watcher.expression + "\"" : "in a component render function."), watcher.vm);
              break;
            }
          }
        }

        // keep copies of post queues before resetting state
        var activatedQueue = activatedChildren.slice();
        var updatedQueue = queue.slice();

        resetSchedulerState();

        // call component updated and activated hooks
        callActivatedHooks(activatedQueue);
        callUpdatedHooks(updatedQueue);

        // devtool hook
        /* istanbul ignore if */
        if (devtools && config.devtools) {
          devtools.emit('flush');
        }
      }

      function callUpdatedHooks(queue) {
        var i = queue.length;
        while (i--) {
          var watcher = queue[i];
          var vm = watcher.vm;
          if (vm._watcher === watcher && vm._isMounted) {
            callHook(vm, 'updated');
          }
        }
      }

      /**
       * Queue a kept-alive component that was activated during patch.
       * The queue will be processed after the entire tree has been patched.
       */
      function queueActivatedComponent(vm) {
        // setting _inactive to false here so that a render function can
        // rely on checking whether it's in an inactive tree (e.g. router-view)
        vm._inactive = false;
        activatedChildren.push(vm);
      }

      function callActivatedHooks(queue) {
        for (var i = 0; i < queue.length; i++) {
          queue[i]._inactive = true;
          activateChildComponent(queue[i], true /* true */);
        }
      }

      /**
       * Push a watcher into the watcher queue.
       * Jobs with duplicate IDs will be skipped unless it's
       * pushed when the queue is being flushed.
       */
      function queueWatcher(watcher) {
        var id = watcher.id;
        if (has[id] == null) {
          has[id] = true;
          if (!flushing) {
            queue.push(watcher);
          } else {
            // if already flushing, splice the watcher based on its id
            // if already past its id, it will be run next immediately.
            var i = queue.length - 1;
            while (i > index && queue[i].id > watcher.id) {
              i--;
            }
            queue.splice(i + 1, 0, watcher);
          }
          // queue the flush
          if (!waiting) {
            waiting = true;
            nextTick(flushSchedulerQueue);
          }
        }
      }

      /*  */

      var uid$1 = 0;

      /**
       * A watcher parses an expression, collects dependencies,
       * and fires callback when the expression value changes.
       * This is used for both the $watch() api and directives.
       */
      var Watcher = function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        this.vm = vm;
        if (isRenderWatcher) {
          vm._watcher = this;
        }
        vm._watchers.push(this);
        // options
        if (options) {
          this.deep = !!options.deep;
          this.user = !!options.user;
          this.lazy = !!options.lazy;
          this.sync = !!options.sync;
        } else {
          this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression = process.env.NODE_ENV !== 'production' ? expOrFn.toString() : '';
        // parse expression for getter
        if (typeof expOrFn === 'function') {
          this.getter = expOrFn;
        } else {
          this.getter = parsePath(expOrFn);
          if (!this.getter) {
            this.getter = function () {};
            process.env.NODE_ENV !== 'production' && warn("Failed watching path: \"" + expOrFn + "\" " + 'Watcher only accepts simple dot-delimited paths. ' + 'For full control, use a function instead.', vm);
          }
        }
        this.value = this.lazy ? undefined : this.get();
      };

      /**
       * Evaluate the getter, and re-collect dependencies.
       */
      Watcher.prototype.get = function get() {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
          value = this.getter.call(vm, vm);
        } catch (e) {
          if (this.user) {
            handleError(e, vm, "getter for watcher \"" + this.expression + "\"");
          } else {
            throw e;
          }
        } finally {
          // "touch" every property so they are all tracked as
          // dependencies for deep watching
          if (this.deep) {
            traverse(value);
          }
          popTarget();
          this.cleanupDeps();
        }
        return value;
      };

      /**
       * Add a dependency to this directive.
       */
      Watcher.prototype.addDep = function addDep(dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
          this.newDepIds.add(id);
          this.newDeps.push(dep);
          if (!this.depIds.has(id)) {
            dep.addSub(this);
          }
        }
      };

      /**
       * Clean up for dependency collection.
       */
      Watcher.prototype.cleanupDeps = function cleanupDeps() {
        var this$1 = this;

        var i = this.deps.length;
        while (i--) {
          var dep = this$1.deps[i];
          if (!this$1.newDepIds.has(dep.id)) {
            dep.removeSub(this$1);
          }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
      };

      /**
       * Subscriber interface.
       * Will be called when a dependency changes.
       */
      Watcher.prototype.update = function update() {
        /* istanbul ignore else */
        if (this.lazy) {
          this.dirty = true;
        } else if (this.sync) {
          this.run();
        } else {
          queueWatcher(this);
        }
      };

      /**
       * Scheduler job interface.
       * Will be called by the scheduler.
       */
      Watcher.prototype.run = function run() {
        if (this.active) {
          var value = this.get();
          if (value !== this.value ||
          // Deep watchers and watchers on Object/Arrays should fire even
          // when the value is the same, because the value may
          // have mutated.
          isObject(value) || this.deep) {
            // set new value
            var oldValue = this.value;
            this.value = value;
            if (this.user) {
              try {
                this.cb.call(this.vm, value, oldValue);
              } catch (e) {
                handleError(e, this.vm, "callback for watcher \"" + this.expression + "\"");
              }
            } else {
              this.cb.call(this.vm, value, oldValue);
            }
          }
        }
      };

      /**
       * Evaluate the value of the watcher.
       * This only gets called for lazy watchers.
       */
      Watcher.prototype.evaluate = function evaluate() {
        this.value = this.get();
        this.dirty = false;
      };

      /**
       * Depend on all deps collected by this watcher.
       */
      Watcher.prototype.depend = function depend() {
        var this$1 = this;

        var i = this.deps.length;
        while (i--) {
          this$1.deps[i].depend();
        }
      };

      /**
       * Remove self from all dependencies' subscriber list.
       */
      Watcher.prototype.teardown = function teardown() {
        var this$1 = this;

        if (this.active) {
          // remove self from vm's watcher list
          // this is a somewhat expensive operation so we skip it
          // if the vm is being destroyed.
          if (!this.vm._isBeingDestroyed) {
            remove(this.vm._watchers, this);
          }
          var i = this.deps.length;
          while (i--) {
            this$1.deps[i].removeSub(this$1);
          }
          this.active = false;
        }
      };

      /*  */

      var sharedPropertyDefinition = {
        enumerable: true,
        configurable: true,
        get: noop,
        set: noop
      };

      function proxy(target, sourceKey, key) {
        sharedPropertyDefinition.get = function proxyGetter() {
          return this[sourceKey][key];
        };
        sharedPropertyDefinition.set = function proxySetter(val) {
          this[sourceKey][key] = val;
        };
        Object.defineProperty(target, key, sharedPropertyDefinition);
      }

      function initState(vm) {
        vm._watchers = [];
        var opts = vm.$options;
        if (opts.props) {
          initProps(vm, opts.props);
        }
        if (opts.methods) {
          initMethods(vm, opts.methods);
        }
        if (opts.data) {
          initData(vm);
        } else {
          observe(vm._data = {}, true /* asRootData */);
        }
        if (opts.computed) {
          initComputed(vm, opts.computed);
        }
        if (opts.watch && opts.watch !== nativeWatch) {
          initWatch(vm, opts.watch);
        }
      }

      function initProps(vm, propsOptions) {
        var propsData = vm.$options.propsData || {};
        var props = vm._props = {};
        // cache prop keys so that future props updates can iterate using Array
        // instead of dynamic object key enumeration.
        var keys = vm.$options._propKeys = [];
        var isRoot = !vm.$parent;
        // root instance props should be converted
        if (!isRoot) {
          toggleObserving(false);
        }
        var loop = function loop(key) {
          keys.push(key);
          var value = validateProp(key, propsOptions, propsData, vm);
          /* istanbul ignore else */
          if (process.env.NODE_ENV !== 'production') {
            var hyphenatedKey = hyphenate(key);
            if (isReservedAttribute(hyphenatedKey) || config.isReservedAttr(hyphenatedKey)) {
              warn("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop.", vm);
            }
            defineReactive(props, key, value, function () {
              if (vm.$parent && !isUpdatingChildComponent) {
                warn("Avoid mutating a prop directly since the value will be " + "overwritten whenever the parent component re-renders. " + "Instead, use a data or computed property based on the prop's " + "value. Prop being mutated: \"" + key + "\"", vm);
              }
            });
          } else {
            defineReactive(props, key, value);
          }
          // static props are already proxied on the component's prototype
          // during Vue.extend(). We only need to proxy props defined at
          // instantiation here.
          if (!(key in vm)) {
            proxy(vm, "_props", key);
          }
        };

        for (var key in propsOptions) {
          loop(key);
        }toggleObserving(true);
      }

      function initData(vm) {
        var data = vm.$options.data;
        data = vm._data = typeof data === 'function' ? getData(data, vm) : data || {};
        if (!isPlainObject(data)) {
          data = {};
          process.env.NODE_ENV !== 'production' && warn('data functions should return an object:\n' + 'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
        }
        // proxy data on instance
        var keys = Object.keys(data);
        var props = vm.$options.props;
        var methods = vm.$options.methods;
        var i = keys.length;
        while (i--) {
          var key = keys[i];
          if (process.env.NODE_ENV !== 'production') {
            if (methods && hasOwn(methods, key)) {
              warn("Method \"" + key + "\" has already been defined as a data property.", vm);
            }
          }
          if (props && hasOwn(props, key)) {
            process.env.NODE_ENV !== 'production' && warn("The data property \"" + key + "\" is already declared as a prop. " + "Use prop default value instead.", vm);
          } else if (!isReserved(key)) {
            proxy(vm, "_data", key);
          }
        }
        // observe data
        observe(data, true /* asRootData */);
      }

      function getData(data, vm) {
        // #7573 disable dep collection when invoking data getters
        pushTarget();
        try {
          return data.call(vm, vm);
        } catch (e) {
          handleError(e, vm, "data()");
          return {};
        } finally {
          popTarget();
        }
      }

      var computedWatcherOptions = { lazy: true };

      function initComputed(vm, computed) {
        // $flow-disable-line
        var watchers = vm._computedWatchers = Object.create(null);
        // computed properties are just getters during SSR
        var isSSR = isServerRendering();

        for (var key in computed) {
          var userDef = computed[key];
          var getter = typeof userDef === 'function' ? userDef : userDef.get;
          if (process.env.NODE_ENV !== 'production' && getter == null) {
            warn("Getter is missing for computed property \"" + key + "\".", vm);
          }

          if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
          }

          // component-defined computed properties are already defined on the
          // component prototype. We only need to define computed properties defined
          // at instantiation here.
          if (!(key in vm)) {
            defineComputed(vm, key, userDef);
          } else if (process.env.NODE_ENV !== 'production') {
            if (key in vm.$data) {
              warn("The computed property \"" + key + "\" is already defined in data.", vm);
            } else if (vm.$options.props && key in vm.$options.props) {
              warn("The computed property \"" + key + "\" is already defined as a prop.", vm);
            }
          }
        }
      }

      function defineComputed(target, key, userDef) {
        var shouldCache = !isServerRendering();
        if (typeof userDef === 'function') {
          sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : userDef;
          sharedPropertyDefinition.set = noop;
        } else {
          sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : userDef.get : noop;
          sharedPropertyDefinition.set = userDef.set ? userDef.set : noop;
        }
        if (process.env.NODE_ENV !== 'production' && sharedPropertyDefinition.set === noop) {
          sharedPropertyDefinition.set = function () {
            warn("Computed property \"" + key + "\" was assigned to but it has no setter.", this);
          };
        }
        Object.defineProperty(target, key, sharedPropertyDefinition);
      }

      function createComputedGetter(key) {
        return function computedGetter() {
          var watcher = this._computedWatchers && this._computedWatchers[key];
          if (watcher) {
            if (watcher.dirty) {
              watcher.evaluate();
            }
            if (Dep.target) {
              watcher.depend();
            }
            return watcher.value;
          }
        };
      }

      function initMethods(vm, methods) {
        var props = vm.$options.props;
        for (var key in methods) {
          if (process.env.NODE_ENV !== 'production') {
            if (methods[key] == null) {
              warn("Method \"" + key + "\" has an undefined value in the component definition. " + "Did you reference the function correctly?", vm);
            }
            if (props && hasOwn(props, key)) {
              warn("Method \"" + key + "\" has already been defined as a prop.", vm);
            }
            if (key in vm && isReserved(key)) {
              warn("Method \"" + key + "\" conflicts with an existing Vue instance method. " + "Avoid defining component methods that start with _ or $.");
            }
          }
          vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
        }
      }

      function initWatch(vm, watch) {
        for (var key in watch) {
          var handler = watch[key];
          if (Array.isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
              createWatcher(vm, key, handler[i]);
            }
          } else {
            createWatcher(vm, key, handler);
          }
        }
      }

      function createWatcher(vm, expOrFn, handler, options) {
        if (isPlainObject(handler)) {
          options = handler;
          handler = handler.handler;
        }
        if (typeof handler === 'string') {
          handler = vm[handler];
        }
        return vm.$watch(expOrFn, handler, options);
      }

      function stateMixin(Vue) {
        // flow somehow has problems with directly declared definition object
        // when using Object.defineProperty, so we have to procedurally build up
        // the object here.
        var dataDef = {};
        dataDef.get = function () {
          return this._data;
        };
        var propsDef = {};
        propsDef.get = function () {
          return this._props;
        };
        if (process.env.NODE_ENV !== 'production') {
          dataDef.set = function (newData) {
            warn('Avoid replacing instance root $data. ' + 'Use nested data properties instead.', this);
          };
          propsDef.set = function () {
            warn("$props is readonly.", this);
          };
        }
        Object.defineProperty(Vue.prototype, '$data', dataDef);
        Object.defineProperty(Vue.prototype, '$props', propsDef);

        Vue.prototype.$set = set;
        Vue.prototype.$delete = del;

        Vue.prototype.$watch = function (expOrFn, cb, options) {
          var vm = this;
          if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
          }
          options = options || {};
          options.user = true;
          var watcher = new Watcher(vm, expOrFn, cb, options);
          if (options.immediate) {
            cb.call(vm, watcher.value);
          }
          return function unwatchFn() {
            watcher.teardown();
          };
        };
      }

      /*  */

      function initProvide(vm) {
        var provide = vm.$options.provide;
        if (provide) {
          vm._provided = typeof provide === 'function' ? provide.call(vm) : provide;
        }
      }

      function initInjections(vm) {
        var result = resolveInject(vm.$options.inject, vm);
        if (result) {
          toggleObserving(false);
          Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (process.env.NODE_ENV !== 'production') {
              defineReactive(vm, key, result[key], function () {
                warn("Avoid mutating an injected value directly since the changes will be " + "overwritten whenever the provided component re-renders. " + "injection being mutated: \"" + key + "\"", vm);
              });
            } else {
              defineReactive(vm, key, result[key]);
            }
          });
          toggleObserving(true);
        }
      }

      function resolveInject(inject, vm) {
        if (inject) {
          // inject is :any because flow is not smart enough to figure out cached
          var result = Object.create(null);
          var keys = hasSymbol ? Reflect.ownKeys(inject).filter(function (key) {
            /* istanbul ignore next */
            return Object.getOwnPropertyDescriptor(inject, key).enumerable;
          }) : Object.keys(inject);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var provideKey = inject[key].from;
            var source = vm;
            while (source) {
              if (source._provided && hasOwn(source._provided, provideKey)) {
                result[key] = source._provided[provideKey];
                break;
              }
              source = source.$parent;
            }
            if (!source) {
              if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = typeof provideDefault === 'function' ? provideDefault.call(vm) : provideDefault;
              } else if (process.env.NODE_ENV !== 'production') {
                warn("Injection \"" + key + "\" not found", vm);
              }
            }
          }
          return result;
        }
      }

      /*  */

      /**
       * Runtime helper for rendering v-for lists.
       */
      function renderList(val, render) {
        var ret, i, l, keys, key;
        if (Array.isArray(val) || typeof val === 'string') {
          ret = new Array(val.length);
          for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
          }
        } else if (typeof val === 'number') {
          ret = new Array(val);
          for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
          }
        } else if (isObject(val)) {
          keys = Object.keys(val);
          ret = new Array(keys.length);
          for (i = 0, l = keys.length; i < l; i++) {
            key = keys[i];
            ret[i] = render(val[key], key, i);
          }
        }
        if (isDef(ret)) {
          ret._isVList = true;
        }
        return ret;
      }

      /*  */

      /**
       * Runtime helper for rendering <slot>
       */
      function renderSlot(name, fallback, props, bindObject) {
        var scopedSlotFn = this.$scopedSlots[name];
        var nodes;
        if (scopedSlotFn) {
          // scoped slot
          props = props || {};
          if (bindObject) {
            if (process.env.NODE_ENV !== 'production' && !isObject(bindObject)) {
              warn('slot v-bind without argument expects an Object', this);
            }
            props = extend(extend({}, bindObject), props);
          }
          nodes = scopedSlotFn(props) || fallback;
        } else {
          var slotNodes = this.$slots[name];
          // warn duplicate slot usage
          if (slotNodes) {
            if (process.env.NODE_ENV !== 'production' && slotNodes._rendered) {
              warn("Duplicate presence of slot \"" + name + "\" found in the same render tree " + "- this will likely cause render errors.", this);
            }
            slotNodes._rendered = true;
          }
          nodes = slotNodes || fallback;
        }

        var target = props && props.slot;
        if (target) {
          return this.$createElement('template', { slot: target }, nodes);
        } else {
          return nodes;
        }
      }

      /*  */

      /**
       * Runtime helper for resolving filters
       */
      function resolveFilter(id) {
        return resolveAsset(this.$options, 'filters', id, true) || identity;
      }

      /*  */

      function isKeyNotMatch(expect, actual) {
        if (Array.isArray(expect)) {
          return expect.indexOf(actual) === -1;
        } else {
          return expect !== actual;
        }
      }

      /**
       * Runtime helper for checking keyCodes from config.
       * exposed as Vue.prototype._k
       * passing in eventKeyName as last argument separately for backwards compat
       */
      function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
        var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
        if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
          return isKeyNotMatch(builtInKeyName, eventKeyName);
        } else if (mappedKeyCode) {
          return isKeyNotMatch(mappedKeyCode, eventKeyCode);
        } else if (eventKeyName) {
          return hyphenate(eventKeyName) !== key;
        }
      }

      /*  */

      /**
       * Runtime helper for merging v-bind="object" into a VNode's data.
       */
      function bindObjectProps(data, tag, value, asProp, isSync) {
        if (value) {
          if (!isObject(value)) {
            process.env.NODE_ENV !== 'production' && warn('v-bind without argument expects an Object or Array value', this);
          } else {
            if (Array.isArray(value)) {
              value = toObject(value);
            }
            var hash;
            var loop = function loop(key) {
              if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                hash = data;
              } else {
                var type = data.attrs && data.attrs.type;
                hash = asProp || config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
              }
              if (!(key in hash)) {
                hash[key] = value[key];

                if (isSync) {
                  var on = data.on || (data.on = {});
                  on["update:" + key] = function ($event) {
                    value[key] = $event;
                  };
                }
              }
            };

            for (var key in value) {
              loop(key);
            }
          }
        }
        return data;
      }

      /*  */

      /**
       * Runtime helper for rendering static trees.
       */
      function renderStatic(index, isInFor) {
        var cached = this._staticTrees || (this._staticTrees = []);
        var tree = cached[index];
        // if has already-rendered static tree and not inside v-for,
        // we can reuse the same tree.
        if (tree && !isInFor) {
          return tree;
        }
        // otherwise, render a fresh tree.
        tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, null, this // for render fns generated for functional component templates
        );
        markStatic(tree, "__static__" + index, false);
        return tree;
      }

      /**
       * Runtime helper for v-once.
       * Effectively it means marking the node as static with a unique key.
       */
      function markOnce(tree, index, key) {
        markStatic(tree, "__once__" + index + (key ? "_" + key : ""), true);
        return tree;
      }

      function markStatic(tree, key, isOnce) {
        if (Array.isArray(tree)) {
          for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
              markStaticNode(tree[i], key + "_" + i, isOnce);
            }
          }
        } else {
          markStaticNode(tree, key, isOnce);
        }
      }

      function markStaticNode(node, key, isOnce) {
        node.isStatic = true;
        node.key = key;
        node.isOnce = isOnce;
      }

      /*  */

      function bindObjectListeners(data, value) {
        if (value) {
          if (!isPlainObject(value)) {
            process.env.NODE_ENV !== 'production' && warn('v-on without argument expects an Object value', this);
          } else {
            var on = data.on = data.on ? extend({}, data.on) : {};
            for (var key in value) {
              var existing = on[key];
              var ours = value[key];
              on[key] = existing ? [].concat(existing, ours) : ours;
            }
          }
        }
        return data;
      }

      /*  */

      function installRenderHelpers(target) {
        target._o = markOnce;
        target._n = toNumber;
        target._s = toString;
        target._l = renderList;
        target._t = renderSlot;
        target._q = looseEqual;
        target._i = looseIndexOf;
        target._m = renderStatic;
        target._f = resolveFilter;
        target._k = checkKeyCodes;
        target._b = bindObjectProps;
        target._v = createTextVNode;
        target._e = createEmptyVNode;
        target._u = resolveScopedSlots;
        target._g = bindObjectListeners;
      }

      /*  */

      function FunctionalRenderContext(data, props, children, parent, Ctor) {
        var options = Ctor.options;
        // ensure the createElement function in functional components
        // gets a unique context - this is necessary for correct named slot check
        var contextVm;
        if (hasOwn(parent, '_uid')) {
          contextVm = Object.create(parent);
          // $flow-disable-line
          contextVm._original = parent;
        } else {
          // the context vm passed in is a functional context as well.
          // in this case we want to make sure we are able to get a hold to the
          // real context instance.
          contextVm = parent;
          // $flow-disable-line
          parent = parent._original;
        }
        var isCompiled = isTrue(options._compiled);
        var needNormalization = !isCompiled;

        this.data = data;
        this.props = props;
        this.children = children;
        this.parent = parent;
        this.listeners = data.on || emptyObject;
        this.injections = resolveInject(options.inject, parent);
        this.slots = function () {
          return resolveSlots(children, parent);
        };

        // support for compiled functional template
        if (isCompiled) {
          // exposing $options for renderStatic()
          this.$options = options;
          // pre-resolve slots for renderSlot()
          this.$slots = this.slots();
          this.$scopedSlots = data.scopedSlots || emptyObject;
        }

        if (options._scopeId) {
          this._c = function (a, b, c, d) {
            var vnode = createElement(contextVm, a, b, c, d, needNormalization);
            if (vnode && !Array.isArray(vnode)) {
              vnode.fnScopeId = options._scopeId;
              vnode.fnContext = parent;
            }
            return vnode;
          };
        } else {
          this._c = function (a, b, c, d) {
            return createElement(contextVm, a, b, c, d, needNormalization);
          };
        }
      }

      installRenderHelpers(FunctionalRenderContext.prototype);

      function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
        var options = Ctor.options;
        var props = {};
        var propOptions = options.props;
        if (isDef(propOptions)) {
          for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
          }
        } else {
          if (isDef(data.attrs)) {
            mergeProps(props, data.attrs);
          }
          if (isDef(data.props)) {
            mergeProps(props, data.props);
          }
        }

        var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);

        var vnode = options.render.call(null, renderContext._c, renderContext);

        if (vnode instanceof VNode) {
          return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options);
        } else if (Array.isArray(vnode)) {
          var vnodes = normalizeChildren(vnode) || [];
          var res = new Array(vnodes.length);
          for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
          }
          return res;
        }
      }

      function cloneAndMarkFunctionalResult(vnode, data, contextVm, options) {
        // #7817 clone node before setting fnContext, otherwise if the node is reused
        // (e.g. it was from a cached normal slot) the fnContext causes named slots
        // that should not be matched to match.
        var clone = cloneVNode(vnode);
        clone.fnContext = contextVm;
        clone.fnOptions = options;
        if (data.slot) {
          (clone.data || (clone.data = {})).slot = data.slot;
        }
        return clone;
      }

      function mergeProps(to, from) {
        for (var key in from) {
          to[camelize(key)] = from[key];
        }
      }

      /*  */

      // Register the component hook to weex native render engine.
      // The hook will be triggered by native, not javascript.


      // Updates the state of the component to weex native render engine.

      /*  */

      // https://github.com/Hanks10100/weex-native-directive/tree/master/component

      // listening on native callback

      /*  */

      /*  */

      // inline hooks to be invoked on component VNodes during patch
      var componentVNodeHooks = {
        init: function init(vnode, hydrating, parentElm, refElm) {
          if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
          } else {
            var child = vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance, parentElm, refElm);
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
          }
        },

        prepatch: function prepatch(oldVnode, vnode) {
          var options = vnode.componentOptions;
          var child = vnode.componentInstance = oldVnode.componentInstance;
          updateChildComponent(child, options.propsData, // updated props
          options.listeners, // updated listeners
          vnode, // new parent vnode
          options.children // new children
          );
        },

        insert: function insert(vnode) {
          var context = vnode.context;
          var componentInstance = vnode.componentInstance;
          if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook(componentInstance, 'mounted');
          }
          if (vnode.data.keepAlive) {
            if (context._isMounted) {
              // vue-router#1212
              // During updates, a kept-alive component's child components may
              // change, so directly walking the tree here may call activated hooks
              // on incorrect children. Instead we push them into a queue which will
              // be processed after the whole patch process ended.
              queueActivatedComponent(componentInstance);
            } else {
              activateChildComponent(componentInstance, true /* direct */);
            }
          }
        },

        destroy: function destroy(vnode) {
          var componentInstance = vnode.componentInstance;
          if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
              componentInstance.$destroy();
            } else {
              deactivateChildComponent(componentInstance, true /* direct */);
            }
          }
        }
      };

      var hooksToMerge = Object.keys(componentVNodeHooks);

      function createComponent(Ctor, data, context, children, tag) {
        if (isUndef(Ctor)) {
          return;
        }

        var baseCtor = context.$options._base;

        // plain options object: turn it into a constructor
        if (isObject(Ctor)) {
          Ctor = baseCtor.extend(Ctor);
        }

        // if at this stage it's not a constructor or an async component factory,
        // reject.
        if (typeof Ctor !== 'function') {
          if (process.env.NODE_ENV !== 'production') {
            warn("Invalid Component definition: " + String(Ctor), context);
          }
          return;
        }

        // async component
        var asyncFactory;
        if (isUndef(Ctor.cid)) {
          asyncFactory = Ctor;
          Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
          if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
          }
        }

        data = data || {};

        // resolve constructor options in case global mixins are applied after
        // component constructor creation
        resolveConstructorOptions(Ctor);

        // transform component v-model data into props & events
        if (isDef(data.model)) {
          transformModel(Ctor.options, data);
        }

        // extract props
        var propsData = extractPropsFromVNodeData(data, Ctor, tag);

        // functional component
        if (isTrue(Ctor.options.functional)) {
          return createFunctionalComponent(Ctor, propsData, data, context, children);
        }

        // extract listeners, since these needs to be treated as
        // child component listeners instead of DOM listeners
        var listeners = data.on;
        // replace with listeners with .native modifier
        // so it gets processed during parent component patch.
        data.on = data.nativeOn;

        if (isTrue(Ctor.options.abstract)) {
          // abstract components do not keep anything
          // other than props & listeners & slot

          // work around flow
          var slot = data.slot;
          data = {};
          if (slot) {
            data.slot = slot;
          }
        }

        // install component management hooks onto the placeholder node
        installComponentHooks(data);

        // return a placeholder vnode
        var name = Ctor.options.name || tag;
        var vnode = new VNode("vue-component-" + Ctor.cid + (name ? "-" + name : ''), data, undefined, undefined, undefined, context, { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);

        // Weex specific: invoke recycle-list optimized @render function for
        // extracting cell-slot template.
        // https://github.com/Hanks10100/weex-native-directive/tree/master/component
        /* istanbul ignore if */
        return vnode;
      }

      function createComponentInstanceForVnode(vnode, // we know it's MountedComponentVNode but flow doesn't
      parent, // activeInstance in lifecycle state
      parentElm, refElm) {
        var options = {
          _isComponent: true,
          parent: parent,
          _parentVnode: vnode,
          _parentElm: parentElm || null,
          _refElm: refElm || null
        };
        // check inline-template render functions
        var inlineTemplate = vnode.data.inlineTemplate;
        if (isDef(inlineTemplate)) {
          options.render = inlineTemplate.render;
          options.staticRenderFns = inlineTemplate.staticRenderFns;
        }
        return new vnode.componentOptions.Ctor(options);
      }

      function installComponentHooks(data) {
        var hooks = data.hook || (data.hook = {});
        for (var i = 0; i < hooksToMerge.length; i++) {
          var key = hooksToMerge[i];
          hooks[key] = componentVNodeHooks[key];
        }
      }

      // transform component v-model info (value and callback) into
      // prop and event handler respectively.
      function transformModel(options, data) {
        var prop = options.model && options.model.prop || 'value';
        var event = options.model && options.model.event || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
        var on = data.on || (data.on = {});
        if (isDef(on[event])) {
          on[event] = [data.model.callback].concat(on[event]);
        } else {
          on[event] = data.model.callback;
        }
      }

      /*  */

      var SIMPLE_NORMALIZE = 1;
      var ALWAYS_NORMALIZE = 2;

      // wrapper function for providing a more flexible interface
      // without getting yelled at by flow
      function createElement(context, tag, data, children, normalizationType, alwaysNormalize) {
        if (Array.isArray(data) || isPrimitive(data)) {
          normalizationType = children;
          children = data;
          data = undefined;
        }
        if (isTrue(alwaysNormalize)) {
          normalizationType = ALWAYS_NORMALIZE;
        }
        return _createElement(context, tag, data, children, normalizationType);
      }

      function _createElement(context, tag, data, children, normalizationType) {
        if (isDef(data) && isDef(data.__ob__)) {
          process.env.NODE_ENV !== 'production' && warn("Avoid using observed data object as vnode data: " + JSON.stringify(data) + "\n" + 'Always create fresh vnode data objects in each render!', context);
          return createEmptyVNode();
        }
        // object syntax in v-bind
        if (isDef(data) && isDef(data.is)) {
          tag = data.is;
        }
        if (!tag) {
          // in case of component :is set to falsy value
          return createEmptyVNode();
        }
        // warn against non-primitive key
        if (process.env.NODE_ENV !== 'production' && isDef(data) && isDef(data.key) && !isPrimitive(data.key)) {
          {
            warn('Avoid using non-primitive value as key, ' + 'use string/number value instead.', context);
          }
        }
        // support single function children as default scoped slot
        if (Array.isArray(children) && typeof children[0] === 'function') {
          data = data || {};
          data.scopedSlots = { default: children[0] };
          children.length = 0;
        }
        if (normalizationType === ALWAYS_NORMALIZE) {
          children = normalizeChildren(children);
        } else if (normalizationType === SIMPLE_NORMALIZE) {
          children = simpleNormalizeChildren(children);
        }
        var vnode, ns;
        if (typeof tag === 'string') {
          var Ctor;
          ns = context.$vnode && context.$vnode.ns || config.getTagNamespace(tag);
          if (config.isReservedTag(tag)) {
            // platform built-in elements
            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
          } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
          } else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
          }
        } else {
          // direct component options / constructor
          vnode = createComponent(tag, data, context, children);
        }
        if (Array.isArray(vnode)) {
          return vnode;
        } else if (isDef(vnode)) {
          if (isDef(ns)) {
            applyNS(vnode, ns);
          }
          if (isDef(data)) {
            registerDeepBindings(data);
          }
          return vnode;
        } else {
          return createEmptyVNode();
        }
      }

      function applyNS(vnode, ns, force) {
        vnode.ns = ns;
        if (vnode.tag === 'foreignObject') {
          // use default namespace inside foreignObject
          ns = undefined;
          force = true;
        }
        if (isDef(vnode.children)) {
          for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== 'svg')) {
              applyNS(child, ns, force);
            }
          }
        }
      }

      // ref #5318
      // necessary to ensure parent re-render when deep bindings like :style and
      // :class are used on slot nodes
      function registerDeepBindings(data) {
        if (isObject(data.style)) {
          traverse(data.style);
        }
        if (isObject(data.class)) {
          traverse(data.class);
        }
      }

      /*  */

      function initRender(vm) {
        vm._vnode = null; // the root of the child tree
        vm._staticTrees = null; // v-once cached trees
        var options = vm.$options;
        var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
        var renderContext = parentVnode && parentVnode.context;
        vm.$slots = resolveSlots(options._renderChildren, renderContext);
        vm.$scopedSlots = emptyObject;
        // bind the createElement fn to this instance
        // so that we get proper render context inside it.
        // args order: tag, data, children, normalizationType, alwaysNormalize
        // internal version is used by render functions compiled from templates
        vm._c = function (a, b, c, d) {
          return createElement(vm, a, b, c, d, false);
        };
        // normalization is always applied for the public version, used in
        // user-written render functions.
        vm.$createElement = function (a, b, c, d) {
          return createElement(vm, a, b, c, d, true);
        };

        // $attrs & $listeners are exposed for easier HOC creation.
        // they need to be reactive so that HOCs using them are always updated
        var parentData = parentVnode && parentVnode.data;

        /* istanbul ignore else */
        if (process.env.NODE_ENV !== 'production') {
          defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
            !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
          }, true);
          defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
            !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
          }, true);
        } else {
          defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
          defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
        }
      }

      function renderMixin(Vue) {
        // install runtime convenience helpers
        installRenderHelpers(Vue.prototype);

        Vue.prototype.$nextTick = function (fn) {
          return nextTick(fn, this);
        };

        Vue.prototype._render = function () {
          var vm = this;
          var ref = vm.$options;
          var render = ref.render;
          var _parentVnode = ref._parentVnode;

          // reset _rendered flag on slots for duplicate slot check
          if (process.env.NODE_ENV !== 'production') {
            for (var key in vm.$slots) {
              // $flow-disable-line
              vm.$slots[key]._rendered = false;
            }
          }

          if (_parentVnode) {
            vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
          }

          // set parent vnode. this allows render functions to have access
          // to the data on the placeholder node.
          vm.$vnode = _parentVnode;
          // render self
          var vnode;
          try {
            vnode = render.call(vm._renderProxy, vm.$createElement);
          } catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (process.env.NODE_ENV !== 'production') {
              if (vm.$options.renderError) {
                try {
                  vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                } catch (e) {
                  handleError(e, vm, "renderError");
                  vnode = vm._vnode;
                }
              } else {
                vnode = vm._vnode;
              }
            } else {
              vnode = vm._vnode;
            }
          }
          // return empty vnode in case the render function errored out
          if (!(vnode instanceof VNode)) {
            if (process.env.NODE_ENV !== 'production' && Array.isArray(vnode)) {
              warn('Multiple root nodes returned from render function. Render function ' + 'should return a single root node.', vm);
            }
            vnode = createEmptyVNode();
          }
          // set parent
          vnode.parent = _parentVnode;
          return vnode;
        };
      }

      /*  */

      var uid$3 = 0;

      function initMixin(Vue) {
        Vue.prototype._init = function (options) {
          var vm = this;
          // a uid
          vm._uid = uid$3++;

          var startTag, endTag;
          /* istanbul ignore if */
          if (process.env.NODE_ENV !== 'production' && config.performance && mark) {
            startTag = "vue-perf-start:" + vm._uid;
            endTag = "vue-perf-end:" + vm._uid;
            mark(startTag);
          }

          // a flag to avoid this being observed
          vm._isVue = true;
          // merge options
          if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
          } else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
          }
          /* istanbul ignore else */
          if (process.env.NODE_ENV !== 'production') {
            initProxy(vm);
          } else {
            vm._renderProxy = vm;
          }
          // expose real self
          vm._self = vm;
          initLifecycle(vm);
          initEvents(vm);
          initRender(vm);
          callHook(vm, 'beforeCreate');
          initInjections(vm); // resolve injections before data/props
          initState(vm);
          initProvide(vm); // resolve provide after data/props
          callHook(vm, 'created');

          /* istanbul ignore if */
          if (process.env.NODE_ENV !== 'production' && config.performance && mark) {
            vm._name = formatComponentName(vm, false);
            mark(endTag);
            measure("vue " + vm._name + " init", startTag, endTag);
          }

          if (vm.$options.el) {
            vm.$mount(vm.$options.el);
          }
        };
      }

      function initInternalComponent(vm, options) {
        var opts = vm.$options = Object.create(vm.constructor.options);
        // doing this because it's faster than dynamic enumeration.
        var parentVnode = options._parentVnode;
        opts.parent = options.parent;
        opts._parentVnode = parentVnode;
        opts._parentElm = options._parentElm;
        opts._refElm = options._refElm;

        var vnodeComponentOptions = parentVnode.componentOptions;
        opts.propsData = vnodeComponentOptions.propsData;
        opts._parentListeners = vnodeComponentOptions.listeners;
        opts._renderChildren = vnodeComponentOptions.children;
        opts._componentTag = vnodeComponentOptions.tag;

        if (options.render) {
          opts.render = options.render;
          opts.staticRenderFns = options.staticRenderFns;
        }
      }

      function resolveConstructorOptions(Ctor) {
        var options = Ctor.options;
        if (Ctor.super) {
          var superOptions = resolveConstructorOptions(Ctor.super);
          var cachedSuperOptions = Ctor.superOptions;
          if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
              extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
              options.components[options.name] = Ctor;
            }
          }
        }
        return options;
      }

      function resolveModifiedOptions(Ctor) {
        var modified;
        var latest = Ctor.options;
        var extended = Ctor.extendOptions;
        var sealed = Ctor.sealedOptions;
        for (var key in latest) {
          if (latest[key] !== sealed[key]) {
            if (!modified) {
              modified = {};
            }
            modified[key] = dedupe(latest[key], extended[key], sealed[key]);
          }
        }
        return modified;
      }

      function dedupe(latest, extended, sealed) {
        // compare latest and sealed to ensure lifecycle hooks won't be duplicated
        // between merges
        if (Array.isArray(latest)) {
          var res = [];
          sealed = Array.isArray(sealed) ? sealed : [sealed];
          extended = Array.isArray(extended) ? extended : [extended];
          for (var i = 0; i < latest.length; i++) {
            // push original options and not sealed options to exclude duplicated options
            if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
              res.push(latest[i]);
            }
          }
          return res;
        } else {
          return latest;
        }
      }

      function Vue(options) {
        if (process.env.NODE_ENV !== 'production' && !(this instanceof Vue)) {
          warn('Vue is a constructor and should be called with the `new` keyword');
        }
        this._init(options);
      }

      initMixin(Vue);
      stateMixin(Vue);
      eventsMixin(Vue);
      lifecycleMixin(Vue);
      renderMixin(Vue);

      /*  */

      function initUse(Vue) {
        Vue.use = function (plugin) {
          var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
          if (installedPlugins.indexOf(plugin) > -1) {
            return this;
          }

          // additional parameters
          var args = toArray(arguments, 1);
          args.unshift(this);
          if (typeof plugin.install === 'function') {
            plugin.install.apply(plugin, args);
          } else if (typeof plugin === 'function') {
            plugin.apply(null, args);
          }
          installedPlugins.push(plugin);
          return this;
        };
      }

      /*  */

      function initMixin$1(Vue) {
        Vue.mixin = function (mixin) {
          this.options = mergeOptions(this.options, mixin);
          return this;
        };
      }

      /*  */

      function initExtend(Vue) {
        /**
         * Each instance constructor, including Vue, has a unique
         * cid. This enables us to create wrapped "child
         * constructors" for prototypal inheritance and cache them.
         */
        Vue.cid = 0;
        var cid = 1;

        /**
         * Class inheritance
         */
        Vue.extend = function (extendOptions) {
          extendOptions = extendOptions || {};
          var Super = this;
          var SuperId = Super.cid;
          var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
          if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
          }

          var name = extendOptions.name || Super.options.name;
          if (process.env.NODE_ENV !== 'production' && name) {
            validateComponentName(name);
          }

          var Sub = function VueComponent(options) {
            this._init(options);
          };
          Sub.prototype = Object.create(Super.prototype);
          Sub.prototype.constructor = Sub;
          Sub.cid = cid++;
          Sub.options = mergeOptions(Super.options, extendOptions);
          Sub['super'] = Super;

          // For props and computed properties, we define the proxy getters on
          // the Vue instances at extension time, on the extended prototype. This
          // avoids Object.defineProperty calls for each instance created.
          if (Sub.options.props) {
            initProps$1(Sub);
          }
          if (Sub.options.computed) {
            initComputed$1(Sub);
          }

          // allow further extension/mixin/plugin usage
          Sub.extend = Super.extend;
          Sub.mixin = Super.mixin;
          Sub.use = Super.use;

          // create asset registers, so extended classes
          // can have their private assets too.
          ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
          });
          // enable recursive self-lookup
          if (name) {
            Sub.options.components[name] = Sub;
          }

          // keep a reference to the super options at extension time.
          // later at instantiation we can check if Super's options have
          // been updated.
          Sub.superOptions = Super.options;
          Sub.extendOptions = extendOptions;
          Sub.sealedOptions = extend({}, Sub.options);

          // cache constructor
          cachedCtors[SuperId] = Sub;
          return Sub;
        };
      }

      function initProps$1(Comp) {
        var props = Comp.options.props;
        for (var key in props) {
          proxy(Comp.prototype, "_props", key);
        }
      }

      function initComputed$1(Comp) {
        var computed = Comp.options.computed;
        for (var key in computed) {
          defineComputed(Comp.prototype, key, computed[key]);
        }
      }

      /*  */

      function initAssetRegisters(Vue) {
        /**
         * Create asset registration methods.
         */
        ASSET_TYPES.forEach(function (type) {
          Vue[type] = function (id, definition) {
            if (!definition) {
              return this.options[type + 's'][id];
            } else {
              /* istanbul ignore if */
              if (process.env.NODE_ENV !== 'production' && type === 'component') {
                validateComponentName(id);
              }
              if (type === 'component' && isPlainObject(definition)) {
                definition.name = definition.name || id;
                definition = this.options._base.extend(definition);
              }
              if (type === 'directive' && typeof definition === 'function') {
                definition = { bind: definition, update: definition };
              }
              this.options[type + 's'][id] = definition;
              return definition;
            }
          };
        });
      }

      /*  */

      function getComponentName(opts) {
        return opts && (opts.Ctor.options.name || opts.tag);
      }

      function matches(pattern, name) {
        if (Array.isArray(pattern)) {
          return pattern.indexOf(name) > -1;
        } else if (typeof pattern === 'string') {
          return pattern.split(',').indexOf(name) > -1;
        } else if (isRegExp(pattern)) {
          return pattern.test(name);
        }
        /* istanbul ignore next */
        return false;
      }

      function pruneCache(keepAliveInstance, filter) {
        var cache = keepAliveInstance.cache;
        var keys = keepAliveInstance.keys;
        var _vnode = keepAliveInstance._vnode;
        for (var key in cache) {
          var cachedNode = cache[key];
          if (cachedNode) {
            var name = getComponentName(cachedNode.componentOptions);
            if (name && !filter(name)) {
              pruneCacheEntry(cache, key, keys, _vnode);
            }
          }
        }
      }

      function pruneCacheEntry(cache, key, keys, current) {
        var cached$$1 = cache[key];
        if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
          cached$$1.componentInstance.$destroy();
        }
        cache[key] = null;
        remove(keys, key);
      }

      var patternTypes = [String, RegExp, Array];

      var KeepAlive = {
        name: 'keep-alive',
        abstract: true,

        props: {
          include: patternTypes,
          exclude: patternTypes,
          max: [String, Number]
        },

        created: function created() {
          this.cache = Object.create(null);
          this.keys = [];
        },

        destroyed: function destroyed() {
          var this$1 = this;

          for (var key in this$1.cache) {
            pruneCacheEntry(this$1.cache, key, this$1.keys);
          }
        },

        mounted: function mounted() {
          var this$1 = this;

          this.$watch('include', function (val) {
            pruneCache(this$1, function (name) {
              return matches(val, name);
            });
          });
          this.$watch('exclude', function (val) {
            pruneCache(this$1, function (name) {
              return !matches(val, name);
            });
          });
        },

        render: function render() {
          var slot = this.$slots.default;
          var vnode = getFirstComponentChild(slot);
          var componentOptions = vnode && vnode.componentOptions;
          if (componentOptions) {
            // check pattern
            var name = getComponentName(componentOptions);
            var ref = this;
            var include = ref.include;
            var exclude = ref.exclude;
            if (
            // not included
            include && (!name || !matches(include, name)) ||
            // excluded
            exclude && name && matches(exclude, name)) {
              return vnode;
            }

            var ref$1 = this;
            var cache = ref$1.cache;
            var keys = ref$1.keys;
            var key = vnode.key == null
            // same constructor may get registered as different local components
            // so cid alone is not enough (#3269)
            ? componentOptions.Ctor.cid + (componentOptions.tag ? "::" + componentOptions.tag : '') : vnode.key;
            if (cache[key]) {
              vnode.componentInstance = cache[key].componentInstance;
              // make current key freshest
              remove(keys, key);
              keys.push(key);
            } else {
              cache[key] = vnode;
              keys.push(key);
              // prune oldest entry
              if (this.max && keys.length > parseInt(this.max)) {
                pruneCacheEntry(cache, keys[0], keys, this._vnode);
              }
            }

            vnode.data.keepAlive = true;
          }
          return vnode || slot && slot[0];
        }
      };

      var builtInComponents = {
        KeepAlive: KeepAlive

        /*  */

      };function initGlobalAPI(Vue) {
        // config
        var configDef = {};
        configDef.get = function () {
          return config;
        };
        if (process.env.NODE_ENV !== 'production') {
          configDef.set = function () {
            warn('Do not replace the Vue.config object, set individual fields instead.');
          };
        }
        Object.defineProperty(Vue, 'config', configDef);

        // exposed util methods.
        // NOTE: these are not considered part of the public API - avoid relying on
        // them unless you are aware of the risk.
        Vue.util = {
          warn: warn,
          extend: extend,
          mergeOptions: mergeOptions,
          defineReactive: defineReactive
        };

        Vue.set = set;
        Vue.delete = del;
        Vue.nextTick = nextTick;

        Vue.options = Object.create(null);
        ASSET_TYPES.forEach(function (type) {
          Vue.options[type + 's'] = Object.create(null);
        });

        // this is used to identify the "base" constructor to extend all plain-object
        // components with in Weex's multi-instance scenarios.
        Vue.options._base = Vue;

        extend(Vue.options.components, builtInComponents);

        initUse(Vue);
        initMixin$1(Vue);
        initExtend(Vue);
        initAssetRegisters(Vue);
      }

      initGlobalAPI(Vue);

      Object.defineProperty(Vue.prototype, '$isServer', {
        get: isServerRendering
      });

      Object.defineProperty(Vue.prototype, '$ssrContext', {
        get: function get() {
          /* istanbul ignore next */
          return this.$vnode && this.$vnode.ssrContext;
        }
      });

      // expose FunctionalRenderContext for ssr runtime helper installation
      Object.defineProperty(Vue, 'FunctionalRenderContext', {
        value: FunctionalRenderContext
      });

      Vue.version = '2.5.16';

      /*  */

      // these are reserved for web because they are directly compiled away
      // during template compilation
      var isReservedAttr = makeMap('style,class');

      // attributes that should be using props for binding
      var acceptValue = makeMap('input,textarea,option,select,progress');
      var mustUseProp = function mustUseProp(tag, type, attr) {
        return attr === 'value' && acceptValue(tag) && type !== 'button' || attr === 'selected' && tag === 'option' || attr === 'checked' && tag === 'input' || attr === 'muted' && tag === 'video';
      };

      var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

      var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' + 'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' + 'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' + 'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' + 'required,reversed,scoped,seamless,selected,sortable,translate,' + 'truespeed,typemustmatch,visible');

      var xlinkNS = 'http://www.w3.org/1999/xlink';

      var isXlink = function isXlink(name) {
        return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
      };

      var getXlinkProp = function getXlinkProp(name) {
        return isXlink(name) ? name.slice(6, name.length) : '';
      };

      var isFalsyAttrValue = function isFalsyAttrValue(val) {
        return val == null || val === false;
      };

      /*  */

      function genClassForVnode(vnode) {
        var data = vnode.data;
        var parentNode = vnode;
        var childNode = vnode;
        while (isDef(childNode.componentInstance)) {
          childNode = childNode.componentInstance._vnode;
          if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
          }
        }
        while (isDef(parentNode = parentNode.parent)) {
          if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
          }
        }
        return renderClass(data.staticClass, data.class);
      }

      function mergeClassData(child, parent) {
        return {
          staticClass: concat(child.staticClass, parent.staticClass),
          class: isDef(child.class) ? [child.class, parent.class] : parent.class
        };
      }

      function renderClass(staticClass, dynamicClass) {
        if (isDef(staticClass) || isDef(dynamicClass)) {
          return concat(staticClass, stringifyClass(dynamicClass));
        }
        /* istanbul ignore next */
        return '';
      }

      function concat(a, b) {
        return a ? b ? a + ' ' + b : a : b || '';
      }

      function stringifyClass(value) {
        if (Array.isArray(value)) {
          return stringifyArray(value);
        }
        if (isObject(value)) {
          return stringifyObject(value);
        }
        if (typeof value === 'string') {
          return value;
        }
        /* istanbul ignore next */
        return '';
      }

      function stringifyArray(value) {
        var res = '';
        var stringified;
        for (var i = 0, l = value.length; i < l; i++) {
          if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
            if (res) {
              res += ' ';
            }
            res += stringified;
          }
        }
        return res;
      }

      function stringifyObject(value) {
        var res = '';
        for (var key in value) {
          if (value[key]) {
            if (res) {
              res += ' ';
            }
            res += key;
          }
        }
        return res;
      }

      /*  */

      var namespaceMap = {
        svg: 'http://www.w3.org/2000/svg',
        math: 'http://www.w3.org/1998/Math/MathML'
      };

      var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' + 'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' + 'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' + 'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' + 's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' + 'embed,object,param,source,canvas,script,noscript,del,ins,' + 'caption,col,colgroup,table,thead,tbody,td,th,tr,' + 'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' + 'output,progress,select,textarea,' + 'details,dialog,menu,menuitem,summary,' + 'content,element,shadow,template,blockquote,iframe,tfoot');

      // this map is intentionally selective, only covering SVG elements that may
      // contain child elements.
      var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' + 'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' + 'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);

      var isReservedTag = function isReservedTag(tag) {
        return isHTMLTag(tag) || isSVG(tag);
      };

      function getTagNamespace(tag) {
        if (isSVG(tag)) {
          return 'svg';
        }
        // basic support for MathML
        // note it doesn't support other MathML elements being component roots
        if (tag === 'math') {
          return 'math';
        }
      }

      var unknownElementCache = Object.create(null);
      function isUnknownElement(tag) {
        /* istanbul ignore if */
        if (!inBrowser) {
          return true;
        }
        if (isReservedTag(tag)) {
          return false;
        }
        tag = tag.toLowerCase();
        /* istanbul ignore if */
        if (unknownElementCache[tag] != null) {
          return unknownElementCache[tag];
        }
        var el = document.createElement(tag);
        if (tag.indexOf('-') > -1) {
          // http://stackoverflow.com/a/28210364/1070244
          return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
        } else {
          return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
        }
      }

      var isTextInputType = makeMap('text,number,password,search,email,tel,url');

      /*  */

      /**
       * Query an element selector if it's not an element already.
       */
      function query(el) {
        if (typeof el === 'string') {
          var selected = document.querySelector(el);
          if (!selected) {
            process.env.NODE_ENV !== 'production' && warn('Cannot find element: ' + el);
            return document.createElement('div');
          }
          return selected;
        } else {
          return el;
        }
      }

      /*  */

      function createElement$1(tagName, vnode) {
        var elm = document.createElement(tagName);
        if (tagName !== 'select') {
          return elm;
        }
        // false or null will remove the attribute but undefined will not
        if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
          elm.setAttribute('multiple', 'multiple');
        }
        return elm;
      }

      function createElementNS(namespace, tagName) {
        return document.createElementNS(namespaceMap[namespace], tagName);
      }

      function createTextNode(text) {
        return document.createTextNode(text);
      }

      function createComment(text) {
        return document.createComment(text);
      }

      function insertBefore(parentNode, newNode, referenceNode) {
        parentNode.insertBefore(newNode, referenceNode);
      }

      function removeChild(node, child) {
        node.removeChild(child);
      }

      function appendChild(node, child) {
        node.appendChild(child);
      }

      function parentNode(node) {
        return node.parentNode;
      }

      function nextSibling(node) {
        return node.nextSibling;
      }

      function tagName(node) {
        return node.tagName;
      }

      function setTextContent(node, text) {
        node.textContent = text;
      }

      function setStyleScope(node, scopeId) {
        node.setAttribute(scopeId, '');
      }

      var nodeOps = Object.freeze({
        createElement: createElement$1,
        createElementNS: createElementNS,
        createTextNode: createTextNode,
        createComment: createComment,
        insertBefore: insertBefore,
        removeChild: removeChild,
        appendChild: appendChild,
        parentNode: parentNode,
        nextSibling: nextSibling,
        tagName: tagName,
        setTextContent: setTextContent,
        setStyleScope: setStyleScope
      });

      /*  */

      var ref = {
        create: function create(_, vnode) {
          registerRef(vnode);
        },
        update: function update(oldVnode, vnode) {
          if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
          }
        },
        destroy: function destroy(vnode) {
          registerRef(vnode, true);
        }
      };

      function registerRef(vnode, isRemoval) {
        var key = vnode.data.ref;
        if (!isDef(key)) {
          return;
        }

        var vm = vnode.context;
        var ref = vnode.componentInstance || vnode.elm;
        var refs = vm.$refs;
        if (isRemoval) {
          if (Array.isArray(refs[key])) {
            remove(refs[key], ref);
          } else if (refs[key] === ref) {
            refs[key] = undefined;
          }
        } else {
          if (vnode.data.refInFor) {
            if (!Array.isArray(refs[key])) {
              refs[key] = [ref];
            } else if (refs[key].indexOf(ref) < 0) {
              // $flow-disable-line
              refs[key].push(ref);
            }
          } else {
            refs[key] = ref;
          }
        }
      }

      /**
       * Virtual DOM patching algorithm based on Snabbdom by
       * Simon Friis Vindum (@paldepind)
       * Licensed under the MIT License
       * https://github.com/paldepind/snabbdom/blob/master/LICENSE
       *
       * modified by Evan You (@yyx990803)
       *
       * Not type-checking this because this file is perf-critical and the cost
       * of making flow understand it is not worth it.
       */

      var emptyNode = new VNode('', {}, []);

      var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

      function sameVnode(a, b) {
        return a.key === b.key && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && a.asyncFactory === b.asyncFactory && isUndef(b.asyncFactory.error));
      }

      function sameInputType(a, b) {
        if (a.tag !== 'input') {
          return true;
        }
        var i;
        var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
        var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
        return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
      }

      function createKeyToOldIdx(children, beginIdx, endIdx) {
        var i, key;
        var map = {};
        for (i = beginIdx; i <= endIdx; ++i) {
          key = children[i].key;
          if (isDef(key)) {
            map[key] = i;
          }
        }
        return map;
      }

      function createPatchFunction(backend) {
        var i, j;
        var cbs = {};

        var modules = backend.modules;
        var nodeOps = backend.nodeOps;

        for (i = 0; i < hooks.length; ++i) {
          cbs[hooks[i]] = [];
          for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
              cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
          }
        }

        function emptyNodeAt(elm) {
          return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
        }

        function createRmCb(childElm, listeners) {
          function remove() {
            if (--remove.listeners === 0) {
              removeNode(childElm);
            }
          }
          remove.listeners = listeners;
          return remove;
        }

        function removeNode(el) {
          var parent = nodeOps.parentNode(el);
          // element may have already been removed due to v-html / v-text
          if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
          }
        }

        function isUnknownElement$$1(vnode, inVPre) {
          return !inVPre && !vnode.ns && !(config.ignoredElements.length && config.ignoredElements.some(function (ignore) {
            return isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
          })) && config.isUnknownElement(vnode.tag);
        }

        var creatingElmInVPre = 0;

        function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
          if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
          }

          vnode.isRootInsert = !nested; // for transition enter check
          if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
          }

          var data = vnode.data;
          var children = vnode.children;
          var tag = vnode.tag;
          if (isDef(tag)) {
            if (process.env.NODE_ENV !== 'production') {
              if (data && data.pre) {
                creatingElmInVPre++;
              }
              if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
                warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.', vnode.context);
              }
            }

            vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
            setScope(vnode);

            /* istanbul ignore if */
            {
              createChildren(vnode, children, insertedVnodeQueue);
              if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
              }
              insert(parentElm, vnode.elm, refElm);
            }

            if (process.env.NODE_ENV !== 'production' && data && data.pre) {
              creatingElmInVPre--;
            }
          } else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
          } else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
          }
        }

        function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
          var i = vnode.data;
          if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef(i = i.hook) && isDef(i = i.init)) {
              i(vnode, false /* hydrating */, parentElm, refElm);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
              initComponent(vnode, insertedVnodeQueue);
              if (isTrue(isReactivated)) {
                reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
              }
              return true;
            }
          }
        }

        function initComponent(vnode, insertedVnodeQueue) {
          if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
          }
          vnode.elm = vnode.componentInstance.$el;
          if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
          } else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
          }
        }

        function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
          var i;
          // hack for #4339: a reactivated component with inner transition
          // does not trigger because the inner node's created hooks are not called
          // again. It's not ideal to involve module-specific logic in here but
          // there doesn't seem to be a better way to do it.
          var innerNode = vnode;
          while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
              for (i = 0; i < cbs.activate.length; ++i) {
                cbs.activate[i](emptyNode, innerNode);
              }
              insertedVnodeQueue.push(innerNode);
              break;
            }
          }
          // unlike a newly created component,
          // a reactivated keep-alive component doesn't insert itself
          insert(parentElm, vnode.elm, refElm);
        }

        function insert(parent, elm, ref$$1) {
          if (isDef(parent)) {
            if (isDef(ref$$1)) {
              if (ref$$1.parentNode === parent) {
                nodeOps.insertBefore(parent, elm, ref$$1);
              }
            } else {
              nodeOps.appendChild(parent, elm);
            }
          }
        }

        function createChildren(vnode, children, insertedVnodeQueue) {
          if (Array.isArray(children)) {
            if (process.env.NODE_ENV !== 'production') {
              checkDuplicateKeys(children);
            }
            for (var i = 0; i < children.length; ++i) {
              createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
            }
          } else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
          }
        }

        function isPatchable(vnode) {
          while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
          }
          return isDef(vnode.tag);
        }

        function invokeCreateHooks(vnode, insertedVnodeQueue) {
          for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
            cbs.create[i$1](emptyNode, vnode);
          }
          i = vnode.data.hook; // Reuse variable
          if (isDef(i)) {
            if (isDef(i.create)) {
              i.create(emptyNode, vnode);
            }
            if (isDef(i.insert)) {
              insertedVnodeQueue.push(vnode);
            }
          }
        }

        // set scope id attribute for scoped CSS.
        // this is implemented as a special case to avoid the overhead
        // of going through the normal attribute patching process.
        function setScope(vnode) {
          var i;
          if (isDef(i = vnode.fnScopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
          } else {
            var ancestor = vnode;
            while (ancestor) {
              if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
                nodeOps.setStyleScope(vnode.elm, i);
              }
              ancestor = ancestor.parent;
            }
          }
          // for slot content they should also get the scopeId from the host instance.
          if (isDef(i = activeInstance) && i !== vnode.context && i !== vnode.fnContext && isDef(i = i.$options._scopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
          }
        }

        function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
          for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
          }
        }

        function invokeDestroyHook(vnode) {
          var i, j;
          var data = vnode.data;
          if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.destroy)) {
              i(vnode);
            }
            for (i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](vnode);
            }
          }
          if (isDef(i = vnode.children)) {
            for (j = 0; j < vnode.children.length; ++j) {
              invokeDestroyHook(vnode.children[j]);
            }
          }
        }

        function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
          for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
              if (isDef(ch.tag)) {
                removeAndInvokeRemoveHook(ch);
                invokeDestroyHook(ch);
              } else {
                // Text node
                removeNode(ch.elm);
              }
            }
          }
        }

        function removeAndInvokeRemoveHook(vnode, rm) {
          if (isDef(rm) || isDef(vnode.data)) {
            var i;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
              // we have a recursively passed down rm callback
              // increase the listeners count
              rm.listeners += listeners;
            } else {
              // directly removing
              rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
              removeAndInvokeRemoveHook(i, rm);
            }
            for (i = 0; i < cbs.remove.length; ++i) {
              cbs.remove[i](vnode, rm);
            }
            if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
              i(vnode, rm);
            } else {
              rm();
            }
          } else {
            removeNode(vnode.elm);
          }
        }

        function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
          var oldStartIdx = 0;
          var newStartIdx = 0;
          var oldEndIdx = oldCh.length - 1;
          var oldStartVnode = oldCh[0];
          var oldEndVnode = oldCh[oldEndIdx];
          var newEndIdx = newCh.length - 1;
          var newStartVnode = newCh[0];
          var newEndVnode = newCh[newEndIdx];
          var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

          // removeOnly is a special flag used only by <transition-group>
          // to ensure removed elements stay in correct relative positions
          // during leaving transitions
          var canMove = !removeOnly;

          if (process.env.NODE_ENV !== 'production') {
            checkDuplicateKeys(newCh);
          }

          while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
              oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            } else if (isUndef(oldEndVnode)) {
              oldEndVnode = oldCh[--oldEndIdx];
            } else if (sameVnode(oldStartVnode, newStartVnode)) {
              patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
              oldStartVnode = oldCh[++oldStartIdx];
              newStartVnode = newCh[++newStartIdx];
            } else if (sameVnode(oldEndVnode, newEndVnode)) {
              patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
              oldEndVnode = oldCh[--oldEndIdx];
              newEndVnode = newCh[--newEndIdx];
            } else if (sameVnode(oldStartVnode, newEndVnode)) {
              // Vnode moved right
              patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
              canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
              oldStartVnode = oldCh[++oldStartIdx];
              newEndVnode = newCh[--newEndIdx];
            } else if (sameVnode(oldEndVnode, newStartVnode)) {
              // Vnode moved left
              patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
              canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
              oldEndVnode = oldCh[--oldEndIdx];
              newStartVnode = newCh[++newStartIdx];
            } else {
              if (isUndef(oldKeyToIdx)) {
                oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
              }
              idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
              if (isUndef(idxInOld)) {
                // New element
                createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
              } else {
                vnodeToMove = oldCh[idxInOld];
                if (sameVnode(vnodeToMove, newStartVnode)) {
                  patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
                  oldCh[idxInOld] = undefined;
                  canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                } else {
                  // same key but different element. treat as new element
                  createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
              }
              newStartVnode = newCh[++newStartIdx];
            }
          }
          if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
          } else if (newStartIdx > newEndIdx) {
            removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
          }
        }

        function checkDuplicateKeys(children) {
          var seenKeys = {};
          for (var i = 0; i < children.length; i++) {
            var vnode = children[i];
            var key = vnode.key;
            if (isDef(key)) {
              if (seenKeys[key]) {
                warn("Duplicate keys detected: '" + key + "'. This may cause an update error.", vnode.context);
              } else {
                seenKeys[key] = true;
              }
            }
          }
        }

        function findIdxInOld(node, oldCh, start, end) {
          for (var i = start; i < end; i++) {
            var c = oldCh[i];
            if (isDef(c) && sameVnode(node, c)) {
              return i;
            }
          }
        }

        function patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly) {
          if (oldVnode === vnode) {
            return;
          }

          var elm = vnode.elm = oldVnode.elm;

          if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
              hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            } else {
              vnode.isAsyncPlaceholder = true;
            }
            return;
          }

          // reuse element for static trees.
          // note we only do this if the vnode is cloned -
          // if the new node is not cloned it means the render functions have been
          // reset by the hot-reload-api and we need to do a proper re-render.
          if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
          }

          var i;
          var data = vnode.data;
          if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
            i(oldVnode, vnode);
          }

          var oldCh = oldVnode.children;
          var ch = vnode.children;
          if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i) {
              cbs.update[i](oldVnode, vnode);
            }
            if (isDef(i = data.hook) && isDef(i = i.update)) {
              i(oldVnode, vnode);
            }
          }
          if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
              if (oldCh !== ch) {
                updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
              }
            } else if (isDef(ch)) {
              if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
              }
              addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if (isDef(oldCh)) {
              removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            } else if (isDef(oldVnode.text)) {
              nodeOps.setTextContent(elm, '');
            }
          } else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
          }
          if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.postpatch)) {
              i(oldVnode, vnode);
            }
          }
        }

        function invokeInsertHook(vnode, queue, initial) {
          // delay insert hooks for component root nodes, invoke them after the
          // element is really inserted
          if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
          } else {
            for (var i = 0; i < queue.length; ++i) {
              queue[i].data.hook.insert(queue[i]);
            }
          }
        }

        var hydrationBailed = false;
        // list of modules that can skip create hook during hydration because they
        // are already rendered on the client or has no need for initialization
        // Note: style is excluded because it relies on initial clone for future
        // deep updates (#7063).
        var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

        // Note: this is a browser-only function so we can assume elms are DOM nodes.
        function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
          var i;
          var tag = vnode.tag;
          var data = vnode.data;
          var children = vnode.children;
          inVPre = inVPre || data && data.pre;
          vnode.elm = elm;

          if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
          }
          // assert node match
          if (process.env.NODE_ENV !== 'production') {
            if (!assertNodeMatch(elm, vnode, inVPre)) {
              return false;
            }
          }
          if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.init)) {
              i(vnode, true /* hydrating */);
            }
            if (isDef(i = vnode.componentInstance)) {
              // child component. it should have hydrated its own tree.
              initComponent(vnode, insertedVnodeQueue);
              return true;
            }
          }
          if (isDef(tag)) {
            if (isDef(children)) {
              // empty element, allow client to pick up and populate children
              if (!elm.hasChildNodes()) {
                createChildren(vnode, children, insertedVnodeQueue);
              } else {
                // v-html and domProps: innerHTML
                if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
                  if (i !== elm.innerHTML) {
                    /* istanbul ignore if */
                    if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined' && !hydrationBailed) {
                      hydrationBailed = true;
                      console.warn('Parent: ', elm);
                      console.warn('server innerHTML: ', i);
                      console.warn('client innerHTML: ', elm.innerHTML);
                    }
                    return false;
                  }
                } else {
                  // iterate and compare children lists
                  var childrenMatch = true;
                  var childNode = elm.firstChild;
                  for (var i$1 = 0; i$1 < children.length; i$1++) {
                    if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                      childrenMatch = false;
                      break;
                    }
                    childNode = childNode.nextSibling;
                  }
                  // if childNode is not null, it means the actual childNodes list is
                  // longer than the virtual children list.
                  if (!childrenMatch || childNode) {
                    /* istanbul ignore if */
                    if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined' && !hydrationBailed) {
                      hydrationBailed = true;
                      console.warn('Parent: ', elm);
                      console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                    }
                    return false;
                  }
                }
              }
            }
            if (isDef(data)) {
              var fullInvoke = false;
              for (var key in data) {
                if (!isRenderedModule(key)) {
                  fullInvoke = true;
                  invokeCreateHooks(vnode, insertedVnodeQueue);
                  break;
                }
              }
              if (!fullInvoke && data['class']) {
                // ensure collecting deps for deep class bindings for future updates
                traverse(data['class']);
              }
            }
          } else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
          }
          return true;
        }

        function assertNodeMatch(node, vnode, inVPre) {
          if (isDef(vnode.tag)) {
            return vnode.tag.indexOf('vue-component') === 0 || !isUnknownElement$$1(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
          } else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
          }
        }

        return function patch(oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
          if (isUndef(vnode)) {
            if (isDef(oldVnode)) {
              invokeDestroyHook(oldVnode);
            }
            return;
          }

          var isInitialPatch = false;
          var insertedVnodeQueue = [];

          if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue, parentElm, refElm);
          } else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
              // patch existing root node
              patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
            } else {
              if (isRealElement) {
                // mounting to a real element
                // check if this is server-rendered content and if we can perform
                // a successful hydration.
                if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                  oldVnode.removeAttribute(SSR_ATTR);
                  hydrating = true;
                }
                if (isTrue(hydrating)) {
                  if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                    invokeInsertHook(vnode, insertedVnodeQueue, true);
                    return oldVnode;
                  } else if (process.env.NODE_ENV !== 'production') {
                    warn('The client-side rendered virtual DOM tree is not matching ' + 'server-rendered content. This is likely caused by incorrect ' + 'HTML markup, for example nesting block-level elements inside ' + '<p>, or missing <tbody>. Bailing hydration and performing ' + 'full client-side render.');
                  }
                }
                // either not server-rendered, or hydration failed.
                // create an empty node and replace it
                oldVnode = emptyNodeAt(oldVnode);
              }

              // replacing existing element
              var oldElm = oldVnode.elm;
              var parentElm$1 = nodeOps.parentNode(oldElm);

              // create new node
              createElm(vnode, insertedVnodeQueue,
              // extremely rare edge case: do not insert if old element is in a
              // leaving transition. Only happens when combining transition +
              // keep-alive + HOCs. (#4590)
              oldElm._leaveCb ? null : parentElm$1, nodeOps.nextSibling(oldElm));

              // update parent placeholder node element, recursively
              if (isDef(vnode.parent)) {
                var ancestor = vnode.parent;
                var patchable = isPatchable(vnode);
                while (ancestor) {
                  for (var i = 0; i < cbs.destroy.length; ++i) {
                    cbs.destroy[i](ancestor);
                  }
                  ancestor.elm = vnode.elm;
                  if (patchable) {
                    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                      cbs.create[i$1](emptyNode, ancestor);
                    }
                    // #6513
                    // invoke insert hooks that may have been merged by create hooks.
                    // e.g. for directives that uses the "inserted" hook.
                    var insert = ancestor.data.hook.insert;
                    if (insert.merged) {
                      // start at index 1 to avoid re-invoking component mounted hook
                      for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                        insert.fns[i$2]();
                      }
                    }
                  } else {
                    registerRef(ancestor);
                  }
                  ancestor = ancestor.parent;
                }
              }

              // destroy old node
              if (isDef(parentElm$1)) {
                removeVnodes(parentElm$1, [oldVnode], 0, 0);
              } else if (isDef(oldVnode.tag)) {
                invokeDestroyHook(oldVnode);
              }
            }
          }

          invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
          return vnode.elm;
        };
      }

      /*  */

      var directives = {
        create: updateDirectives,
        update: updateDirectives,
        destroy: function unbindDirectives(vnode) {
          updateDirectives(vnode, emptyNode);
        }
      };

      function updateDirectives(oldVnode, vnode) {
        if (oldVnode.data.directives || vnode.data.directives) {
          _update(oldVnode, vnode);
        }
      }

      function _update(oldVnode, vnode) {
        var isCreate = oldVnode === emptyNode;
        var isDestroy = vnode === emptyNode;
        var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
        var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

        var dirsWithInsert = [];
        var dirsWithPostpatch = [];

        var key, oldDir, dir;
        for (key in newDirs) {
          oldDir = oldDirs[key];
          dir = newDirs[key];
          if (!oldDir) {
            // new directive, bind
            callHook$1(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
              dirsWithInsert.push(dir);
            }
          } else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            callHook$1(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
              dirsWithPostpatch.push(dir);
            }
          }
        }

        if (dirsWithInsert.length) {
          var callInsert = function callInsert() {
            for (var i = 0; i < dirsWithInsert.length; i++) {
              callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
          };
          if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
          } else {
            callInsert();
          }
        }

        if (dirsWithPostpatch.length) {
          mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
              callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
          });
        }

        if (!isCreate) {
          for (key in oldDirs) {
            if (!newDirs[key]) {
              // no longer present, unbind
              callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
          }
        }
      }

      var emptyModifiers = Object.create(null);

      function normalizeDirectives$1(dirs, vm) {
        var res = Object.create(null);
        if (!dirs) {
          // $flow-disable-line
          return res;
        }
        var i, dir;
        for (i = 0; i < dirs.length; i++) {
          dir = dirs[i];
          if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
          }
          res[getRawDirName(dir)] = dir;
          dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
        }
        // $flow-disable-line
        return res;
      }

      function getRawDirName(dir) {
        return dir.rawName || dir.name + "." + Object.keys(dir.modifiers || {}).join('.');
      }

      function callHook$1(dir, hook, vnode, oldVnode, isDestroy) {
        var fn = dir.def && dir.def[hook];
        if (fn) {
          try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
          } catch (e) {
            handleError(e, vnode.context, "directive " + dir.name + " " + hook + " hook");
          }
        }
      }

      var baseModules = [ref, directives];

      /*  */

      function updateAttrs(oldVnode, vnode) {
        var opts = vnode.componentOptions;
        if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
          return;
        }
        if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
          return;
        }
        var key, cur, old;
        var elm = vnode.elm;
        var oldAttrs = oldVnode.data.attrs || {};
        var attrs = vnode.data.attrs || {};
        // clone observed objects, as the user probably wants to mutate it
        if (isDef(attrs.__ob__)) {
          attrs = vnode.data.attrs = extend({}, attrs);
        }

        for (key in attrs) {
          cur = attrs[key];
          old = oldAttrs[key];
          if (old !== cur) {
            setAttr(elm, key, cur);
          }
        }
        // #4391: in IE9, setting type can reset value for input[type=radio]
        // #6666: IE/Edge forces progress value down to 1 before setting a max
        /* istanbul ignore if */
        if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
          setAttr(elm, 'value', attrs.value);
        }
        for (key in oldAttrs) {
          if (isUndef(attrs[key])) {
            if (isXlink(key)) {
              elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            } else if (!isEnumeratedAttr(key)) {
              elm.removeAttribute(key);
            }
          }
        }
      }

      function setAttr(el, key, value) {
        if (el.tagName.indexOf('-') > -1) {
          baseSetAttr(el, key, value);
        } else if (isBooleanAttr(key)) {
          // set attribute for blank value
          // e.g. <option disabled>Select one</option>
          if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
          } else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
          }
        } else if (isEnumeratedAttr(key)) {
          el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
        } else if (isXlink(key)) {
          if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
          } else {
            el.setAttributeNS(xlinkNS, key, value);
          }
        } else {
          baseSetAttr(el, key, value);
        }
      }

      function baseSetAttr(el, key, value) {
        if (isFalsyAttrValue(value)) {
          el.removeAttribute(key);
        } else {
          // #7138: IE10 & 11 fires input event when setting placeholder on
          // <textarea>... block the first input event and remove the blocker
          // immediately.
          /* istanbul ignore if */
          if (isIE && !isIE9 && el.tagName === 'TEXTAREA' && key === 'placeholder' && !el.__ieph) {
            var blocker = function blocker(e) {
              e.stopImmediatePropagation();
              el.removeEventListener('input', blocker);
            };
            el.addEventListener('input', blocker);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
          }
          el.setAttribute(key, value);
        }
      }

      var attrs = {
        create: updateAttrs,
        update: updateAttrs

        /*  */

      };function updateClass(oldVnode, vnode) {
        var el = vnode.elm;
        var data = vnode.data;
        var oldData = oldVnode.data;
        if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
          return;
        }

        var cls = genClassForVnode(vnode);

        // handle transition classes
        var transitionClass = el._transitionClasses;
        if (isDef(transitionClass)) {
          cls = concat(cls, stringifyClass(transitionClass));
        }

        // set the class
        if (cls !== el._prevClass) {
          el.setAttribute('class', cls);
          el._prevClass = cls;
        }
      }

      var klass = {
        create: updateClass,
        update: updateClass

        /*  */

        /*  */

        // add a raw attr (use this in preTransforms)


        // note: this only removes the attr from the Array (attrsList) so that it
        // doesn't get processed by processAttrs.
        // By default it does NOT remove it from the map (attrsMap) because the map is
        // needed during codegen.

        /*  */

        /**
         * Cross-platform code generation for component v-model
         */

        /**
         * Cross-platform codegen helper for generating v-model value assignment code.
         */

        /*  */

        // in some cases, the event used has to be determined at runtime
        // so we used some reserved tokens during compile.
      };var RANGE_TOKEN = '__r';
      var CHECKBOX_RADIO_TOKEN = '__c';

      /*  */

      // normalize v-model event tokens that can only be determined at runtime.
      // it's important to place the event as the first in the array because
      // the whole point is ensuring the v-model callback gets called before
      // user-attached handlers.
      function normalizeEvents(on) {
        /* istanbul ignore if */
        if (isDef(on[RANGE_TOKEN])) {
          // IE input[type=range] only supports `change` event
          var event = isIE ? 'change' : 'input';
          on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
          delete on[RANGE_TOKEN];
        }
        // This was originally intended to fix #4521 but no longer necessary
        // after 2.5. Keeping it for backwards compat with generated code from < 2.4
        /* istanbul ignore if */
        if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
          on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
          delete on[CHECKBOX_RADIO_TOKEN];
        }
      }

      var target$1;

      function createOnceHandler(handler, event, capture) {
        var _target = target$1; // save current target element in closure
        return function onceHandler() {
          var res = handler.apply(null, arguments);
          if (res !== null) {
            remove$2(event, onceHandler, capture, _target);
          }
        };
      }

      function add$1(event, handler, once$$1, capture, passive) {
        handler = withMacroTask(handler);
        if (once$$1) {
          handler = createOnceHandler(handler, event, capture);
        }
        target$1.addEventListener(event, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
      }

      function remove$2(event, handler, capture, _target) {
        (_target || target$1).removeEventListener(event, handler._withTask || handler, capture);
      }

      function updateDOMListeners(oldVnode, vnode) {
        if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
          return;
        }
        var on = vnode.data.on || {};
        var oldOn = oldVnode.data.on || {};
        target$1 = vnode.elm;
        normalizeEvents(on);
        updateListeners(on, oldOn, add$1, remove$2, vnode.context);
        target$1 = undefined;
      }

      var events = {
        create: updateDOMListeners,
        update: updateDOMListeners

        /*  */

      };function updateDOMProps(oldVnode, vnode) {
        if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
          return;
        }
        var key, cur;
        var elm = vnode.elm;
        var oldProps = oldVnode.data.domProps || {};
        var props = vnode.data.domProps || {};
        // clone observed objects, as the user probably wants to mutate it
        if (isDef(props.__ob__)) {
          props = vnode.data.domProps = extend({}, props);
        }

        for (key in oldProps) {
          if (isUndef(props[key])) {
            elm[key] = '';
          }
        }
        for (key in props) {
          cur = props[key];
          // ignore children if the node has textContent or innerHTML,
          // as these will throw away existing DOM nodes and cause removal errors
          // on subsequent patches (#3360)
          if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children) {
              vnode.children.length = 0;
            }
            if (cur === oldProps[key]) {
              continue;
            }
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
              elm.removeChild(elm.childNodes[0]);
            }
          }

          if (key === 'value') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
              elm.value = strCur;
            }
          } else {
            elm[key] = cur;
          }
        }
      }

      // check platforms/web/util/attrs.js acceptValue


      function shouldUpdateValue(elm, checkVal) {
        return !elm.composing && (elm.tagName === 'OPTION' || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal));
      }

      function isNotInFocusAndDirty(elm, checkVal) {
        // return true when textbox (.number and .trim) loses focus and its value is
        // not equal to the updated value
        var notInFocus = true;
        // #6157
        // work around IE bug when accessing document.activeElement in an iframe
        try {
          notInFocus = document.activeElement !== elm;
        } catch (e) {}
        return notInFocus && elm.value !== checkVal;
      }

      function isDirtyWithModifiers(elm, newVal) {
        var value = elm.value;
        var modifiers = elm._vModifiers; // injected by v-model runtime
        if (isDef(modifiers)) {
          if (modifiers.lazy) {
            // inputs with lazy should only be updated when not in focus
            return false;
          }
          if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
          }
          if (modifiers.trim) {
            return value.trim() !== newVal.trim();
          }
        }
        return value !== newVal;
      }

      var domProps = {
        create: updateDOMProps,
        update: updateDOMProps

        /*  */

      };var parseStyleText = cached(function (cssText) {
        var res = {};
        var listDelimiter = /;(?![^(]*\))/g;
        var propertyDelimiter = /:(.+)/;
        cssText.split(listDelimiter).forEach(function (item) {
          if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
          }
        });
        return res;
      });

      // merge static and dynamic style data on the same vnode
      function normalizeStyleData(data) {
        var style = normalizeStyleBinding(data.style);
        // static style is pre-processed into an object during compilation
        // and is always a fresh object, so it's safe to merge into it
        return data.staticStyle ? extend(data.staticStyle, style) : style;
      }

      // normalize possible array / string values into Object
      function normalizeStyleBinding(bindingStyle) {
        if (Array.isArray(bindingStyle)) {
          return toObject(bindingStyle);
        }
        if (typeof bindingStyle === 'string') {
          return parseStyleText(bindingStyle);
        }
        return bindingStyle;
      }

      /**
       * parent component style should be after child's
       * so that parent component's style could override it
       */
      function getStyle(vnode, checkChild) {
        var res = {};
        var styleData;

        if (checkChild) {
          var childNode = vnode;
          while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
              extend(res, styleData);
            }
          }
        }

        if (styleData = normalizeStyleData(vnode.data)) {
          extend(res, styleData);
        }

        var parentNode = vnode;
        while (parentNode = parentNode.parent) {
          if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
          }
        }
        return res;
      }

      /*  */

      var cssVarRE = /^--/;
      var importantRE = /\s*!important$/;
      var setProp = function setProp(el, name, val) {
        /* istanbul ignore if */
        if (cssVarRE.test(name)) {
          el.style.setProperty(name, val);
        } else if (importantRE.test(val)) {
          el.style.setProperty(name, val.replace(importantRE, ''), 'important');
        } else {
          var normalizedName = normalize(name);
          if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
              el.style[normalizedName] = val[i];
            }
          } else {
            el.style[normalizedName] = val;
          }
        }
      };

      var vendorNames = ['Webkit', 'Moz', 'ms'];

      var emptyStyle;
      var normalize = cached(function (prop) {
        emptyStyle = emptyStyle || document.createElement('div').style;
        prop = camelize(prop);
        if (prop !== 'filter' && prop in emptyStyle) {
          return prop;
        }
        var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
        for (var i = 0; i < vendorNames.length; i++) {
          var name = vendorNames[i] + capName;
          if (name in emptyStyle) {
            return name;
          }
        }
      });

      function updateStyle(oldVnode, vnode) {
        var data = vnode.data;
        var oldData = oldVnode.data;

        if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
          return;
        }

        var cur, name;
        var el = vnode.elm;
        var oldStaticStyle = oldData.staticStyle;
        var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

        // if static style exists, stylebinding already merged into it when doing normalizeStyleData
        var oldStyle = oldStaticStyle || oldStyleBinding;

        var style = normalizeStyleBinding(vnode.data.style) || {};

        // store normalized style under a different key for next diff
        // make sure to clone it if it's reactive, since the user likely wants
        // to mutate it.
        vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;

        var newStyle = getStyle(vnode, true);

        for (name in oldStyle) {
          if (isUndef(newStyle[name])) {
            setProp(el, name, '');
          }
        }
        for (name in newStyle) {
          cur = newStyle[name];
          if (cur !== oldStyle[name]) {
            // ie9 setting to null has no effect, must use empty string
            setProp(el, name, cur == null ? '' : cur);
          }
        }
      }

      var style = {
        create: updateStyle,
        update: updateStyle

        /*  */

        /**
         * Add class with compatibility for SVG since classList is not supported on
         * SVG elements in IE
         */
      };function addClass(el, cls) {
        /* istanbul ignore if */
        if (!cls || !(cls = cls.trim())) {
          return;
        }

        /* istanbul ignore else */
        if (el.classList) {
          if (cls.indexOf(' ') > -1) {
            cls.split(/\s+/).forEach(function (c) {
              return el.classList.add(c);
            });
          } else {
            el.classList.add(cls);
          }
        } else {
          var cur = " " + (el.getAttribute('class') || '') + " ";
          if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
          }
        }
      }

      /**
       * Remove class with compatibility for SVG since classList is not supported on
       * SVG elements in IE
       */
      function removeClass(el, cls) {
        /* istanbul ignore if */
        if (!cls || !(cls = cls.trim())) {
          return;
        }

        /* istanbul ignore else */
        if (el.classList) {
          if (cls.indexOf(' ') > -1) {
            cls.split(/\s+/).forEach(function (c) {
              return el.classList.remove(c);
            });
          } else {
            el.classList.remove(cls);
          }
          if (!el.classList.length) {
            el.removeAttribute('class');
          }
        } else {
          var cur = " " + (el.getAttribute('class') || '') + " ";
          var tar = ' ' + cls + ' ';
          while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
          }
          cur = cur.trim();
          if (cur) {
            el.setAttribute('class', cur);
          } else {
            el.removeAttribute('class');
          }
        }
      }

      /*  */

      function resolveTransition(def) {
        if (!def) {
          return;
        }
        /* istanbul ignore else */
        if ((typeof def === "undefined" ? "undefined" : _typeof(def)) === 'object') {
          var res = {};
          if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
          }
          extend(res, def);
          return res;
        } else if (typeof def === 'string') {
          return autoCssTransition(def);
        }
      }

      var autoCssTransition = cached(function (name) {
        return {
          enterClass: name + "-enter",
          enterToClass: name + "-enter-to",
          enterActiveClass: name + "-enter-active",
          leaveClass: name + "-leave",
          leaveToClass: name + "-leave-to",
          leaveActiveClass: name + "-leave-active"
        };
      });

      var hasTransition = inBrowser && !isIE9;
      var TRANSITION = 'transition';
      var ANIMATION = 'animation';

      // Transition property/event sniffing
      var transitionProp = 'transition';
      var transitionEndEvent = 'transitionend';
      var animationProp = 'animation';
      var animationEndEvent = 'animationend';
      if (hasTransition) {
        /* istanbul ignore if */
        if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
          transitionProp = 'WebkitTransition';
          transitionEndEvent = 'webkitTransitionEnd';
        }
        if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
          animationProp = 'WebkitAnimation';
          animationEndEvent = 'webkitAnimationEnd';
        }
      }

      // binding to window is necessary to make hot reload work in IE in strict mode
      var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : /* istanbul ignore next */function (fn) {
        return fn();
      };

      function nextFrame(fn) {
        raf(function () {
          raf(fn);
        });
      }

      function addTransitionClass(el, cls) {
        var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
        if (transitionClasses.indexOf(cls) < 0) {
          transitionClasses.push(cls);
          addClass(el, cls);
        }
      }

      function removeTransitionClass(el, cls) {
        if (el._transitionClasses) {
          remove(el._transitionClasses, cls);
        }
        removeClass(el, cls);
      }

      function whenTransitionEnds(el, expectedType, cb) {
        var ref = getTransitionInfo(el, expectedType);
        var type = ref.type;
        var timeout = ref.timeout;
        var propCount = ref.propCount;
        if (!type) {
          return cb();
        }
        var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
        var ended = 0;
        var end = function end() {
          el.removeEventListener(event, onEnd);
          cb();
        };
        var onEnd = function onEnd(e) {
          if (e.target === el) {
            if (++ended >= propCount) {
              end();
            }
          }
        };
        setTimeout(function () {
          if (ended < propCount) {
            end();
          }
        }, timeout + 1);
        el.addEventListener(event, onEnd);
      }

      var transformRE = /\b(transform|all)(,|$)/;

      function getTransitionInfo(el, expectedType) {
        var styles = window.getComputedStyle(el);
        var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
        var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
        var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
        var animationDelays = styles[animationProp + 'Delay'].split(', ');
        var animationDurations = styles[animationProp + 'Duration'].split(', ');
        var animationTimeout = getTimeout(animationDelays, animationDurations);

        var type;
        var timeout = 0;
        var propCount = 0;
        /* istanbul ignore if */
        if (expectedType === TRANSITION) {
          if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
          }
        } else if (expectedType === ANIMATION) {
          if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
          }
        } else {
          timeout = Math.max(transitionTimeout, animationTimeout);
          type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
          propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
        }
        var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
        return {
          type: type,
          timeout: timeout,
          propCount: propCount,
          hasTransform: hasTransform
        };
      }

      function getTimeout(delays, durations) {
        /* istanbul ignore next */
        while (delays.length < durations.length) {
          delays = delays.concat(delays);
        }

        return Math.max.apply(null, durations.map(function (d, i) {
          return toMs(d) + toMs(delays[i]);
        }));
      }

      function toMs(s) {
        return Number(s.slice(0, -1)) * 1000;
      }

      /*  */

      function enter(vnode, toggleDisplay) {
        var el = vnode.elm;

        // call leave callback now
        if (isDef(el._leaveCb)) {
          el._leaveCb.cancelled = true;
          el._leaveCb();
        }

        var data = resolveTransition(vnode.data.transition);
        if (isUndef(data)) {
          return;
        }

        /* istanbul ignore if */
        if (isDef(el._enterCb) || el.nodeType !== 1) {
          return;
        }

        var css = data.css;
        var type = data.type;
        var enterClass = data.enterClass;
        var enterToClass = data.enterToClass;
        var enterActiveClass = data.enterActiveClass;
        var appearClass = data.appearClass;
        var appearToClass = data.appearToClass;
        var appearActiveClass = data.appearActiveClass;
        var beforeEnter = data.beforeEnter;
        var enter = data.enter;
        var afterEnter = data.afterEnter;
        var enterCancelled = data.enterCancelled;
        var beforeAppear = data.beforeAppear;
        var appear = data.appear;
        var afterAppear = data.afterAppear;
        var appearCancelled = data.appearCancelled;
        var duration = data.duration;

        // activeInstance will always be the <transition> component managing this
        // transition. One edge case to check is when the <transition> is placed
        // as the root node of a child component. In that case we need to check
        // <transition>'s parent for appear check.
        var context = activeInstance;
        var transitionNode = activeInstance.$vnode;
        while (transitionNode && transitionNode.parent) {
          transitionNode = transitionNode.parent;
          context = transitionNode.context;
        }

        var isAppear = !context._isMounted || !vnode.isRootInsert;

        if (isAppear && !appear && appear !== '') {
          return;
        }

        var startClass = isAppear && appearClass ? appearClass : enterClass;
        var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
        var toClass = isAppear && appearToClass ? appearToClass : enterToClass;

        var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
        var enterHook = isAppear ? typeof appear === 'function' ? appear : enter : enter;
        var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
        var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;

        var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);

        if (process.env.NODE_ENV !== 'production' && explicitEnterDuration != null) {
          checkDuration(explicitEnterDuration, 'enter', vnode);
        }

        var expectsCSS = css !== false && !isIE9;
        var userWantsControl = getHookArgumentsLength(enterHook);

        var cb = el._enterCb = once(function () {
          if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
          }
          if (cb.cancelled) {
            if (expectsCSS) {
              removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
          } else {
            afterEnterHook && afterEnterHook(el);
          }
          el._enterCb = null;
        });

        if (!vnode.data.show) {
          // remove pending leave element on enter by injecting an insert hook
          mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
              pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
          });
        }

        // start enter transition
        beforeEnterHook && beforeEnterHook(el);
        if (expectsCSS) {
          addTransitionClass(el, startClass);
          addTransitionClass(el, activeClass);
          nextFrame(function () {
            removeTransitionClass(el, startClass);
            if (!cb.cancelled) {
              addTransitionClass(el, toClass);
              if (!userWantsControl) {
                if (isValidDuration(explicitEnterDuration)) {
                  setTimeout(cb, explicitEnterDuration);
                } else {
                  whenTransitionEnds(el, type, cb);
                }
              }
            }
          });
        }

        if (vnode.data.show) {
          toggleDisplay && toggleDisplay();
          enterHook && enterHook(el, cb);
        }

        if (!expectsCSS && !userWantsControl) {
          cb();
        }
      }

      function leave(vnode, rm) {
        var el = vnode.elm;

        // call enter callback now
        if (isDef(el._enterCb)) {
          el._enterCb.cancelled = true;
          el._enterCb();
        }

        var data = resolveTransition(vnode.data.transition);
        if (isUndef(data) || el.nodeType !== 1) {
          return rm();
        }

        /* istanbul ignore if */
        if (isDef(el._leaveCb)) {
          return;
        }

        var css = data.css;
        var type = data.type;
        var leaveClass = data.leaveClass;
        var leaveToClass = data.leaveToClass;
        var leaveActiveClass = data.leaveActiveClass;
        var beforeLeave = data.beforeLeave;
        var leave = data.leave;
        var afterLeave = data.afterLeave;
        var leaveCancelled = data.leaveCancelled;
        var delayLeave = data.delayLeave;
        var duration = data.duration;

        var expectsCSS = css !== false && !isIE9;
        var userWantsControl = getHookArgumentsLength(leave);

        var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);

        if (process.env.NODE_ENV !== 'production' && isDef(explicitLeaveDuration)) {
          checkDuration(explicitLeaveDuration, 'leave', vnode);
        }

        var cb = el._leaveCb = once(function () {
          if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
          }
          if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
          }
          if (cb.cancelled) {
            if (expectsCSS) {
              removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
          } else {
            rm();
            afterLeave && afterLeave(el);
          }
          el._leaveCb = null;
        });

        if (delayLeave) {
          delayLeave(performLeave);
        } else {
          performLeave();
        }

        function performLeave() {
          // the delayed leave may have already been cancelled
          if (cb.cancelled) {
            return;
          }
          // record leaving element
          if (!vnode.data.show) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
          }
          beforeLeave && beforeLeave(el);
          if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame(function () {
              removeTransitionClass(el, leaveClass);
              if (!cb.cancelled) {
                addTransitionClass(el, leaveToClass);
                if (!userWantsControl) {
                  if (isValidDuration(explicitLeaveDuration)) {
                    setTimeout(cb, explicitLeaveDuration);
                  } else {
                    whenTransitionEnds(el, type, cb);
                  }
                }
              }
            });
          }
          leave && leave(el, cb);
          if (!expectsCSS && !userWantsControl) {
            cb();
          }
        }
      }

      // only used in dev mode
      function checkDuration(val, name, vnode) {
        if (typeof val !== 'number') {
          warn("<transition> explicit " + name + " duration is not a valid number - " + "got " + JSON.stringify(val) + ".", vnode.context);
        } else if (isNaN(val)) {
          warn("<transition> explicit " + name + " duration is NaN - " + 'the duration expression might be incorrect.', vnode.context);
        }
      }

      function isValidDuration(val) {
        return typeof val === 'number' && !isNaN(val);
      }

      /**
       * Normalize a transition hook's argument length. The hook may be:
       * - a merged hook (invoker) with the original in .fns
       * - a wrapped component method (check ._length)
       * - a plain function (.length)
       */
      function getHookArgumentsLength(fn) {
        if (isUndef(fn)) {
          return false;
        }
        var invokerFns = fn.fns;
        if (isDef(invokerFns)) {
          // invoker
          return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
        } else {
          return (fn._length || fn.length) > 1;
        }
      }

      function _enter(_, vnode) {
        if (vnode.data.show !== true) {
          enter(vnode);
        }
      }

      var transition = inBrowser ? {
        create: _enter,
        activate: _enter,
        remove: function remove$$1(vnode, rm) {
          /* istanbul ignore else */
          if (vnode.data.show !== true) {
            leave(vnode, rm);
          } else {
            rm();
          }
        }
      } : {};

      var platformModules = [attrs, klass, events, domProps, style, transition];

      /*  */

      // the directive module should be applied last, after all
      // built-in modules have been applied.
      var modules = platformModules.concat(baseModules);

      var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

      /**
       * Not type checking this file because flow doesn't like attaching
       * properties to Elements.
       */

      /* istanbul ignore if */
      if (isIE9) {
        // http://www.matts411.com/post/internet-explorer-9-oninput/
        document.addEventListener('selectionchange', function () {
          var el = document.activeElement;
          if (el && el.vmodel) {
            trigger(el, 'input');
          }
        });
      }

      var directive = {
        inserted: function inserted(el, binding, vnode, oldVnode) {
          if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
              mergeVNodeHook(vnode, 'postpatch', function () {
                directive.componentUpdated(el, binding, vnode);
              });
            } else {
              setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
          } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
              el.addEventListener('compositionstart', onCompositionStart);
              el.addEventListener('compositionend', onCompositionEnd);
              // Safari < 10.2 & UIWebView doesn't fire compositionend when
              // switching focus before confirming composition choice
              // this also fixes the issue where some browsers e.g. iOS Chrome
              // fires "change" instead of "input" on autocomplete.
              el.addEventListener('change', onCompositionEnd);
              /* istanbul ignore if */
              if (isIE9) {
                el.vmodel = true;
              }
            }
          }
        },

        componentUpdated: function componentUpdated(el, binding, vnode) {
          if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions = el._vOptions;
            var curOptions = el._vOptions = [].map.call(el.options, getValue);
            if (curOptions.some(function (o, i) {
              return !looseEqual(o, prevOptions[i]);
            })) {
              // trigger change event if
              // no matching option found for at least one value
              var needReset = el.multiple ? binding.value.some(function (v) {
                return hasNoMatchingOption(v, curOptions);
              }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
              if (needReset) {
                trigger(el, 'change');
              }
            }
          }
        }
      };

      function setSelected(el, binding, vm) {
        actuallySetSelected(el, binding, vm);
        /* istanbul ignore if */
        if (isIE || isEdge) {
          setTimeout(function () {
            actuallySetSelected(el, binding, vm);
          }, 0);
        }
      }

      function actuallySetSelected(el, binding, vm) {
        var value = binding.value;
        var isMultiple = el.multiple;
        if (isMultiple && !Array.isArray(value)) {
          process.env.NODE_ENV !== 'production' && warn("<select multiple v-model=\"" + binding.expression + "\"> " + "expects an Array value for its binding, but got " + Object.prototype.toString.call(value).slice(8, -1), vm);
          return;
        }
        var selected, option;
        for (var i = 0, l = el.options.length; i < l; i++) {
          option = el.options[i];
          if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
              option.selected = selected;
            }
          } else {
            if (looseEqual(getValue(option), value)) {
              if (el.selectedIndex !== i) {
                el.selectedIndex = i;
              }
              return;
            }
          }
        }
        if (!isMultiple) {
          el.selectedIndex = -1;
        }
      }

      function hasNoMatchingOption(value, options) {
        return options.every(function (o) {
          return !looseEqual(o, value);
        });
      }

      function getValue(option) {
        return '_value' in option ? option._value : option.value;
      }

      function onCompositionStart(e) {
        e.target.composing = true;
      }

      function onCompositionEnd(e) {
        // prevent triggering an input event for no reason
        if (!e.target.composing) {
          return;
        }
        e.target.composing = false;
        trigger(e.target, 'input');
      }

      function trigger(el, type) {
        var e = document.createEvent('HTMLEvents');
        e.initEvent(type, true, true);
        el.dispatchEvent(e);
      }

      /*  */

      // recursively search for possible transition defined inside the component root
      function locateNode(vnode) {
        return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
      }

      var show = {
        bind: function bind(el, ref, vnode) {
          var value = ref.value;

          vnode = locateNode(vnode);
          var transition$$1 = vnode.data && vnode.data.transition;
          var originalDisplay = el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display;
          if (value && transition$$1) {
            vnode.data.show = true;
            enter(vnode, function () {
              el.style.display = originalDisplay;
            });
          } else {
            el.style.display = value ? originalDisplay : 'none';
          }
        },

        update: function update(el, ref, vnode) {
          var value = ref.value;
          var oldValue = ref.oldValue;

          /* istanbul ignore if */
          if (!value === !oldValue) {
            return;
          }
          vnode = locateNode(vnode);
          var transition$$1 = vnode.data && vnode.data.transition;
          if (transition$$1) {
            vnode.data.show = true;
            if (value) {
              enter(vnode, function () {
                el.style.display = el.__vOriginalDisplay;
              });
            } else {
              leave(vnode, function () {
                el.style.display = 'none';
              });
            }
          } else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
          }
        },

        unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
          if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
          }
        }
      };

      var platformDirectives = {
        model: directive,
        show: show

        /*  */

        // Provides transition support for a single element/component.
        // supports transition mode (out-in / in-out)

      };var transitionProps = {
        name: String,
        appear: Boolean,
        css: Boolean,
        mode: String,
        type: String,
        enterClass: String,
        leaveClass: String,
        enterToClass: String,
        leaveToClass: String,
        enterActiveClass: String,
        leaveActiveClass: String,
        appearClass: String,
        appearActiveClass: String,
        appearToClass: String,
        duration: [Number, String, Object]
      };

      // in case the child is also an abstract component, e.g. <keep-alive>
      // we want to recursively retrieve the real component to be rendered
      function getRealChild(vnode) {
        var compOptions = vnode && vnode.componentOptions;
        if (compOptions && compOptions.Ctor.options.abstract) {
          return getRealChild(getFirstComponentChild(compOptions.children));
        } else {
          return vnode;
        }
      }

      function extractTransitionData(comp) {
        var data = {};
        var options = comp.$options;
        // props
        for (var key in options.propsData) {
          data[key] = comp[key];
        }
        // events.
        // extract listeners and pass them directly to the transition methods
        var listeners = options._parentListeners;
        for (var key$1 in listeners) {
          data[camelize(key$1)] = listeners[key$1];
        }
        return data;
      }

      function placeholder(h, rawChild) {
        if (/\d-keep-alive$/.test(rawChild.tag)) {
          return h('keep-alive', {
            props: rawChild.componentOptions.propsData
          });
        }
      }

      function hasParentTransition(vnode) {
        while (vnode = vnode.parent) {
          if (vnode.data.transition) {
            return true;
          }
        }
      }

      function isSameChild(child, oldChild) {
        return oldChild.key === child.key && oldChild.tag === child.tag;
      }

      var Transition = {
        name: 'transition',
        props: transitionProps,
        abstract: true,

        render: function render(h) {
          var this$1 = this;

          var children = this.$slots.default;
          if (!children) {
            return;
          }

          // filter out text nodes (possible whitespaces)
          children = children.filter(function (c) {
            return c.tag || isAsyncPlaceholder(c);
          });
          /* istanbul ignore if */
          if (!children.length) {
            return;
          }

          // warn multiple elements
          if (process.env.NODE_ENV !== 'production' && children.length > 1) {
            warn('<transition> can only be used on a single element. Use ' + '<transition-group> for lists.', this.$parent);
          }

          var mode = this.mode;

          // warn invalid mode
          if (process.env.NODE_ENV !== 'production' && mode && mode !== 'in-out' && mode !== 'out-in') {
            warn('invalid <transition> mode: ' + mode, this.$parent);
          }

          var rawChild = children[0];

          // if this is a component root node and the component's
          // parent container node also has transition, skip.
          if (hasParentTransition(this.$vnode)) {
            return rawChild;
          }

          // apply transition data to child
          // use getRealChild() to ignore abstract components e.g. keep-alive
          var child = getRealChild(rawChild);
          /* istanbul ignore if */
          if (!child) {
            return rawChild;
          }

          if (this._leaving) {
            return placeholder(h, rawChild);
          }

          // ensure a key that is unique to the vnode type and to this transition
          // component instance. This key will be used to remove pending leaving nodes
          // during entering.
          var id = "__transition-" + this._uid + "-";
          child.key = child.key == null ? child.isComment ? id + 'comment' : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;

          var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
          var oldRawChild = this._vnode;
          var oldChild = getRealChild(oldRawChild);

          // mark v-show
          // so that the transition module can hand over the control to the directive
          if (child.data.directives && child.data.directives.some(function (d) {
            return d.name === 'show';
          })) {
            child.data.show = true;
          }

          if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) &&
          // #6687 component root is a comment node
          !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = oldChild.data.transition = extend({}, data);
            // handle transition mode
            if (mode === 'out-in') {
              // return placeholder node and queue update when leave finishes
              this._leaving = true;
              mergeVNodeHook(oldData, 'afterLeave', function () {
                this$1._leaving = false;
                this$1.$forceUpdate();
              });
              return placeholder(h, rawChild);
            } else if (mode === 'in-out') {
              if (isAsyncPlaceholder(child)) {
                return oldRawChild;
              }
              var delayedLeave;
              var performLeave = function performLeave() {
                delayedLeave();
              };
              mergeVNodeHook(data, 'afterEnter', performLeave);
              mergeVNodeHook(data, 'enterCancelled', performLeave);
              mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                delayedLeave = leave;
              });
            }
          }

          return rawChild;
        }

        /*  */

        // Provides transition support for list items.
        // supports move transitions using the FLIP technique.

        // Because the vdom's children update algorithm is "unstable" - i.e.
        // it doesn't guarantee the relative positioning of removed elements,
        // we force transition-group to update its children into two passes:
        // in the first pass, we remove all nodes that need to be removed,
        // triggering their leaving transition; in the second pass, we insert/move
        // into the final desired state. This way in the second pass removed
        // nodes will remain where they should be.

      };var props = extend({
        tag: String,
        moveClass: String
      }, transitionProps);

      delete props.mode;

      var TransitionGroup = {
        props: props,

        render: function render(h) {
          var tag = this.tag || this.$vnode.data.tag || 'span';
          var map = Object.create(null);
          var prevChildren = this.prevChildren = this.children;
          var rawChildren = this.$slots.default || [];
          var children = this.children = [];
          var transitionData = extractTransitionData(this);

          for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
              if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                children.push(c);
                map[c.key] = c;(c.data || (c.data = {})).transition = transitionData;
              } else if (process.env.NODE_ENV !== 'production') {
                var opts = c.componentOptions;
                var name = opts ? opts.Ctor.options.name || opts.tag || '' : c.tag;
                warn("<transition-group> children must be keyed: <" + name + ">");
              }
            }
          }

          if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
              var c$1 = prevChildren[i$1];
              c$1.data.transition = transitionData;
              c$1.data.pos = c$1.elm.getBoundingClientRect();
              if (map[c$1.key]) {
                kept.push(c$1);
              } else {
                removed.push(c$1);
              }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
          }

          return h(tag, null, children);
        },

        beforeUpdate: function beforeUpdate() {
          // force removing pass
          this.__patch__(this._vnode, this.kept, false, // hydrating
          true // removeOnly (!important, avoids unnecessary moves)
          );
          this._vnode = this.kept;
        },

        updated: function updated() {
          var children = this.prevChildren;
          var moveClass = this.moveClass || (this.name || 'v') + '-move';
          if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
          }

          // we divide the work into three loops to avoid mixing DOM reads and writes
          // in each iteration - which helps prevent layout thrashing.
          children.forEach(callPendingCbs);
          children.forEach(recordPosition);
          children.forEach(applyTranslation);

          // force reflow to put everything in position
          // assign to this to avoid being removed in tree-shaking
          // $flow-disable-line
          this._reflow = document.body.offsetHeight;

          children.forEach(function (c) {
            if (c.data.moved) {
              var el = c.elm;
              var s = el.style;
              addTransitionClass(el, moveClass);
              s.transform = s.WebkitTransform = s.transitionDuration = '';
              el.addEventListener(transitionEndEvent, el._moveCb = function cb(e) {
                if (!e || /transform$/.test(e.propertyName)) {
                  el.removeEventListener(transitionEndEvent, cb);
                  el._moveCb = null;
                  removeTransitionClass(el, moveClass);
                }
              });
            }
          });
        },

        methods: {
          hasMove: function hasMove(el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
              return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
              return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
              el._transitionClasses.forEach(function (cls) {
                removeClass(clone, cls);
              });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return this._hasMove = info.hasTransform;
          }
        }
      };

      function callPendingCbs(c) {
        /* istanbul ignore if */
        if (c.elm._moveCb) {
          c.elm._moveCb();
        }
        /* istanbul ignore if */
        if (c.elm._enterCb) {
          c.elm._enterCb();
        }
      }

      function recordPosition(c) {
        c.data.newPos = c.elm.getBoundingClientRect();
      }

      function applyTranslation(c) {
        var oldPos = c.data.pos;
        var newPos = c.data.newPos;
        var dx = oldPos.left - newPos.left;
        var dy = oldPos.top - newPos.top;
        if (dx || dy) {
          c.data.moved = true;
          var s = c.elm.style;
          s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
          s.transitionDuration = '0s';
        }
      }

      var platformComponents = {
        Transition: Transition,
        TransitionGroup: TransitionGroup

        /*  */

        // install platform specific utils
      };Vue.config.mustUseProp = mustUseProp;
      Vue.config.isReservedTag = isReservedTag;
      Vue.config.isReservedAttr = isReservedAttr;
      Vue.config.getTagNamespace = getTagNamespace;
      Vue.config.isUnknownElement = isUnknownElement;

      // install platform runtime directives & components
      extend(Vue.options.directives, platformDirectives);
      extend(Vue.options.components, platformComponents);

      // install platform patch function
      Vue.prototype.__patch__ = inBrowser ? patch : noop;

      // public mount method
      Vue.prototype.$mount = function (el, hydrating) {
        el = el && inBrowser ? query(el) : undefined;
        return mountComponent(this, el, hydrating);
      };

      // devtools global hook
      /* istanbul ignore next */
      if (inBrowser) {
        setTimeout(function () {
          if (config.devtools) {
            if (devtools) {
              devtools.emit('init', Vue);
            } else if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && isChrome) {
              console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
            }
          }
          if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && config.productionTip !== false && typeof console !== 'undefined') {
            console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" + "Make sure to turn on production mode when deploying for production.\n" + "See more tips at https://vuejs.org/guide/deployment.html");
          }
        }, 0);
      }

      /*  */

      module.exports = Vue;
    }).call(this, require('_process'), typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {}, require("timers").setImmediate);
  }, { "_process": 123, "timers": 125 }], 128: [function (require, module, exports) {
    var inserted = exports.cache = {};

    function noop() {}

    exports.insert = function (css) {
      if (inserted[css]) return noop;
      inserted[css] = true;

      var elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');

      if ('textContent' in elem) {
        elem.textContent = css;
      } else {
        elem.styleSheet.cssText = css;
      }

      document.getElementsByTagName('head')[0].appendChild(elem);
      return function () {
        document.getElementsByTagName('head')[0].removeChild(elem);
        inserted[css] = false;
      };
    };
  }, {}], 129: [function (require, module, exports) {
    'use strict';

    var _ref;

    var _titleBar = require('../../../../../widget/m/title-bar.vue');

    var _titleBar2 = _interopRequireDefault(_titleBar);

    var _icp = require('../../../../../widget/m/icp.vue');

    var _icp2 = _interopRequireDefault(_icp);

    var _swert = require('../../../../../widget/common/swert.vue');

    var _swert2 = _interopRequireDefault(_swert);

    var _countdown = require('../../../widget/countdown.vue');

    var _countdown2 = _interopRequireDefault(_countdown);

    var _redpacketApplyPopup = require('../../../widget/redpacket-apply-popup.vue');

    var _redpacketApplyPopup2 = _interopRequireDefault(_redpacketApplyPopup);

    var _holdDate = require('../../../../widget/hold-date');

    var _holdDate2 = _interopRequireDefault(_holdDate);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }

    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }return arr2;
      } else {
        return Array.from(arr);
      }
    }

    if (!Array.prototype.filter) {
      Array.prototype.filter = function (func, thisArg) {
        'use strict';

        if (!(typeof func === 'function' && this)) throw new TypeError();

        var len = this.length >>> 0,
            res = new Array(len),

        // preallocate array
        t = this,
            c = 0,
            i = -1;
        if (thisArg === undefined) while (++i !== len) {
          // checks to see if the key was set
          if (i in this) if (func(t[i], i, t)) res[c++] = t[i];else while (++i !== len) {
            // checks to see if the key was set
            if (i in this) if (func.call(thisArg, t[i], i, t)) res[c++] = t[i];
          }
        }res.length = c; // shrink down array to proper size
        return res;
      };
    }

    var THIS_HREF = window.location.href;
    var _each = require('lodash/each');
    var param = require('bmh/param');
    var Cookie = require('js-cookie');
    var Echo = require('echo-js')(window);
    var SmoothScroll = require('smooth-scroll');
    var numeral = require('numeral');
    var clean = require('bmh/clean-empty-obj');
    var jsonp = require('bmh/jsonp');
    var dateFormat = require('bmh/date-format');
    var UA = navigator.userAgent.toLowerCase();
    var IS_WECHAT = UA.match(/MicroMessenger/i) == 'micromessenger';
    var ERROR_MSG_MOBILE = '手机号码填写有误';
    var IS_AT_ACTIVITY = new Date().getTime() > new Date(activity.hold_date.replace(/-/g, '/') + ' 00:00:00+800').getTime();
    var MAX_LENGTH_OF_PRAISE_COMMENT = 46;
    var PAYMENT_TYPE_MAP = {
      'wx': 5,
      'zfb': 4
    };
    var PRODUCT_TAG_MAP = {
      1: '人气爆款',
      2: '销量冠军',
      3: 'TOP10',
      4: '口碑推荐'
    };
    var URL = {
      apply: '//m.tugou.com/tuan/apply/issue/apply/',
      query: '//m.tugou.com/tuan/apply/issue/query/',
      buy_ticket: '//m.tugou.com/tuan/apply/issue/buy-ticket/',
      route_apply: '//m.tugou.com/tuan/apply/issue/send-route-sms/',
      wechat_auth: '//m.tugou.com/tuan/pay/oauth?referer=',
      pay: 'https://m.tugou.com/tuan/pay/'
    };
    function _getCollapsedText(original_text, max_length) {
      var appendix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '……';

      if (original_text.length > max_length) {
        return '' + original_text.substring(0, max_length) + appendix;
      }
      return '';
    }

    var praise_comment_list = [{
      avatar: '//tugou-pic.oss-cn-hangzhou.aliyuncs.com/tuan/apply/tx1.png',
      name: '万科魅力  王女士',
      thing: '在兔狗家装节找到了口碑装修公司',
      comment: '自己就是个装修小白，和管家沟通完之后，第一个联系的就是圣都，先去他们的展厅看了，真的不愧是大品牌，展厅很大，材料很多都挑花眼了。之后还去了家装节接触下设计师，欧式的风格感觉不错就下了定金，现在已经开始施工了，各方面都有序进行，很期待我的新家！'
    }, {
      avatar: '//tugou-pic.oss-cn-hangzhou.aliyuncs.com/tuan/apply/tx2.png',
      name: '绿地世纪城  温女士',
      thing: '在兔狗家装节团购了优质建材家具',
      comment: '自从报名了兔狗家装节，接触到活力满满的小橙，在举办前为我们开设装修知识讲座，积极提供选购建议和我们互动，真的非常好！在家装节定了地板、瓷砖、吊顶、木门、定制家具，现在家里面已经快装完了，感谢兔狗！'
    }, {
      avatar: '//tugou-pic.oss-cn-hangzhou.aliyuncs.com/tuan/apply/tx3.png',
      name: '龙湖名景台  张先生',
      thing: '在兔狗家装节申请了低息装修贷款',
      comment: '参加兔狗家装节，知道了原来装修也可以分期贷款，比较了下，决定选择兔狗装分期。利息比其他贷款都低，申请条件也不高。现在装修已经放款，必须表扬一下，整个过程速度快，资料提交简单，很满意。'
    }];
    praise_comment_list.forEach(function (item) {
      item.collapsed_comment = _getCollapsedText(item.comment, MAX_LENGTH_OF_PRAISE_COMMENT);
      item.is_collapsed = item.collapsed_comment !== '';
    });
    activity.hold_date_text = (0, _holdDate2.default)(activity.hold_date, activity.duration);
    function getProductAttribute(attribute) {
      var arr = [];
      _each(attribute, function (attr_arr, key) {
        var attr = key + "\uFF1A" + attr_arr.join(', ');
        arr.push(_getCollapsedText(key + "\uFF1A" + attr_arr.join(', '), 20, '...') || attr);
      });
      return arr;
    }
    var product = {
      single_list: REMOTE_PRODUCT[1] ? REMOTE_PRODUCT[1].map(function (item) {
        var now_time = new Date().getTime();
        var on_sale_time = item.online_time * 1000;
        var sold = item.sales_volume || 0;
        return {
          id: item.ware_id,
          img: item.logo_url,
          name: item.title.replace(/^.+\s\|\s/, ''),
          is_on_sale: now_time > on_sale_time,
          is_at_activity: IS_AT_ACTIVITY,
          on_sale_time: dateFormat(on_sale_time, '%m月%d日'),
          inventory: IS_AT_ACTIVITY ? 0 : numeral(item.limit_number).subtract(sold).value(),
          sold: sold,
          original_price: item.original_price,
          price: item.price,
          unit: item.unit,
          url: 'https://m.tugou.com/pin/' + BRANCH.spelling + '/ware/' + item.ware_id,
          attribute: {
            is_show_all: false,
            list: getProductAttribute(item.attribute)
          }
        };
      }) : [],
      double_list: REMOTE_PRODUCT[2] ? REMOTE_PRODUCT[2].map(function (item) {
        var now_time = new Date().getTime();
        var on_sale_time = item.online_time * 1000;
        var sold = item.sales_volume || 0;
        return {
          id: item.ware_id,
          img: item.banner_image_url[1] || item.banner_image_url[0] || '', // waiting remote
          name: item.title,
          is_on_sale: now_time > on_sale_time,
          is_at_activity: IS_AT_ACTIVITY,
          on_sale_time: dateFormat(on_sale_time, '%m月%d日'),
          tag: PRODUCT_TAG_MAP[item.tag],
          inventory: IS_AT_ACTIVITY ? 0 : numeral(item.limit_number).subtract(sold).value(),
          original_price: item.original_price, // waiting remote
          price: item.price,
          unit: item.unit, // waiting remote
          url: 'https://m.tugou.com/pin/' + BRANCH.spelling + '/ware/' + item.ware_id,
          attribute: {
            is_show_all: false,
            list: getProductAttribute(item.attribute)
          }
        };
      }) : []
    };

    var IS_FROM_WXAPP = param('from') === 'wxapp' || window.__wxjs_environment === 'miniprogram' || UA.match(/miniprogram/i) == 'miniprogram';

    var app = new Vue({
      el: '#app',
      components: {
        'title-bar': _titleBar2.default,
        'icp': _icp2.default,
        'swert': _swert2.default,
        'countdown': _countdown2.default,
        'red-packet-pop': _redpacketApplyPopup2.default
      },
      data: {
        is_from_app: param('from') === 'app',
        is_from_wxapp: IS_FROM_WXAPP,
        show_call: false,
        is_wechat: IS_WECHAT,
        wechat_open_id: '',
        is_footer_show: false,
        is_at_activity: IS_AT_ACTIVITY,
        swert_msg: '',
        activity: activity,
        branch: BRANCH,
        issue_id: activity.issue_id,
        smooth_scroll: null,
        nav: {
          list: [],
          active: 'benefit'
        },
        is_nav_fixed: false,

        form: {
          banner: {
            name: '',
            mobile: '',
            entry: IS_FROM_WXAPP ? 901501 : 701501,
            company: false,
            material: false,
            furniture: false,
            loan: false,
            is_verify_show: false,
            is_loading: false
          },
          route: {
            mobile: '',
            entry: IS_FROM_WXAPP ? 909201 : 709201,
            btn_disabled: false, // 地图发送短信按钮禁用状态
            btn_text: '一键发送到手机'
          },
          welfare_product: {
            name: '',
            mobile: '',
            entry: IS_FROM_WXAPP ? 914902 : 714901
          },
          hot_product: {
            name: '',
            mobile: '',
            entry: IS_FROM_WXAPP ? 915002 : 715001
          },
          footer: {
            name: '',
            mobile: '',
            entry: IS_FROM_WXAPP ? 915101 : 715101
          }
        },
        pop: {
          is_show: false, // 是否显示弹窗（背景）
          content_show: false, // 显示的弹窗类型 默认不显示 可选：welfare_product, hot_product, footer, pay, cancel
          is_loading: false,
          product: {},
          pay: {
            order_number: '',
            query_status_timer: null
          }
        },

        benefit_list: BENEFIT_LIST, // 报名专享特权
        brand_list: (_ref = []).concat.apply(_ref, _toConsumableArray(BRAND_LIST.map(function (brand) {
          return brand.pic;
        }))), // 严选品牌
        product: product,
        product_tag_icon_map: {
          '人气爆款': 'i-tag-fire',
          '销量冠军': 'i-tag-crown',
          'TOP10': 'i-tag-star',
          '口碑推荐': 'i-tag-thumbs-up'
        },
        guarantee_list: [{ name: '品牌保障' }, { name: '正品保障' }, { name: '低价保障' }, { name: '质量保障' }, { name: '服务保障' }, { name: '售后保障' }],
        comment_list: praise_comment_list,
        is_need_captcha: false,
        share: {
          share_key: param('share_key'),
          entry_type: param('entry_type'),
          loading: false,
          count_down: 0,
          captcha: ''
        },
        apply_id: '',
        /* log sms */
        is_sms_logged: false
      },
      computed: {
        isBenefitShow: function isBenefitShow() {
          return this.benefit_list.length > 1 && this.benefit_list.length < 9;
        },
        isProductShow: function isProductShow() {
          var product = this.product;
          return product.single_list.length > 0 || product.double_list.length > 0;
        },
        isBrandShow: function isBrandShow() {
          return this.brand_list.length > 0;
        }
      },
      methods: {
        dataStatistics: function dataStatistics(label) {
          var ware_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

          window._vds && window._vds.track('antuan_click', { label: label, ware_id: ware_id, branch: BRANCH.name });
          return true;
        },
        selectBranch: function selectBranch(branch) {
          window.location.href = '//m.tugou.com/tuan/' + branch.spelling + '/';
        },
        link: function link(url) {
          var is_from_app = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.is_from_app;

          if (!is_from_app) {
            return url;
          }
          if (-1 === url.indexOf('?')) {
            return url + '?from=app';
          } else {
            return url + '&from=app';
          }
        },
        toggleLink: function toggleLink(url, type, item) {
          if (!this.checkWechatAuthorized()) {
            return;
          }
          if (this.issue_id === Number(Cookie.get('issue_id'))) {
            if (Cookie.get('ticket_number') || type === 'hot_product') {
              // 已购黑卡 || 非黑卡模块
              window.location.href = this.link(url);
              return;
            }
          }
          this.showPop(type, item);
        },
        checkWechatAuthorized: function checkWechatAuthorized() {
          if (!IS_WECHAT) {
            return true;
          }
          if (this.wechat_open_id) {
            return true;
          }
          recordScrollTop();
          this.swert_msg = '微信登录中...';
          window.location.href = '' + URL.wechat_auth + encodeURIComponent(THIS_HREF);
          return false;
        },
        bannerApply: function bannerApply() {
          var _this = this;

          if (!isMobile(this.form.banner.mobile)) {
            return false;
          }
          var send_data = {
            mobile: this.form.banner.mobile,
            entry_type: this.form.banner.entry
          };
          return this.apply(URL.apply, send_data).then(function (res) {
            _this.form.banner.is_verify_show = true;
            return Promise.resolve(res);
          });
        },
        routeApply: function routeApply() {
          var _this2 = this;

          if (!isMobile(this.form.route.mobile)) {
            this.swert_msg = '请填写正确的手机号码';
            return false;
          }
          this.form.route.btn_disabled = true;
          var send_data = {
            mobile: this.form.route.mobile,
            entry_type: this.form.route.entry
          };
          return this.apply(URL.route_apply, send_data).then(function (data) {
            if (data.error === 0) {
              _this2.form.route.btn_text = '发送成功';
            }
            _this2.swert_msg = data.message;
            _this2.form.route.btn_disabled = false;
            _this2.form.route.mobile = '';
          }).catch(function (e) {
            console.error(e);
            _this2.form.route.btn_disabled = false;
          });
        },
        popApply: function popApply() {
          var _this3 = this;

          var send_data = {
            mobile: this.form[this.pop.content_show].mobile,
            entry_type: this.form[this.pop.content_show].entry
          };
          if (!isMobile(send_data.mobile)) {
            return false;
          }
          if (/product/.test(this.pop.content_show)) {
            send_data.pin_ware_id = this.pop.product.id;
          }
          return this.apply(URL.apply, send_data).then(function (data) {
            if (_this3.pop.content_show === 'hot_product') {
              if (data.error === 0 || data.error === 1001) {
                Cookie.set('issue_id', _this3.issue_id, { expires: 30, path: '/' });
                window.location.href = _this3.link(_this3.pop.product.url);
              } else if (data.error === 1002) {
                /* 已支付的用户设置 Cookie 标识必买爆款产品是否须要弹出领票弹窗，未支付且点击立即领票接口的通过单独支付页设置 Cookie */
                Cookie.set('issue_id', _this3.issue_id, { expires: 30, path: '/' });
                Cookie.set('ticket_number', data.data.ticket_number, { expires: 30, path: '/' });
                window.location.href = _this3.link(_this3.pop.product.url);
              } else {
                _this3.swert_msg = data.message;
              }
            }
          });
        },
        apply: function apply(url, send_data) {
          var _this4 = this;

          var common_data = {
            wechat: this.activity.buddy_wechat,
            city_name: this.branch.name,
            utm_source: param('utm_source'),
            utm_term: param('utm_term'),
            track_key: param('track_key'),
            is_send_message: {
              value: 0,
              clearable: false
            }
          };
          Object.assign(send_data, common_data);
          clean(send_data);
          return jsonp(url, send_data).then(function (data) {
            if (data.error === 0 || data.error === 1001) {
              _this4.apply_id = data.id;
              _this4.is_need_captcha = isNaN(parseInt(data.need_check_captcha)) || data.need_check_captcha == 1;
            }
            return Promise.resolve(data);
          });
        },
        logSms: function logSms(mobile, captcha) {
          var _this5 = this;

          if (this.is_sms_logged || captcha.length !== 4) {
            return;
          }
          return axios.get('//m.tugou.com/tuan/apply/issue/input-captcha?mobile=' + mobile).then(function (res) {
            if (res.data.error === 0) {
              _this5.is_sms_logged = true;
            }
          });
        },
        sendSms: function sendSms(field, pop_show) {
          var _this6 = this;

          var mobile = '';
          if (field) {
            mobile = this.form[pop_show].mobile;
            if (!isMobile(this.form[pop_show].mobile)) {
              this.swert_msg = ERROR_MSG_MOBILE;
              return;
            }
          } else {
            mobile = this.form.banner.mobile;
            if (!isMobile(this.form.banner.mobile)) {
              this.swert_msg = ERROR_MSG_MOBILE;
              return;
            }
          }
          this.share.count_down = 60;
          this.share.loading = true;
          return axios.get('//m.tugou.com/tuan/apply/issue/get-captcha/', {
            params: { mobile: mobile }
          }).then(function (res) {
            var data = res.data;
            if (data.error === 0) {
              var t = setInterval(function () {
                if (_this6.share.count_down > 0) {
                  _this6.share.count_down--;
                } else {
                  _this6.share.loading = false;
                  clearInterval(t);
                }
              }, 1000);
            } else {
              _this6.swert_msg = data.message;
              _this6.share.loading = false;
            }
          });
        },
        getTicket: function getTicket(field, pop_type) {
          var _this7 = this;

          var mobile = '';
          var name = '';

          function setBtnEnable() {
            field ? this.pop.is_loading = false : this.form.banner.is_loading = false;
          }

          if (field) {
            mobile = this.form[pop_type].mobile;
            name = this.form[pop_type].name;
            if (!isMobile(this.form[pop_type].mobile)) {
              this.swert_msg = ERROR_MSG_MOBILE;
              return;
            }
            this.pop.is_loading = true;
          } else {
            mobile = this.form.banner.mobile;
            name = this.form.banner.name;
            if (!isMobile(this.form.banner.mobile)) {
              this.swert_msg = ERROR_MSG_MOBILE;
              return;
            }
            this.form.banner.is_loading = true;
          }
          if (this.is_need_captcha && !this.share.captcha) {
            this.swert_msg = '请输入验证码';
            setBtnEnable.call(this);
            return;
          }
          var send_data = {
            name: name,
            mobile: mobile,
            captcha: this.share.captcha,
            apply_id: this.apply_id,
            city_name: this.branch.name,
            company: this.form.banner.company ? 1 : '',
            materials: this.form.banner.material ? 1 : '',
            furniture: this.form.banner.furniture ? 1 : '',
            need_loan: this.form.banner.loan ? 1 : '',
            is_send_message: 1
          };
          clean(send_data);
          var commit = function commit() {
            return axios.post(URL.buy_ticket, send_data).then(function (res) {
              setBtnEnable.call(_this7);
              var data = res.data;
              if (!field && !_this7.is_from_app) {
                // banner
                window.tugou_toutiao([{
                  convert_id: '1601769144889373',
                  event_type: 'form'
                }]); // 今日头条转化代码
              }
              var is_from_product = pop_type === 'welfare_product' || pop_type === 'hot_product';

              /* 360信息流OCPC代码测试 北京 */
              if (_this7.branch.spelling === 'beijing' && !_this7.is_from_app && !_this7.is_from_wxapp && (data.error === 0 || data.error === 1001 || data.error === 1002)) {
                (function (w, n) {
                  w[n] = typeof w[n] === 'function' ? w[n] : function () {
                    (w[n].c = w[n].c || []).push(arguments);
                  };
                  _qha('send', {
                    et: 31,
                    order: [{
                      id: data.data.ticket_number, // 注册id, 必填项
                      orderType: '1' // 常量，请勿修改
                    }]
                  });
                })(window, '_qha');
              }

              if (data.error === 0 || data.error === 1001) {
                if (is_from_product) {
                  _this7.pop.pay.order_number = data.data.ticket_number;
                  _this7.hidePopContent();
                  _this7.showPop('pay');
                } else {
                  window.location.href = '//m.tugou.com/tuan/apply/success/?from_mobile=1&id=' + _this7.apply_id + '&mc=zbmy&issue_id=' + _this7.issue_id;
                }
              } else if (data.error === 1002) {
                /* 已支付的用户设置 Cookie 标识必买爆款产品是否须要弹出领票弹窗，未支付且点击立即领票接口的通过单独支付页设置 Cookie */
                Cookie.set('issue_id', _this7.issue_id, { expires: 30, path: '/' });
                Cookie.set('ticket_number', data.data.ticket_number, { expires: 30, path: '/' });
                if (is_from_product) {
                  window.location.href = _this7.link(_this7.pop.product.url);
                } else {
                  window.location.href = '//m.tugou.com/tuan/apply/success/?from_mobile=1&id=' + _this7.apply_id + '&mc=zbmy&issue_id=' + _this7.issue_id;
                }
              } else {
                _this7.swert_msg = data.message;
              }
            });
          };
          var apply = function apply() {
            return field ? _this7.popApply() : _this7.bannerApply();
          };
          if (!this.apply_id) {
            return apply().then(function () {
              return commit();
            });
          }
          return commit();
        },
        scrollTo: function scrollTo(el_id, index) {
          var nav_arr = this.nav.list.filter(function (item) {
            return item.is_show;
          }).map(function (item) {
            return item.name;
          });
          window._vds && window._vds.track('antuan_click', { label: '导航', text_information: nav_arr[index], branch: BRANCH.name });
          this.smooth_scroll.animateScroll(document.getElementById(el_id));
        },
        toggleCollapsedComment: function toggleCollapsedComment(comment) {
          comment.is_collapsed = !comment.is_collapsed;
        },
        getCollapsedText: function getCollapsedText(original_text, max_length) {
          var appendix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

          return _getCollapsedText(original_text, max_length, appendix);
        },
        showPop: function showPop(type, product) {
          var _this8 = this;

          this.pop.is_show = true;
          this.share.captcha = '';
          if (type === 'welfare_product' || type === 'hot_product') {
            this.pop.product = JSON.parse(JSON.stringify(product));
          }
          var timer = setTimeout(function () {
            _this8.pop.content_show = type;
            clearTimeout(timer);
          });
        },
        hidePop: function hidePop() {
          if (!this.pop.content_show) {
            // 连续弹出弹窗时不隐藏
            this.pop.is_show = false;
          }
        },
        hidePopContent: function hidePopContent() {
          if (!this.pop.is_loading) {
            this.pop.content_show = false;
            this.share.captcha = '';
          }
        },
        confirmCancelPay: function confirmCancelPay() {
          // 关闭支付弹窗
          this.showPop('cancel');
        },

        /* 必买爆款领票获取抢购资格支付相关 */
        queryPayStatus: function queryPayStatus() {
          var _this10 = this;

          var is_init_query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          /*
           *  两种状态调用该方法
           *  1. 支付成功后返回当前页刷新页面后无法获取支付状态，查询一次并立即清空支付相关数据
           *  2. 支付成功后返回当前页（不刷新），当前页轮询支付状态
           *  - 支付相关数据在创建支付订单时写入 Cookie
           */
          function query(order_number, redirect_url) {
            var _this9 = this;

            return axios.get('//m.tugou.com/tuan/pay/query?order_number=' + order_number + '&_ajax=true').then(function (res) {
              if (res.data.status == 3) {
                _this9.clearCookiePayData();
                Cookie.set('issue_id', _this9.issue_id, { expires: 30, path: '/' });
                Cookie.set('ticket_number', order_number, { expires: 30, path: '/' });
                window.location.href = redirect_url;
              }
            });
          }
          if (is_init_query) {
            var pay_data = this.getCookiePayData();
            if (!pay_data) {
              return;
            }
            this.clearCookiePayData();
            query(pay_data.order_number, pay_data.product_url);
            return;
          }
          this.pop.pay.query_status_timer = setInterval(function () {
            query(_this10.pop.pay.order_number, _this10.pop.product.url);
          }, 2000);
        },
        clearQueryPayStatus: function clearQueryPayStatus() {
          if (this.pop.pay.query_status_timer) {
            clearInterval(this.pop.pay.query_status_timer);
          }
        },
        setCookiePayData: function setCookiePayData() {
          Cookie.set('pay_data', {
            order_number: this.pop.pay.order_number,
            product_url: this.pop.product.url
          });
        },
        getCookiePayData: function getCookiePayData() {
          return Cookie.getJSON('pay_data');
        },
        clearCookiePayData: function clearCookiePayData() {
          // 清除支付相关数据，防止重复跳转
          Cookie.remove('pay_data');
        },
        pay: function pay(web_pay_type) {
          var _this11 = this;

          var post_pay = '//m.tugou.com/tuan/pay/create';
          var obj = {
            order_number: this.pop.pay.order_number,
            pay_kind: web_pay_type,
            _ajax: true
          };
          axios.post(post_pay, obj).then(function (res) {
            if (res.data.error == 0) {
              if (IS_WECHAT) {
                var data = res.data;
                var onBridgeReady = function onBridgeReady() {
                  WeixinJSBridge.invoke('getBrandWCPayRequest', data.jsapi, function (res) {
                    if (res.err_msg == 'get_brand_wcpay_request:ok') {
                      var redirect = document.createElement('a');
                      redirect.href = app.pop.product.url;
                      if (!redirect.click) {
                        window.location.href = redirect.href;
                      } else {
                        redirect.click();
                      }
                    } else {
                      console.log(res.err_msg);
                    }
                  });
                };
                if (typeof WeixinJSBridge == 'undefined') {
                  if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                  } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                  }
                } else {
                  onBridgeReady();
                }
              } else {
                var redirect = document.createElement('a');
                redirect.href = res.data.redirect_url;
                if (!redirect.click) {
                  window.location.href = redirect.href;
                } else {
                  redirect.click();
                }
              }
            } else {
              _this11.swert_msg = res.data.message;
            }
          });
        },
        payOnApp: function payOnApp(web_pay_type) {
          var _this12 = this;

          // 微信 1, 支付宝 2
          var post_pay = '//api.tugou.com/tuan/pay/create';
          var obj = {
            order_number: this.pop.pay.order_number,
            pay_kind: web_pay_type,
            _ajax: true
          };
          axios.post(post_pay, obj).then(function (res) {
            if (res.data.error === 0) {
              web_pay_type === 1 ? app_bridge.wxpay(res.data.data.order_data, function (res) {
                _this12.payCallback(res);
              }) : app_bridge.alipay({ 'payString': res.data.data.order_data }, function (res) {
                _this12.payCallback(res);
              });
            } else {
              _this12.swert_msg = res.data.message;
            }
          });
        },
        payCallback: function payCallback(res) {
          if (res.data.success) {
            this.swert_msg = '支付成功，请稍候...';
          } else {
            this.swert_msg = '支付失败';
          }
        },
        payOrder: function payOrder(type, web_pay_type) {
          var _this13 = this;

          axios.post('//m.tugou.com/tuan/pay/restart', {
            order_number: this.pop.pay.order_number,
            payment_type: PAYMENT_TYPE_MAP[type],
            _ajax: true
          }).then(function (res) {
            if (res.data.error === 0) {
              _this13.clearQueryPayStatus();
              _this13.queryPayStatus(); // 开始轮询是否支付完成
              _this13.setCookiePayData();
              if (_this13.is_from_app) {
                app_bridge.getAppInfo().then(function (res) {
                  var app_version = res.app_version;
                  app_version < '4.4.1' ? _this13.pay(web_pay_type) : _this13.payOnApp(web_pay_type);
                });
              } else {
                _this13.pay(web_pay_type);
              }
            } else {
              alert(res.data.message);
            }
          });
        },

        /* 支付相关 end */
        getSoldPercentage: function getSoldPercentage(sold, inventory) {
          var percentage = numeral(sold).divide(this.getTotal(sold, inventory));
          // 防止后台自定义数据导致的计算结果不符合逻辑的情况
          if (percentage.value() > 1) {
            return '100%';
          }
          if (percentage.value() < 0) {
            return '0%';
          }
          return percentage.format('0%');
        },
        getTotal: function getTotal(sold, inventory) {
          return numeral(sold).add(inventory).value();
        },
        toggleMyTicket: function toggleMyTicket() {
          this.showPop('footer');
        },
        checkboxClick: function checkboxClick(model) {
          eval('this.' + model + ' = !this.' + model);
        },
        appShare: function appShare() {
          var share = window.SHARE;
          app_bridge.appShare({
            title: share.title,
            desc: share.description,
            link: share.url,
            icon: share.icon_url
          }, function (res) {
            alert(res);
          });
        },
        qiyuOpen: function qiyuOpen() {
          if (this.is_from_app) {
            app_bridge.openCustomService({ title: '兔狗家装节', url: THIS_HREF });
          } else {
            window.qiyukefuOpen();
          }
        },
        swert: function swert(msg) {
          this.swert_msg = msg;
        }
      },
      created: function created() {
        var _this14 = this;

        /* 初始化 nav */
        this.nav = {
          list: [{
            id: 'benefit',
            tail_id: 'benefit-tail',
            name: '会员特权',
            is_show: true
          }, {
            id: 'product',
            tail_id: 'product-tail',
            name: '必买爆款',
            is_show: this.isProductShow
          }, {
            id: 'brand',
            tail_id: 'brand-tail',
            name: '严选品牌',
            is_show: this.isBrandShow
          }, {
            id: 'reason',
            tail_id: 'reason-tail',
            name: '五大理由',
            is_show: true
          }, {
            id: 'route',
            tail_id: 'route-tail',
            name: '地图导航',
            is_show: true
          }],
          active: 'benefit'
        };

        axios.get(URL.query).then(function (res) {
          var data = res.data;
          if (data.error !== 0) {
            return;
          }
          _this14.wechat_open_id = data.data.wx_open_id;
        });

        app_bridge.init();

        this.queryPayStatus(true);
      },
      mounted: function mounted() {
        var _this15 = this;

        Echo.init({
          offsetVertical: 400,
          debounce: false
        });

        new Swiper('#gallery', {
          autoplay: 2000,
          loop: true,
          centeredSlides: true
        });

        var brand_name = param('brand_name');
        var track_key = param('track_key');
        window.SHARE = {
          title: brand_name && track_key ? decodeURIComponent(brand_name) + "\u9080\u8BF7\u60A8\u53C2\u52A0\u5154\u72D7\u5BB6\u88C5\u8282" : this.activity.name, // 分享标题
          description: "\u65F6\u95F4\uFF1A" + this.activity.time + " \u5730\u70B9\uFF1A" + this.activity.venue_name, // 分享描述
          url: 'https://m.tugou.com/tuan/' + this.branch.spelling + '/', // 分享链接
          icon_url: 'https://tugou-pic.oss-cn-hangzhou.aliyuncs.com/tuan/apply/share.jpg' // 分享图片
        };

        this.smooth_scroll = new SmoothScroll();

        var footerShowControl = function footerShowControl() {
          return _this15.is_footer_show = (document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop) > window.screen.availHeight / 2;
        };
        var nav_list = JSON.parse(JSON.stringify(this.nav.list));
        var navFixControl = function navFixControl() {
          _this15.is_nav_fixed = getWindowRelativeTop(nav_list[0].id) < 0;
          nav_list.some(function (item) {
            if (!item.is_show) {
              return false;
            }
            var is_active = (item.id === 'benefit' || getWindowRelativeTop(item.id) <= 0) && getWindowRelativeTop(item.tail_id) > 0;
            _this15.nav.active = is_active ? item.id : null;
            return is_active;
          });
        };
        var scroll = function scroll() {
          footerShowControl();
          navFixControl();
        };
        window.onscroll = scroll;
        scroll();

        this.$nextTick(function () {
          return checkScrollAndRemoveScrollTop();
        });
      }
    });

    function isMobile(mobile) {
      return (/^1\d{10}$/.test(mobile)
      );
    }

    function getWindowRelativeTop(id) {
      var el = document.getElementById(id);
      if (!el) {
        return null;
      }
      return document.getElementById(id).getBoundingClientRect().top;
    }

    function recordScrollTop() {
      Cookie.set('scroll_top', document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop);
    }
    function checkScrollAndRemoveScrollTop() {
      var scroll_top = numeral(Cookie.get('scroll_top')).value();
      if (!scroll_top) {
        return;
      }
      app.smooth_scroll.animateScroll(scroll_top);
      Cookie.remove('scroll_top');
    }
  }, { "../../../../../widget/common/swert.vue": 133, "../../../../../widget/m/icp.vue": 134, "../../../../../widget/m/title-bar.vue": 136, "../../../../widget/hold-date": 132, "../../../widget/countdown.vue": 130, "../../../widget/redpacket-apply-popup.vue": 131, "bmh/clean-empty-obj": 3, "bmh/date-format": 4, "bmh/jsonp": 5, "bmh/param": 6, "echo-js": 78, "js-cookie": 79, "lodash/each": 107, "numeral": 122, "smooth-scroll": 124 }], 130: [function (require, module, exports) {
    var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 114, stdin */\n#activity-countdown {\n  height: 0.8rem;\n  background: #d22929;\n  line-height: 0.8rem;\n  text-align: center;\n  font-size: 0.32rem;\n  color: #fff; }\n  /* line 121, stdin */\n  #activity-countdown strong {\n    display: inline-block;\n    margin: 0 0.1em;\n    border-radius: 0.02rem;\n    width: 0.48rem;\n    height: 0.48rem;\n    background: #1B1D1D;\n    line-height: 0.48rem;\n    font-weight: normal; }");(function () {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var VALID_TIMESTAMP_ONE_DAY = 1000 * 3600 * 24;
      var FREQUENCY = 100;
      exports.default = {
        props: {
          date: {
            type: String,
            default: '1970-01-01'
          },
          showDays: {
            type: Boolean,
            default: true
          },
          showSecUnit: {
            type: Boolean,
            default: true
          },
          showMs: {
            type: Boolean,
            default: true
          },
          format: String,
          text: String,
          validDays: {
            type: Number,
            default: 3
          }
        },
        data: function data() {
          var format_list = this.format ? this.format.split('/') : '';
          return {
            is_show: false,
            day: '',
            hr: '',
            min: '',
            sec: '',
            tenth_of_a_sec: '',
            format_list: [format_list[0] || '天', format_list[1] || ':', format_list[2] || ':', format_list[3] || '.']
          };
        },

        watch: {
          'date': function date() {
            this.watchDate();
          }
        },
        methods: {
          isNowInValidDays: function isNowInValidDays(left_timestamp) {
            return left_timestamp > 0 && left_timestamp < VALID_TIMESTAMP_ONE_DAY * this.validDays;
          },
          getTimestamp: function getTimestamp() {
            var date = this.date.replace(/-/g, '/');
            if (date !== '' && !/^\d{4}\/\d{2}\/\d{2}$/.test(date)) {
              throw Error('Prop \'date\' format error!');
            }
            var now_timestamp = new Date().getTime();
            var target_timestamp = new Date(date + ' 00:00:00+0800').getTime();
            return target_timestamp - now_timestamp;
          },
          setCountdown: function setCountdown(timestamp, stopCallback) {
            var _this = this;

            var minutes_for_update_timestamp = 0;
            timestamp -= FREQUENCY;
            var interval = setInterval(function () {
              var day = Math.floor(timestamp / 1000 / 60 / 60 / 24);
              var hr = Math.floor(timestamp / 1000 / 60 / 60 % 24);
              var min = Math.floor(timestamp / 1000 / 60 % 60);
              var sec = Math.floor(timestamp / 1000 % 60);
              var tenth_of_a_sec = Math.floor(timestamp % 1000 / FREQUENCY);
              if (_this.showDays) {
                _this.setTimeData({ day: day, hr: hr, min: min, sec: sec, tenth_of_a_sec: tenth_of_a_sec });
              } else {
                hr += day * 24;
                _this.setTimeData({ hr: hr, min: min, sec: sec, tenth_of_a_sec: tenth_of_a_sec });
              }
              timestamp -= FREQUENCY;
              minutes_for_update_timestamp += FREQUENCY;
              if (minutes_for_update_timestamp > 1000 * 60 * 30) {
                timestamp = _this.getTimestamp();
                minutes_for_update_timestamp = 0;
              }
              if (timestamp <= 0) {
                stopCallback();
                clearInterval(interval);
              }
            }, FREQUENCY);
          },
          setTimeData: function setTimeData(data) {
            for (var key in data) {
              if (data.hasOwnProperty(key)) {
                this[key] = data[key];
              }
            }
          },
          watchDate: function watchDate() {
            var _this2 = this;

            var left_timestamp = this.getTimestamp();
            if (left_timestamp && this.isNowInValidDays(left_timestamp)) {
              this.is_show = true;
              this.setCountdown(left_timestamp, function () {
                return _this2.is_show = false;
              });
            }
          }
        },
        mounted: function mounted() {
          this.watchDate();
        }
      };
    })();
    if (module.exports.__esModule) module.exports = module.exports.default;
    var __vue__options__ = typeof module.exports === "function" ? module.exports.options : module.exports;
    if (__vue__options__.functional) {
      console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.");
    }
    __vue__options__.render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _vm.is_show ? _c('div', { attrs: { "id": "activity-countdown" } }, [_c('span', [_vm._v(_vm._s(_vm.text ? _vm.text : '距领票结束仅剩：'))]), _vm.showDays ? [_c('strong', [_vm._v(_vm._s(_vm.day))]), _vm._v(_vm._s(_vm.format_list[0]))] : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.hr))]), _vm._v(_vm._s(_vm.format_list[1])), _c('strong', [_vm._v(_vm._s(_vm.min))]), _vm._v(_vm._s(_vm.format_list[2])), _c('strong', [_vm._v(_vm._s(_vm.sec))]), _vm.showSecUnit ? [_vm._v(_vm._s(_vm.format_list[3]))] : _vm._e(), _vm.showMs ? [_c('strong', [_vm._v(_vm._s(_vm.tenth_of_a_sec))])] : _vm._e()], 2) : _vm._e();
    };
    __vue__options__.staticRenderFns = [];
    if (module.hot) {
      (function () {
        var hotAPI = require("vue-hot-reload-api");
        hotAPI.install(require("vue"), true);
        if (!hotAPI.compatible) return;
        module.hot.accept();
        module.hot.dispose(__vueify_style_dispose__);
        if (!module.hot.data) {
          hotAPI.createRecord("data-v-5022fc84", __vue__options__);
        } else {
          hotAPI.rerender("data-v-5022fc84", __vue__options__);
        }
      })();
    }
  }, { "vue": 127, "vue-hot-reload-api": 126, "vueify/lib/insert-css": 128 }], 131: [function (require, module, exports) {
    var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("@keyframes shake {\n  0%, 35%, 50%, 100% {\n    transform: rotate(0deg); }\n  5%, 25%, 45% {\n    transform: rotate(5deg); }\n  15% {\n    transform: rotate(-5deg); } }\n\n/* line 276, stdin */\n#red-packet-pop .redpacket {\n  position: fixed;\n  top: 30%;\n  right: 1%;\n  z-index: 3;\n  width: 0.92rem; }\n  /* line 282, stdin */\n  #red-packet-pop .redpacket img {\n    width: 100%;\n    animation: shake 2s infinite linear; }\n\n/* line 288, stdin */\n#red-packet-pop .form-inline,\n#red-packet-pop .pop .title {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center; }\n\n/* line 304, stdin */\n#red-packet-pop .pop {\n  position: relative;\n  margin: 20% auto;\n  border-radius: 0.16rem;\n  width: 6.30rem;\n  height: auto;\n  padding-top: 1px;\n  background: -webkit-linear-gradient(bottom, #dc1129 0, #fc212b 77%, #ff7e15 100%);\n  background: linear-gradient(to top, #dc1129 0, #fc212b 77%, #ff7e15 100%);\n  padding-bottom: 0.36rem;\n  color: #fff; }\n  /* line 315, stdin */\n  #red-packet-pop .pop .close {\n    font-size: 0.42rem;\n    color: #fff; }\n  /* line 319, stdin */\n  #red-packet-pop .pop .decoration {\n    position: absolute;\n    top: 0;\n    left: -0.30rem;\n    width: 6.90rem;\n    height: 3.62rem;\n    background: url(\"//static.tugou.com/tuan/m/topic/version/1711281/img/decoration.png\") no-repeat center/6.9rem 3.62rem; }\n  /* line 327, stdin */\n  #red-packet-pop .pop figure {\n    padding: 0.02rem 0 0;\n    text-align: center;\n    font-size: 0.32rem; }\n    /* line 331, stdin */\n    #red-packet-pop .pop figure img {\n      display: block;\n      margin: -0.42rem auto 0;\n      width: 1.93rem;\n      height: 2.00rem; }\n  /* line 338, stdin */\n  #red-packet-pop .pop .title {\n    padding: 0.48rem 0;\n    text-align: center;\n    font-size: 0.40rem; }\n    /* line 342, stdin */\n    #red-packet-pop .pop .title .border {\n      margin-right: 0.24rem;\n      width: 0.02rem;\n      height: 0.81rem;\n      background: #fc939b; }\n    /* line 348, stdin */\n    #red-packet-pop .pop .title .price {\n      padding-right: 0.16rem; }\n    /* line 351, stdin */\n    #red-packet-pop .pop .title strong {\n      display: inline-block;\n      height: 1.08rem;\n      line-height: 1.08rem;\n      font-size: 1.16rem; }\n    /* line 357, stdin */\n    #red-packet-pop .pop .title small {\n      font-size: 0.36rem; }\n    /* line 360, stdin */\n    #red-packet-pop .pop .title .price,\n    #red-packet-pop .pop .title strong {\n      vertical-align: text-top; }\n  /* line 365, stdin */\n  #red-packet-pop .pop .form {\n    margin: 0 0.34rem;\n    background: transparent; }\n    /* line 369, stdin */\n    #red-packet-pop .pop .form .submit {\n      margin: 0.32rem 0 0.24rem;\n      height: auto; }\n  /* line 374, stdin */\n  #red-packet-pop .pop > p {\n    margin: 0 0.34rem 0.08rem;\n    font-size: 0.24rem; }\n  /* line 379, stdin */\n  #red-packet-pop .pop.pop-verify .back {\n    display: block;\n    margin: 0.12rem 0 0 0.12rem;\n    width: 0.60rem;\n    height: 0.60rem; }\n  /* line 385, stdin */\n  #red-packet-pop .pop.pop-verify h1 {\n    margin: 0.36rem 0;\n    text-align: center;\n    font-size: 0.30rem; }\n  /* line 390, stdin */\n  #red-packet-pop .pop.pop-verify a {\n    color: #ffbf81; }\n  /* line 394, stdin */\n  #red-packet-pop .pop.pop-verify .form-inline button {\n    border: 1px solid transparent;\n    min-width: 2.00rem;\n    max-width: 2.40rem;\n    background: #ff8c1b;\n    font-size: 0.28rem;\n    color: #fff; }\n    /* line 401, stdin */\n    #red-packet-pop .pop.pop-verify .form-inline button:disabled {\n      background: #aaa; }\n  /* line 407, stdin */\n  #red-packet-pop .pop .hint {\n    margin: 0.16rem 0;\n    text-align: center;\n    font-size: 0.48rem;\n    font-weight: bold; }\n    /* line 412, stdin */\n    #red-packet-pop .pop .hint small {\n      font-size: 0.30rem; }\n  /* line 417, stdin */\n  #red-packet-pop .pop .done figure {\n    font-size: 0.24rem; }");(function () {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _promise = require('babel-runtime/core-js/promise');

      var _promise2 = _interopRequireDefault(_promise);

      var _popup = require('../../../widget/m/popup.vue');

      var _popup2 = _interopRequireDefault(_popup);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var jsonp = require('bmh/jsonp');
      var param = require('bmh/param');
      var clean = require('bmh/clean-empty-obj');
      function isMobile(mobile) {
        return (/^1\d{10}$/.test(mobile)
        );
      }
      var URL = {
        apply: '//m.tugou.com/tuan/apply/issue/apply/',
        buy_ticket: '//m.tugou.com/tuan/apply/issue/buy-ticket/',
        get_captcha: '//m.tugou.com/tuan/apply/issue/get-captcha/'
      };
      exports.default = {
        props: {
          time: String,
          address: String,
          wechat: String,
          branch_name: String,
          entry_id: Number
        },
        data: function data() {
          return {
            show: 'apply',
            content_list: [{ name: 'apply', class_name: 'pop pop-apply' }, { name: 'verify', class_name: 'pop pop-verify' }, { name: 'done', class_name: 'pop pop-done' }],

            is_done: false,
            name: '',
            mobile: '',
            captcha: '',
            apply_id: '',
            verify: {
              loading: false,
              count_down: 0
            },
            is_need_captcha: false,
            form_loading: false,
            hint: '',

            is_applied: false,

            is_applying: false };
        },

        components: { popup: _popup2.default },
        methods: {
          swert: function swert(msg) {
            this.$emit('swert', msg);
          },
          showPop: function showPop(content) {
            this.show = content || 'apply';
          },
          hidePop: function hidePop() {
            this.show = false;
          },
          getCaptcha: function getCaptcha() {
            var _this = this;

            if (!isMobile(this.mobile)) {
              this.swert('手机号码填写有误');
              return;
            }
            this.verify.count_down = 59;
            this.verify.loading = true;
            return axios.post(URL.get_captcha, { mobile: this.mobile }).then(function (res) {
              var data = res.data;
              if (data.error === 0) {
                var t = setInterval(function () {
                  if (_this.verify.count_down > 0) {
                    _this.verify.count_down--;
                  } else {
                    _this.verify.loading = false;
                    clearInterval(t);
                  }
                }, 1000);
              } else {
                _this.swert(data.message);
                _this.verify.loading = false;
              }
            });
          },
          validate: function validate() {
            if (!this.mobile) {
              this.swert('请填写手机号码');
              return false;
            }
            if (!isMobile(this.mobile)) {
              this.swert('手机号码格式错误');
              return false;
            }
            return true;
          },
          applyCommit: function applyCommit() {
            var _this2 = this;

            if (!this.validate()) {
              return false;
            }
            this.form_loading = true;
            var interval = void 0;
            var commit = function commit() {
              if (!_this2.is_applying) {
                clearInterval(interval);

                _this2.form_loading = false;
                if (_this2.is_need_captcha) {
                  _this2.showPop('verify');
                  _this2.getCaptcha();
                } else {
                  _this2.getTicket();
                }
              }

              return commit;
            };
            interval = setInterval(commit(), 200);
          },
          apply: function apply() {
            var _this3 = this;

            if (!isMobile(this.mobile)) {
              return _promise2.default.reject();
            }
            var send_data = {
              name: this.name,
              mobile: this.mobile,
              entry_type: this.entry_id,
              topic: '兔狗家装节',
              hold_date: this.time,
              venue_name: this.address,
              wechat: this.wechat,
              city_name: this.branch_name,
              from_mobile: 1,
              utm_source: param('utm_source'),
              utm_term: param('utm_term'),
              is_send_message: 0
            };
            clean(send_data);
            this.is_applying = true;
            return jsonp(URL.apply, send_data).then(function (data) {
              _this3.captcha = '';
              if (data.error === 0 || data.error === 1001) {
                if (data.error === 1001) {
                  _this3.is_applied = true;
                }
                _this3.apply_id = data.id;
                _this3.is_need_captcha = isNaN(parseInt(data.need_check_captcha)) || data.need_check_captcha == 1;
              }
              _this3.is_applying = false;
            });
          },
          getTicket: function getTicket() {
            var _this4 = this;

            if (!isMobile(this.mobile)) {
              this.swert('手机号码填写有误');
              return;
            }
            if (this.is_need_captcha && !this.captcha) {
              this.swert('请输入验证码');
              return;
            }
            this.form_loading = true;
            var send_data = {
              mobile: this.mobile,
              captcha: this.captcha,
              apply_id: this.apply_id,
              is_send_message: 1
            };
            clean(send_data);
            var commit = function commit() {
              return axios.post(URL.buy_ticket, send_data).then(function (res) {
                _this4.form_loading = false;
                var data = res.data;

                if (data.error === 0 || data.error === 1001 || data.error === 1002) {
                  _this4.is_done = true;
                  _this4.hint = _this4.is_applied ? '已经领取过啦！' : '领取成功！';
                  _this4.showPop('done');
                } else {
                  _this4.swert(data.message);
                }
              });
            };
            if (!this.apply_id) {
              return this.apply().then(function () {
                return commit();
              });
            }
            return commit();
          },
          qiyuOpen: function qiyuOpen() {
            window.qiyukefuOpen();
          },
          logSms: function logSms(mobile, captcha) {
            var _this5 = this;

            if (this.is_sms_logged || captcha.length !== 4) {
              return;
            }
            return axios.get('//m.tugou.com/tuan/apply/issue/input-captcha?mobile=' + mobile).then(function (res) {
              if (res.data.error === 0) {
                _this5.is_sms_logged = true;
              }
            });
          }
        }
      };
    })();
    if (module.exports.__esModule) module.exports = module.exports.default;
    var __vue__options__ = typeof module.exports === "function" ? module.exports.options : module.exports;
    if (__vue__options__.functional) {
      console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.");
    }
    __vue__options__.render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { attrs: { "id": "red-packet-pop" } }, [_c('a', { staticClass: "redpacket", attrs: { "href": "javascript:;" }, on: { "click": function click($event) {
            _vm.showPop(_vm.is_done ? 'done' : '');
          } } }, [_c('img', { attrs: { "src": "//static.tugou.com/tuan/m/topic/version/1711281/img/redpacket.png", "alt": "" } })]), _vm._v(" "), _c('popup', { attrs: { "content-list": _vm.content_list, "close-icon-class": "close" }, on: { "hide": _vm.hidePop }, model: { value: _vm.show, callback: function callback($$v) {
            _vm.show = $$v;
          }, expression: "show" } }, [_c('template', { slot: "apply" }, [_c('div', { staticClass: "decoration" }), _vm._v(" "), _c('figure', [_c('img', { attrs: { "src": "//static.tugou.com/tuan/m/topic/version/1711281/img/tugou.png", "alt": "" } }), _vm._v("\n        兔狗家装节\n      ")]), _vm._v(" "), _c('div', { staticClass: "title" }, [_c('div', { staticClass: "price" }, [_vm._v("¥"), _c('strong', [_vm._v("30")])]), _vm._v(" "), _c('div', { staticClass: "border" }), _vm._v(" "), _c('div', { staticClass: "intro" }, [_c('small', [_vm._v("免费领取价值")]), _c('br'), _vm._v("30元入场券")])]), _vm._v(" "), _c('div', { staticClass: "form" }, [_c('input', { directives: [{ name: "model", rawName: "v-model", value: _vm.name, expression: "name" }], staticClass: "name-input", attrs: { "type": "text", "placeholder": "请输入您的姓名" }, domProps: { "value": _vm.name }, on: { "input": function input($event) {
            if ($event.target.composing) {
              return;
            }_vm.name = $event.target.value;
          } } }), _vm._v(" "), _c('input', { directives: [{ name: "model", rawName: "v-model", value: _vm.mobile, expression: "mobile" }], attrs: { "type": "tel", "placeholder": "请输入您的手机号码" }, domProps: { "value": _vm.mobile }, on: { "input": [function ($event) {
            if ($event.target.composing) {
              return;
            }_vm.mobile = $event.target.value;
          }, _vm.apply] } }), _vm._v(" "), _c('button', { staticClass: "submit", attrs: { "type": "button", "disabled": _vm.form_loading }, on: { "click": _vm.applyCommit } }, [_vm._v("填好了，免费领取")])]), _vm._v(" "), _c('p', [_vm._v("使用期限：" + _vm._s(_vm.time))]), _vm._v(" "), _c('p', [_vm._v("使用方法：价值30元的家庭套票1份，凭手机号领取，现场核销！")])]), _vm._v(" "), _c('template', { slot: "verify" }, [_c('img', { staticClass: "back", attrs: { "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAApVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+4/eNVAAAANnRSTlMA/eIC+gug9RDs1sQ3HBMF8du0q+e5WFIxJQfQyH9CIohsXkYXzIWZdC4Z7r14ZkxJO2IrKo0E+yDIAAAC2klEQVR42u3cC1biQBQE0ErIF1HkKz+Vjygoyjgzvv0vbdQjSWdWQNV5dwecaL2udKfhnHPOOeecc84555xzzjnnnHPnZn97O74Cv1ViZsMO2D3at7gLaq3MfozBbNa3k1sQKy6ssgav57ZVkkvQmsYm8UAmpVWiG9C6y62S34HWOLFKOQGtVWSV+B60Hq3WfgCrVma1ixSsZn2r9WdgFY5zy1pg9TXOFRZY4TiPfoNWOM6TX6AVjvNr4lIYjvPhH9AKx3mPeNkejvM572uTxjgf8Y7zNBznA94xWCys9gRa4TiPdqA1jTVa7aTUaLWbXKPVjhONVruKJFotlhqttpVptNq0r9Fqi4VGq31ua7TaaazRaielRqvd5BqtdpxotNpVJNFqsdRotd1Mo9WmI6t9gFZjnL+B1nNbo9VOY41W2yk1Wu0m12i140Sj1a4iiVaLpUar7WYarTYdabTaYqHRaou2RqvtLjRaLTKNVos7jVYL9CRaLdBRaLWN7fM+7xj8Njgt2wtwuzitS0Buq/JDTn9aL9SRFS7fD7xr9//id0v+TGKJnv5pbZUX5iUjWnOrJEcQu481zv40f4k9Ma9UHuZWGzHHcHow04jhxmGNeApirybS3HGTBDFMvDUCvF8HMfwKYtNY470pcDXX2JgG0pHGAXig9SQTw7swht9BTCeGOx7DZ+dqa7UDcwzPGjFMvFXdjOHhXxDbRSoxfAxjmPr+ls6Lxp41cO8xfHZmfY3bHT7pxPAqjGHi04HAMbdKRB3DE50Y7lltwHxJW7HQ+PgN6DZimPrEyodMDL9pxjDxVW3N78fsEcQuRWOY+ThRd2AqBweXYQzvQSyM4XwDYhuZGN6HMbwEMY/h8yMawyV1DK81Y5h6i24/DJ4J9f/JZU/i++TmvabUm6ZhDBN/mtX4amMLeuvya7pTv6j/kd7sqLcYnXPOOeecc84555xzzjnnnHPn5x+I+i8A6ScPrAAAAABJRU5ErkJggg==", "alt": "go back" }, on: { "click": function click($event) {
            _vm.showPop();
          } } }), _vm._v(" "), _c('h1', [_vm._v("验证码已发送至" + _vm._s(_vm.mobile))]), _vm._v(" "), _c('div', { staticClass: "body" }, [_c('div', { staticClass: "form" }, [_c('div', { staticClass: "form-inline" }, [_c('input', { directives: [{ name: "model", rawName: "v-model", value: _vm.captcha, expression: "captcha" }], attrs: { "type": "number", "placeholder": "请输入验证码" }, domProps: { "value": _vm.captcha }, on: { "input": [function ($event) {
            if ($event.target.composing) {
              return;
            }_vm.captcha = $event.target.value;
          }, function ($event) {
            _vm.logSms(_vm.mobile, _vm.captcha);
          }] } }), _vm._v(" "), _c('button', { attrs: { "type": "button", "disabled": _vm.verify.loading }, domProps: { "textContent": _vm._s(_vm.verify.loading ? '请稍候（' + _vm.verify.count_down + '）' : '发送短信验证码') }, on: { "click": _vm.getCaptcha } })]), _vm._v(" "), _c('button', { staticClass: "submit", attrs: { "type": "button", "disabled": _vm.form_loading }, on: { "click": _vm.getTicket } }, [_vm._v("验证好了，免费领取")]), _vm._v(" "), _c('p', [_vm._v("验证码收不到？"), _c('a', { attrs: { "href": "javascript:;" }, on: { "click": _vm.qiyuOpen } }, [_vm._v("点击咨询")])])])])]), _vm._v(" "), _c('template', { slot: "done" }, [_c('div', { staticClass: "decoration" }), _vm._v(" "), _c('figure', [_c('img', { attrs: { "src": "//static.tugou.com/tuan/m/topic/version/1711281/img/tugou-ok.png", "alt": "" } }), _vm._v("\n        兔狗家装节\n      ")]), _vm._v(" "), _c('div', { staticClass: "hint" }, [_vm._v(_vm._s(_vm.hint)), _c('br'), _c('small', [_vm._v("价值30元入场券")])]), _vm._v(" "), _c('p', [_vm._v("使用期限：" + _vm._s(_vm.time))]), _vm._v(" "), _c('p', [_vm._v("使用方法：价值30元的家庭套票1份，凭手机号领取，现场核销！")])])], 2)], 1);
    };
    __vue__options__.staticRenderFns = [];
    if (module.hot) {
      (function () {
        var hotAPI = require("vue-hot-reload-api");
        hotAPI.install(require("vue"), true);
        if (!hotAPI.compatible) return;
        module.hot.accept();
        module.hot.dispose(__vueify_style_dispose__);
        if (!module.hot.data) {
          hotAPI.createRecord("data-v-2e9417ec", __vue__options__);
        } else {
          hotAPI.rerender("data-v-2e9417ec", __vue__options__);
        }
      })();
    }
  }, { "../../../widget/m/popup.vue": 135, "babel-runtime/core-js/promise": 2, "bmh/clean-empty-obj": 3, "bmh/jsonp": 5, "bmh/param": 6, "vue": 127, "vue-hot-reload-api": 126, "vueify/lib/insert-css": 128 }], 132: [function (require, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    /**
     * 家装节举办时间
     * @param {String|Date} date 开始日期
     * @param {Number} duration 持续天数
     * @param {Object} options 选项
     * @param {Boolean|Number} options.force_year 强制显示年月日
     * @returns {String} 格式化后的日期
     */
    var dateFormat = require('bmh/date-format');
    function holdDate(date, duration, options) {
      var start_format = '%m月%d日';
      var end_format = '%d日';
      var start_time = new Date(date).getTime();
      var end_time = new Date(date).getTime() + (duration - 1) * 3600 * 24 * 1000;
      options = options || {};

      if (options.force_year) {
        start_format = end_format = '%Y年%m月%d日';
      } else if (duration > 1) {
        if (dateFormat(start_time, '%m') !== dateFormat(end_time, '%m')) {
          end_format = '%m月%d日';
        }
        if (dateFormat(start_time, '%Y') !== dateFormat(end_time, '%Y')) {
          start_format = end_format = '%Y年%m月%d日';
        }
      }

      var start = dateFormat(start_time, start_format, false);
      var end = dateFormat(end_time, end_format, false);
      return '' + start + (duration > 1 ? '-' + end : '');
    }
    exports.default = holdDate;
  }, { "bmh/date-format": 4 }], 133: [function (require, module, exports) {
    var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 5, stdin */\n#component-swert {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  padding: .35rem .5rem;\n  max-width: 80%;\n  border-radius: .04rem;\n  word-break: keep-all;\n  word-wrap: break-word;\n  font-size: .32rem;\n  color: #fff;\n  background-color: rgba(68, 68, 68, 0.88);\n  z-index: 9999;\n  text-align: center; }\n  /* line 22, stdin */\n  #component-swert.a-fadeout {\n    -webkit-animation: fadeout 2s ease-in forwards;\n    -moz-animation: fadeout 2s ease-in forwards;\n    -ms-animation: fadeout 2s ease-in forwards;\n    animation: fadeout 2s ease-in forwards; }\n\n@-webkit-keyframes fadeout {\n  0% {\n    opacity: 1; }\n  70% {\n    opacity: 0.7; }\n  100% {\n    opacity: 0; } }\n\n@-moz-keyframes fadeout {\n  0% {\n    opacity: 1; }\n  70% {\n    opacity: 0.7; }\n  100% {\n    opacity: 0; } }\n\n@-ms-keyframes fadeout {\n  /* line 55, stdin */\n  0% {\n    opacity: 1; }\n  /* line 58, stdin */\n  70% {\n    opacity: 0.7; }\n  /* line 61, stdin */\n  100% {\n    opacity: 0; } }\n\n@keyframes fadeout {\n  0% {\n    opacity: 1; }\n  70% {\n    opacity: 0.7; }\n  100% {\n    opacity: 0; } }");(function () {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = {
        props: {
          value: String
        },
        data: function data() {
          return {
            msg: this.value
          };
        },

        watch: {
          value: function value(val) {
            this.msg = val;
          },
          msg: function msg(val) {
            this.$emit('input', val);
          }
        },
        mounted: function mounted() {
          var _this = this;

          var swert = document.getElementById('component-swert');
          swert.addEventListener('webkitAnimationEnd', function () {
            return _this.msg = '';
          });
          swert.addEventListener('animationEnd', function () {
            return _this.msg = '';
          });
        }
      };
    })();
    if (module.exports.__esModule) module.exports = module.exports.default;
    var __vue__options__ = typeof module.exports === "function" ? module.exports.options : module.exports;
    if (__vue__options__.functional) {
      console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.");
    }
    __vue__options__.render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('p', { directives: [{ name: "show", rawName: "v-show", value: _vm.msg, expression: "msg" }], staticClass: "a-fadeout", attrs: { "id": "component-swert" }, domProps: { "textContent": _vm._s(_vm.msg) } });
    };
    __vue__options__.staticRenderFns = [];
    if (module.hot) {
      (function () {
        var hotAPI = require("vue-hot-reload-api");
        hotAPI.install(require("vue"), true);
        if (!hotAPI.compatible) return;
        module.hot.accept();
        module.hot.dispose(__vueify_style_dispose__);
        if (!module.hot.data) {
          hotAPI.createRecord("data-v-4aab3c05", __vue__options__);
        } else {
          hotAPI.rerender("data-v-4aab3c05", __vue__options__);
        }
      })();
    }
  }, { "vue": 127, "vue-hot-reload-api": 126, "vueify/lib/insert-css": 128 }], 134: [function (require, module, exports) {
    var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 5, stdin */\n#icp-record {\n  padding: 0.16rem 0;\n  width: 100%;\n  text-align: center;\n  font-size: 0.24rem;\n  color: #999; }");
    var __vue__options__ = typeof module.exports === "function" ? module.exports.options : module.exports;
    if (__vue__options__.functional) {
      console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.");
    }
    __vue__options__.render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { attrs: { "id": "icp-record" } }, [_vm._v("杭州兔狗科技有限公司 浙ICP备14016529号")]);
    };
    __vue__options__.staticRenderFns = [];
    if (module.hot) {
      (function () {
        var hotAPI = require("vue-hot-reload-api");
        hotAPI.install(require("vue"), true);
        if (!hotAPI.compatible) return;
        module.hot.accept();
        module.hot.dispose(__vueify_style_dispose__);
        if (!module.hot.data) {
          hotAPI.createRecord("data-v-418504be", __vue__options__);
        } else {
          hotAPI.rerender("data-v-418504be", __vue__options__);
        }
      })();
    }
  }, { "vue": 127, "vue-hot-reload-api": 126, "vueify/lib/insert-css": 128 }], 135: [function (require, module, exports) {
    var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 216, stdin */\n.widget-pop__container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  overflow-y: scroll;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6); }\n  /* line 226, stdin */\n  .widget-pop__container .i-cross__main {\n    position: absolute;\n    top: 0.3em;\n    right: 0.3em;\n    z-index: 1;\n    box-sizing: border-box;\n    width: 1.5em;\n    height: 1.5em;\n    font-size: 0.24rem;\n    color: #1b1d1d;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg); }\n    /* line 239, stdin */\n    .widget-pop__container .i-cross__main:before, .widget-pop__container .i-cross__main:after {\n      content: '';\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      box-shadow: inset 0 0 0 1em;\n      -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%); }\n    /* line 250, stdin */\n    .widget-pop__container .i-cross__main:before {\n      width: 1em;\n      height: 2px; }\n    /* line 254, stdin */\n    .widget-pop__container .i-cross__main:after {\n      width: 2px;\n      height: 1em; }\n\n/* line 260, stdin */\n.widget-pop__content {\n  /* default styles */\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background: #fff;\n  /* in-out animation */\n  transition: all 0.3s ease; }\n  /* line 270, stdin */\n  .widget-pop__content.v-enter, .widget-pop__content.v-leave-to {\n    transform: translateY(100%); }\n  /* line 274, stdin */\n  .widget-pop__content.v-enter-to, .widget-pop__content.v-leave {\n    transform: translateY(0); }");(function () {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _stringify = require('babel-runtime/core-js/json/stringify');

      var _stringify2 = _interopRequireDefault(_stringify);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
          value: function value(predicate) {
            if (this == null) {
              throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            var len = o.length >>> 0;

            if (typeof predicate !== 'function') {
              throw new TypeError('predicate must be a function');
            }

            var thisArg = arguments[1];

            var k = 0;

            while (k < len) {
              var kValue = o[k];
              if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
              }

              k++;
            }

            return undefined;
          }
        });
      }
      function getScrollTop() {
        return window.pageYOffset || window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      }
      function setScrollTop(scroll_top) {
        document.documentElement.scrollTop = document.body.scrollTop = scroll_top;
      }
      function isIOS() {
        return navigator.userAgent.toLowerCase().match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
      }
      exports.default = {
        props: {
          value: {
            type: [Boolean, String],
            default: false
          },
          zIndex: {
            type: [Number, String],
            default: 999
          },
          closeOnClick: {
            type: Boolean,
            default: false
          },
          contentList: {
            type: Array,
            default: function _default() {
              return [];
            }
          },
          isLockScroll: {
            type: Boolean,
            default: false
          },
          closeIconClass: {
            type: String,
            default: ''
          },
          isCloseIconShow: {
            type: Boolean,
            default: true
          },
          beforeHide: {
            type: Function
          },
          contentClass: {
            type: String,
            default: ''
          }
        },
        data: function data() {
          return {
            is_show: !!this.value,
            content_show: this.value,
            original_body_style: null
          };
        },

        watch: {
          value: function value(val) {
            val ? this.showPop(val) : this.hidePopContent();
          },
          content_show: function content_show(val) {
            this.$emit('input', val);
          }
        },
        methods: {
          showPop: function showPop(pop_name) {
            var _this = this;

            this.is_show = true;
            if (this.isLockScroll || isIOS()) {
              this.lockScroll();
            }
            var timer = setTimeout(function () {
              _this.content_show = pop_name;
              clearTimeout(timer);
            });
          },
          hidePop: function hidePop() {
            if (this.content_show) {
              return false;
            }
            if (this.isLockScroll || isIOS()) {
              this.releaseScroll();
            }
            this.is_show = false;
          },
          hidePopContent: function hidePopContent(content) {
            var _this2 = this;

            if (!this.content_show) {
              return;
            }
            if (this.contentList.length === 0) {
              this.$emit('hide');
            } else {
              var _content = content || this.contentList.find(function (item) {
                return item.name === _this2.content_show;
              });
              if (_content && _content.onHide) {
                _content.onHide();
              } else {
                this.$emit('hide');
              }
            }
            this.content_show = false;
          },
          handleHide: function handleHide() {
            var _this3 = this;

            if (this.contentList.length === 0) {
              if (this._events['before-hide']) {
                this.$emit('before-hide', this.hidePopContent);
              } else {
                this.hidePopContent();
              }
            } else {
              var content = this.contentList.find(function (item) {
                return item.name === _this3.content_show;
              });
              if (content && content.onBeforeHide) {
                content.onBeforeHide(this.hidePopContent, content);
              } else if (this._events['before-hide']) {
                this.$emit('before-hide', this.hidePopContent, content);
              } else {
                this.hidePopContent(content);
              }
            }
          },
          lockScroll: function lockScroll() {
            if (this.original_body_style) {
              return;
            }
            var scroll_top = getScrollTop();
            var body_style = document.body.style;
            var original_body_style = {
              position: body_style.position,
              top: body_style.top,
              width: body_style.width
            };
            this.original_body_style = JSON.parse((0, _stringify2.default)(original_body_style));
            body_style.position = 'fixed';
            body_style.top = '-' + scroll_top + 'px';
            body_style.width = '100%';
          },
          releaseScroll: function releaseScroll() {
            var body_style = document.body.style;
            var scroll_top = body_style.top.replace(/\D/g, '');
            for (var prop in this.original_body_style) {
              if (!this.original_body_style.hasOwnProperty(prop)) {
                continue;
              }
              body_style[prop] = this.original_body_style[prop];
            }
            this.original_body_style = null;
            setScrollTop(scroll_top);
          }
        },
        created: function created() {}
      };
    })();
    if (module.exports.__esModule) module.exports = module.exports.default;
    var __vue__options__ = typeof module.exports === "function" ? module.exports.options : module.exports;
    if (__vue__options__.functional) {
      console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.");
    }
    __vue__options__.render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.is_show, expression: "is_show" }], staticClass: "widget-pop__container", style: { 'z-index': _vm.zIndex }, on: { "click": function click($event) {
            if ($event.target !== $event.currentTarget) {
              return null;
            }_vm.closeOnClick && _vm.handleHide();
          } } }, [_vm.contentList.length > 0 ? _vm._l(_vm.contentList, function (content, index) {
        return _c('transition', { key: index, on: { "after-leave": _vm.hidePop } }, [_c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.content_show === content.name, expression: "content_show === content.name" }], staticClass: "widget-pop__content", class: content.class_name }, [_vm.isCloseIconShow ? _c('i', { staticClass: "i-cross__main", class: _vm.closeIconClass, on: { "click": _vm.handleHide } }) : _vm._e(), _vm._v(" "), _vm._t(content.name)], 2)]);
      }) : [_c('transition', { on: { "after-leave": _vm.hidePop } }, [_c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.content_show, expression: "content_show" }], staticClass: "widget-pop__content", class: _vm.contentClass }, [_vm.isCloseIconShow ? _c('i', { staticClass: "i-cross__main", class: _vm.closeIconClass, on: { "click": _vm.handleHide } }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])]], 2);
    };
    __vue__options__.staticRenderFns = [];
    if (module.hot) {
      (function () {
        var hotAPI = require("vue-hot-reload-api");
        hotAPI.install(require("vue"), true);
        if (!hotAPI.compatible) return;
        module.hot.accept();
        module.hot.dispose(__vueify_style_dispose__);
        if (!module.hot.data) {
          hotAPI.createRecord("data-v-59777fd4", __vue__options__);
        } else {
          hotAPI.rerender("data-v-59777fd4", __vue__options__);
        }
      })();
    }
  }, { "babel-runtime/core-js/json/stringify": 1, "vue": 127, "vue-hot-reload-api": 126, "vueify/lib/insert-css": 128 }], 136: [function (require, module, exports) {
    var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* line 156, stdin */\n#title-bar h1,\n#branch-list header h1, #title-bar .loc, #title-bar .widget-before,\n#title-bar .widget-after,\n#branch-list header .widget-before,\n#branch-list header .widget-after, #branch-list li.checked a {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n/* line 162, stdin */\n#title-bar h1,\n#branch-list header h1, #title-bar .loc {\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center; }\n\n/* line 181, stdin */\n#title-bar .i-back {\n  display: inline-block;\n  width: 0.88rem;\n  height: 0.88rem;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYBAMAAACDuy0HAAAAJ1BMVEUAAABmZmZoaGhmZmZoaGhnZ2doaGhsbGxmZmZmZmZmZmZmZmZmZmYchydiAAAADHRSTlMA7C7wM3o7FN5kXwVpR9yqAAAAY0lEQVRIx2MYBaNgFIyC4QSYFpCgWPEkCQbLHCwg3uAzJiQYfNhh1OBRg9ENPoMKDuBRvOMMCYrZbEhQzJB8Roj4PMJic1CBeNXOo0aPRKMLSDD6KAMJRgcwjIJRMApGweAGACPpSyN/KkMRAAAAAElFTkSuQmCC) no-repeat center center/0.88rem 0.88rem; }\n\n/* line 181, stdin */\n#title-bar .i-hamburger {\n  display: inline-block;\n  width: 0.88rem;\n  height: 0.88rem;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYAQMAAABLW6J3AAAABlBMVEUAAABmZmZ+SwYRAAAAAXRSTlMAQObYZgAAAB1JREFUOMtjGAV0A/z/////gJNNEhh12yBx23AHABctI90/93W1AAAAAElFTkSuQmCC) no-repeat center center/0.88rem 0.88rem; }\n\n/* line 181, stdin */\n#title-bar .i-loc {\n  display: inline-block;\n  width: 0.4rem;\n  height: 0.4rem;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAkCAMAAACpD3pbAAAAWlBMVEUAAABsbGxmZmZmZmZmZmZoaGhnZ2dnZ2dnZ2dnZ2dnZ2dnZ2dmZmZmZmZmZmZmZmZmZmZnZ2dpaWlwcHBvb29mZmZmZmZmZmZnZ2dnZ2dmZmZnZ2dmZmZmZmbQNQ0bAAAAHXRSTlMABeyM8WbWrR6mn/rjxZuVS0EjEQvAubSBfn1qMh1l504AAADoSURBVDjLfdFJFoMgEEXRDyhG7Jv0Yf/bTMKxKFHgTp9CAfDEpK66KPRVTQJH60taT77WsJYU6YMSTAz2ZBC+3mzEjXpvo/ptX5vg9l94qqJSqip4vgWA4mmFm4RPoQBBX+sLNhdNqwmM9O+v+k7/j+h5Dlb64Tu/jsc7dmitUyFQWadFQ0MyPk4DmcsSXW7xDs/caE/MuYPNwD19LXcAn/SlfvBjUk9i8Le08QdtFzijjRqxMbFqQFZ9rnqFN8tjlTN2piaszYTAO8xvHDz29YGTgeuAiJpqjRhRb1Ug0VOVr88gQykEvoBBO1VvPfUUAAAAAElFTkSuQmCC) no-repeat center center/0.2rem 0.24rem; }\n\n/* line 181, stdin */\n#title-bar .i-ask {\n  display: inline-block;\n  width: 0.88rem;\n  height: 0.88rem;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAUVBMVEUAAABnZ2d4eHhmZmZmZmZpaWlnZ2dmZmZoaGhmZmZnZ2dmZmZmZmZpaWlnZ2dnZ2dnZ2dnZ2dmZmZnZ2dmZmZmZmZmZmZycnJnZ2doaGhmZmZfirEVAAAAGnRSTlMAiAbm/CSwcjPwvqpcPtfPlPa4jy0eGQSeUYc/+PUAAAEgSURBVFjD7ZbhDoIwDIRlk7EhCoqi9v0f1IvGVANowi7+sd+/rcllWe+2rgzDMAzDMH6Ni9equkZHlt1ektxJly1Rtqzlhbpk6VZ7AbvQ92EnYF9xdAtorbv4WMRujWXB0m2Puj62HOUGMhv35o8Ntppc3VOC7vl97wzldMoUrtE1N/I0elhn+hd9i+PtiA7m+TmIdFP7nUjISgYOXE4WcOQyJxqzBwsiOTE5qK/GLjwsVXWFF5Fhujig5Au3NHJgriqyOID+u7BfJCzfhcWE/034YbeBazcNSMMNiEY6zD8jiDT32VT4Dz0gf00K9zNVuN+/wh1YFN6IdfeeOow3FLYCNBO0MVbRFJMHb0/2M/kqFNenZ/MMwzAMwzCMz9wAUwEfxLcKaSsAAAAASUVORK5CYII=) no-repeat center center/0.88rem 0.88rem; }\n\n/* line 181, stdin */\n#title-bar .i-times {\n  display: inline-block;\n  width: 0.88rem;\n  height: 0.88rem;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYBAMAAACDuy0HAAAAGFBMVEUAAABmZmZnZ2dqampnZ2dmZmZnZ2dmZmbEshW9AAAAB3RSTlMAnekdnNsqPlVRvwAAAJJJREFUSMft1DEOwjAQBVEjOACi4QAUHIWWLi3iBql8fagyRaQdF+7yp1o3T5FjbUsppVR33h2KvtdGt08NP1cOp/6o5VeHvv/nsktfN5jRaGCngZ12GHEMhgR2Gthp4AEaeIBegJ0G9pb+btNlvnn2bfg9+x/0tzHz1UFCO8zgMJPDjA4zT9hIvut8i6aU0vH6Afg6KhmstnG9AAAAAElFTkSuQmCC) no-repeat center center/0.88rem 0.88rem; }\n\n/* line 181, stdin */\n#title-bar .i-check-cyan {\n  display: inline-block;\n  width: 0.36rem;\n  height: 0.36rem;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAAWlBMVEUAAABE6ekOycQOysQQysQOzcYPysQW0tAOysQOysQOysQPy8QOy8QOycQPysQQzMcP0MkPycQPycQOycUQzMQPysQPysQOysQQy8MQysYOycMPysQPzcUOycOU+C4mAAAAHXRSTlMAA+TspCTBC/qwnmdX25QuIN+YbUHLv7ZAP9WFQvqmBNIAAAFUSURBVEjHndZLbsMwDARQOmwT2fL/77Rz/2sWCAQ4rihF4myyeogNmOSQlG4a14GN4ebe2o6SclSMS27j70dUNxDytI8YmhcEMtRB1G+I5N7LamdEw+IfWoNP+fFQ0SIhVfGPeSrgrsomEP85d5PKvt5Uz8mqeGObSs0qRYtK1Znqu379NJnq9nzNV64CZiKqMpX7Vjhb4UbU5Sugo0mhYGlUKLS0XuaiTFK403CZwqJMUWiIr7PrXFyByVyU50QFczJ+EHnOV47x+Z6eCykwDZBcXGGgFZKLK6w0QnRRhZEmyC6mMFEH2U0RhY6IZUcRxW5MPecpb6Uf8F1c4XArKOB6WTVu4QVcUUJMfa5Xz4XVci5z3wUVZnLZJBdSW/RQcUBxrzmLZlcdYas6+a2qYLSFos4YqypPu6aqbb2iGC6zooY2dX7p5eqIAr9iD+s4iRX7DxI7181MougIAAAAAElFTkSuQmCC) no-repeat center center/0.36rem 0.36rem; }\n\n/* line 189, stdin */\n#title-bar,\n#branch-list header {\n  position: relative;\n  width: 100%;\n  height: 0.96rem;\n  color: #444; }\n  /* line 195, stdin */\n  #title-bar h1,\n  #branch-list header h1 {\n    margin: 0;\n    height: 100%;\n    font-size: 0.34rem;\n    font-weight: normal; }\n    /* line 201, stdin */\n    #title-bar h1 img,\n    #branch-list header h1 img {\n      width: 2.5rem;\n      height: 0.6rem; }\n  /* line 206, stdin */\n  #title-bar .widget-before,\n  #title-bar .widget-after,\n  #branch-list header .widget-before,\n  #branch-list header .widget-after {\n    position: absolute;\n    top: 0;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    height: 0.96rem; }\n  /* line 216, stdin */\n  #title-bar .widget-before,\n  #branch-list header .widget-before {\n    left: 0;\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n    -ms-flex-pack: start;\n    justify-content: flex-start; }\n  /* line 223, stdin */\n  #title-bar .widget-after,\n  #branch-list header .widget-after {\n    right: 0;\n    -webkit-box-pack: end;\n    -webkit-justify-content: flex-end;\n    -ms-flex-pack: end;\n    justify-content: flex-end; }\n\n/* line 232, stdin */\n#title-bar .loc {\n  height: 100%;\n  padding-right: 0.32rem;\n  font-size: 0.28rem; }\n\n/* line 239, stdin */\n#branch-list {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 99;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  background: #f6f6f6;\n  font-size: 0.32rem;\n  color: #444; }\n  /* line 251, stdin */\n  #branch-list header,\n  #branch-list p,\n  #branch-list li {\n    background: white; }\n  /* line 256, stdin */\n  #branch-list li a,\n  #branch-list p {\n    padding: 0.36rem 0.32rem; }\n  /* line 260, stdin */\n  #branch-list li,\n  #branch-list p {\n    margin-top: 2px; }\n  /* line 264, stdin */\n  #branch-list a {\n    display: block; }\n  /* line 267, stdin */\n  #branch-list ul {\n    margin-top: 0.08rem; }\n  /* line 271, stdin */\n  #branch-list li.checked a {\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    color: #0ec9c3; }");(function () {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
          value: function value(predicate) {
            if (this == null) {
              throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            var len = o.length >>> 0;

            if (typeof predicate !== 'function') {
              throw new TypeError('predicate must be a function');
            }

            var thisArg = arguments[1];

            var k = 0;

            while (k < len) {
              var kValue = o[k];
              if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
              }

              k++;
            }

            return undefined;
          }
        });
      }
      exports.default = {
        props: {
          show: {
            type: String,
            default: ''
          },
          branchList: {
            type: Array
          },
          loc: {
            type: String,
            default: ''
          },
          locSelectable: {
            type: Boolean,
            default: false
          },
          hamburgerOpen: {
            type: Boolean,
            default: false
          }
        },
        data: function data() {
          return {
            show_branch_pop: false,
            branch_list: []
          };
        },

        computed: {
          currentBranch: function currentBranch() {
            var _this = this;

            var temp = this._branchList.find(function (item) {
              return item.spelling === _this.loc;
            });
            return !!temp ? temp : {};
          },
          _branchList: function _branchList() {
            var branch_list = this.branchList;
            return branch_list instanceof Array ? branch_list : this.branch_list;
          }
        },
        methods: {
          isShow: function isShow(name) {
            return this.show.split(',').indexOf(name) !== -1;
          },
          goBack: function goBack(e) {
            if (!!this._events['go-back']) {
              this.$emit('go-back');
              e.preventDefault();
            }
          },
          toggleHamburger: function toggleHamburger() {
            this.$emit('toggle-hamburger', this.hamburgerOpen);
          },
          toggleAsk: function toggleAsk() {
            this.$emit('toggle-ask');
          },
          selectBranch: function selectBranch(e, branch) {
            if (!!this._events['select-branch']) {
              this.$emit('select-branch', branch);
              e.preventDefault();
            }
          }
        },
        created: function created() {
          var _this2 = this;

          if (!this.branchList) {
            axios.get('//static.tugou.com/widget/data/branch.json').then(function (res) {
              return _this2.branch_list = res.data;
            });
          }
        }
      };
    })();
    if (module.exports.__esModule) module.exports = module.exports.default;
    var __vue__options__ = typeof module.exports === "function" ? module.exports.options : module.exports;
    if (__vue__options__.functional) {
      console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.");
    }
    __vue__options__.render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('header', { attrs: { "id": "title-bar" } }, [_c('div', { staticClass: "widget-before" }, [_vm.isShow('back') ? _c('a', { staticClass: "i-back", attrs: { "href": "javascript:history.go(-1);" }, on: { "click": _vm.goBack } }) : _vm._e()]), _vm._v(" "), _c('h1', [_vm._t("default", [_c('img', { staticClass: "logo", attrs: { "src": "//static.tugou.com/widget/m/img/logo.png", "alt": "兔狗家装网" } })])], 2), _vm._v(" "), _c('div', { staticClass: "widget-after" }, [_vm.isShow('loc') ? _c('a', { staticClass: "loc", on: { "click": function click($event) {
            _vm.locSelectable && (_vm.show_branch_pop = true);
          } } }, [_c('i', { staticClass: "i-loc" }), _vm._v(_vm._s(_vm.currentBranch.name) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.isShow('ask') ? _c('a', { staticClass: "i-ask", attrs: { "href": "javascript:;" }, on: { "click": _vm.toggleAsk } }) : _vm._e(), _vm._v(" "), _vm.isShow('hamburger') ? _c('a', { class: _vm.hamburgerOpen ? 'i-times' : 'i-hamburger', attrs: { "href": "javascript:;" }, on: { "click": _vm.toggleHamburger } }) : _vm._e()]), _vm._v(" "), _vm.isShow('loc') && _vm.locSelectable ? _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.show_branch_pop, expression: "show_branch_pop" }], attrs: { "id": "branch-list" } }, [_c('header', [_c('div', { staticClass: "widget-before" }, [_c('a', { staticClass: "i-times", attrs: { "href": "javascript:;" }, on: { "click": function click($event) {
            _vm.show_branch_pop = false;
          } } })]), _vm._v(" "), _c('h1', [_vm._v("城市列表")])]), _vm._v(" "), _c('p', [_vm._v("您当前所在的城市：" + _vm._s(_vm.currentBranch.name))]), _vm._v(" "), _c('ul', _vm._l(_vm._branchList, function (item, index) {
        return _c('li', { key: index, class: { checked: Number(item.id) === Number(_vm.currentBranch.id) } }, [_c('a', { attrs: { "href": !!item.link ? item.link : 'javascript:;' }, on: { "click": function click($event) {
              _vm.selectBranch($event, item);
            } } }, [_vm._v("\n          " + _vm._s(item.name)), Number(item.id) === Number(_vm.currentBranch.id) ? _c('i', { staticClass: "i-check-cyan" }) : _vm._e()])]);
      }))]) : _vm._e()]);
    };
    __vue__options__.staticRenderFns = [];
    if (module.hot) {
      (function () {
        var hotAPI = require("vue-hot-reload-api");
        hotAPI.install(require("vue"), true);
        if (!hotAPI.compatible) return;
        module.hot.accept();
        module.hot.dispose(__vueify_style_dispose__);
        if (!module.hot.data) {
          hotAPI.createRecord("data-v-0e09e546", __vue__options__);
        } else {
          hotAPI.rerender("data-v-0e09e546", __vue__options__);
        }
      })();
    }
  }, { "vue": 127, "vue-hot-reload-api": 126, "vueify/lib/insert-css": 128 }] }, {}, [129]);